import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class InAppPurchaseData_Filter {
  get descriptor() {
    return InAppPurchaseData_Filter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._haveItems = [];
    this._haveCards = [];
    this._hasStartVersion = false;
    this._startVersion = null;
    this._hasEventControlled = false;
    this._eventControlled = null;
    this._hasTriggered = false;
    this._triggered = null;
  }
  isEmpty() {
    if (this._haveItems.length > 0) return false;
    if (this._haveCards.length > 0) return false;
    if (this._hasStartVersion) return false;
    if (this._hasEventControlled) return false;
    if (this._hasTriggered) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_Filter) {
      return value;
    }
    return InAppPurchaseData_Filter.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_Filter();
    result._haveItems = JsonToList(json.haveItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._haveCards = JsonToList(json.haveCards, JsonToString);
    if (json.startVersion != null) {
      result._hasStartVersion = true;
      result._startVersion = JsonToString.fromJson(json.startVersion);
    }
    if (json.eventControlled != null) {
      result._hasEventControlled = true;
      result._eventControlled = JsonToBoolean.fromJson(json.eventControlled);
    }
    if (json.triggered != null) {
      result._hasTriggered = true;
      result._triggered = JsonToBoolean.fromJson(json.triggered);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._haveItems.length > 0) {
      result.haveItems = ArrayToJson(this._haveItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._haveCards.length > 0) {
      result.haveCards = ArrayToJson(this._haveCards, JsonToString);
    }
    if (this._hasStartVersion) {
      result.startVersion = JsonToString.toJson(this._startVersion);
    }
    if (this._hasEventControlled) {
      result.eventControlled = JsonToBoolean.toJson(this._eventControlled);
    }
    if (this._hasTriggered) {
      result.triggered = JsonToBoolean.toJson(this._triggered);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get haveItems() {
    return this._haveItems;
  }
  addHaveItems(path, value) {
    return {type: 'ADD', path: path.concat(['haveItems']), value: value.toJson()};
  }
  setHaveItems(path, value) {
    return {type: 'SET', path: path.concat(['haveItems']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setHaveItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['haveItems', key]), value: value.toJson()};
  }
  deleteHaveItems(path) {
    return {type: 'DELETE', path: path.concat(['haveItems'])};
  }
  deleteHaveItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['haveItems', key])};
  }
  /**
   * @returns {string[]}
   */
  get haveCards() {
    return this._haveCards;
  }
  addHaveCards(path, value) {
    return {type: 'ADD', path: path.concat(['haveCards']), value};
  }
  setHaveCards(path, value) {
    return {type: 'SET', path: path.concat(['haveCards']), value: ArrayToJson(value, JsonToString)};
  }
  setHaveCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['haveCards', key]), value};
  }
  deleteHaveCards(path) {
    return {type: 'DELETE', path: path.concat(['haveCards'])};
  }
  deleteHaveCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['haveCards', key])};
  }
  /**
   * @returns {string}
   */
  get startVersion() {
    return this._hasStartVersion ? this._startVersion : JsonToString.default;
  }
  get hasStartVersion() {
    return this._hasStartVersion;
  }
  setStartVersion(path, value) {
    return {type: 'SET', path: path.concat(['startVersion']), value};
  }
  deleteStartVersion(path) {
    return {type: 'DELETE', path: path.concat(['startVersion'])};
  }
  /**
   * @returns {boolean}
   */
  get eventControlled() {
    return this._hasEventControlled ? this._eventControlled : JsonToBoolean.default;
  }
  get hasEventControlled() {
    return this._hasEventControlled;
  }
  setEventControlled(path, value) {
    return {type: 'SET', path: path.concat(['eventControlled']), value};
  }
  deleteEventControlled(path) {
    return {type: 'DELETE', path: path.concat(['eventControlled'])};
  }
  /**
   * @returns {boolean}
   */
  get triggered() {
    return this._hasTriggered ? this._triggered : JsonToBoolean.default;
  }
  get hasTriggered() {
    return this._hasTriggered;
  }
  setTriggered(path, value) {
    return {type: 'SET', path: path.concat(['triggered']), value};
  }
  deleteTriggered(path) {
    return {type: 'DELETE', path: path.concat(['triggered'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "haveItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveItems = [];        for (let i of value) {
                copy._haveItems.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveItems = copy._haveItems.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._haveItems.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._haveItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveItems = copy._haveItems.slice();
              copy._haveItems[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveItems = copy._haveItems.slice(0, path[1]).concat(copy._haveItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._haveItems.length) {
            return this;
          }
          const oldValue = this._haveItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_Filter(this);
          copy._haveItems = copy._haveItems.slice();
          copy._haveItems[key] = newValue;
          return copy;
        }
      }
      case "haveCards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveCards = [];        for (let i of value) {
                copy._haveCards.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveCards = copy._haveCards.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._haveCards.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveCards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._haveCards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveCards = copy._haveCards.slice();
              copy._haveCards[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._haveCards = copy._haveCards.slice(0, path[1]).concat(copy._haveCards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._haveCards.length) {
            return this;
          }
          const oldValue = this._haveCards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_Filter(this);
          copy._haveCards = copy._haveCards.slice();
          copy._haveCards[key] = newValue;
          return copy;
        }
      }
      case "startVersion": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._hasStartVersion = true;
              copy._startVersion = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartVersion) {
                return this;
              }
              const copy = new InAppPurchaseData_Filter(this);
              copy._hasStartVersion = false;
              copy._startVersion = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventControlled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._hasEventControlled = true;
              copy._eventControlled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventControlled) {
                return this;
              }
              const copy = new InAppPurchaseData_Filter(this);
              copy._hasEventControlled = false;
              copy._eventControlled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "triggered": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Filter(this);
              copy._hasTriggered = true;
              copy._triggered = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTriggered) {
                return this;
              }
              const copy = new InAppPurchaseData_Filter(this);
              copy._hasTriggered = false;
              copy._triggered = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_Filter} other
   * @returns {InAppPurchaseData_Filter}
   */
  merge(other) {
    const copy = new InAppPurchaseData_Filter(this);
    copy._haveItems = this._haveItems.concat(other._haveItems);
    copy._haveCards = this._haveCards.concat(other._haveCards);
    if (other._hasStartVersion) {
      copy._hasStartVersion = true;
      copy._startVersion = other._startVersion;
    }
    if (other._hasEventControlled) {
      copy._hasEventControlled = true;
      copy._eventControlled = other._eventControlled;
    }
    if (other._hasTriggered) {
      copy._hasTriggered = true;
      copy._triggered = other._triggered;
    }
    return copy;
  }
}
InAppPurchaseData_Filter.default = new InAppPurchaseData_Filter();
class InAppPurchaseData_Filter_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_Filter(value);
  }
  build() {
    return new InAppPurchaseData_Filter(this._value);
  }
  addAllHaveItems(values) {
    this._value._haveItems = this._value._haveItems.concat(values);
    return this;
  }
  addHaveItems(value) {
    this._value._haveItems = this._value._haveItems.concat([value]);
    return this;
  }
  setHaveItems(index, value) {
    this._value._haveItems = this._value._haveItems.concat();
    this._value._haveItems[index] = value;
    return this;
  }
  clearHaveItems() {
    this._value._haveItems = [];
    return this;
  }
  addAllHaveCards(values) {
    this._value._haveCards = this._value._haveCards.concat(values);
    return this;
  }
  addHaveCards(value) {
    this._value._haveCards = this._value._haveCards.concat([value]);
    return this;
  }
  setHaveCards(index, value) {
    this._value._haveCards = this._value._haveCards.concat();
    this._value._haveCards[index] = value;
    return this;
  }
  clearHaveCards() {
    this._value._haveCards = [];
    return this;
  }
  setStartVersion(value) {
    this._value._hasStartVersion = true;
    this._value._startVersion = value;
    return this;
  }
  deleteStartVersion() {
    this._value._hasStartVersion = false;
    this._value._startVersion = null;
    return this;
  }
  setEventControlled(value) {
    this._value._hasEventControlled = true;
    this._value._eventControlled = value;
    return this;
  }
  deleteEventControlled() {
    this._value._hasEventControlled = false;
    this._value._eventControlled = null;
    return this;
  }
  setTriggered(value) {
    this._value._hasTriggered = true;
    this._value._triggered = value;
    return this;
  }
  deleteTriggered() {
    this._value._hasTriggered = false;
    this._value._triggered = null;
    return this;
  }
}
InAppPurchaseData_Filter.Builder = InAppPurchaseData_Filter_Builder;
class InAppPurchaseData_Filter_WithParent {
  /**
   * @param {InAppPurchaseData_Filter} value
   * @param {InAppPurchaseData_Filter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_Filter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfHaveItems() {
    if (!this._selfHaveItems) {
      this._selfHaveItems = [];
      for (let i of this._value.haveItems) {
        this._selfHaveItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfHaveItems;
  }
  get inherentHaveItems() {
    if (!this._inherentHaveItems) {
      this._inherentHaveItems = this._parent ? this._parent.haveItems : [];
    }
    return this._inherentHaveItems;
  }
  get haveItems() {
    if (!this._allHaveItems) {
      this._allHaveItems = this._parent ? this._parent.haveItems.concat(this.selfHaveItems) : this.selfHaveItems;
    }
    return this._allHaveItems;
  }
  get selfHaveCards() {
    return this._value.haveCards;
  }
  get inherentHaveCards() {
    if (!this._inherentHaveCards) {
      this._inherentHaveCards = this._parent ? this._parent.haveCards : [];
    }
    return this._inherentHaveCards;
  }
  get haveCards() {
    if (!this._allHaveCards) {
      this._allHaveCards = this._parent ? this._parent.haveCards.concat(this.selfHaveCards) : this.selfHaveCards;
    }
    return this._allHaveCards;
  }
  get hasStartVersion() {
    if (this._cachedHasStartVersion === undefined) {
      if (this._value.hasStartVersion) {
        this._cachedHasStartVersion = true;
      } else {
        this._cachedHasStartVersion = this._parent ? this._parent.hasStartVersion : false;
      }
    }
    return this._cachedHasStartVersion;
  }
  get startVersion() {
    if (this._cachedStartVersion === undefined) {
      if (this._value.hasStartVersion) {
        this._cachedStartVersion = this._value.startVersion;
      } else {
        this._cachedStartVersion = this._parent ? this._parent.startVersion : this._value.startVersion;
      }
    }
    return this._cachedStartVersion;
  }
  get hasEventControlled() {
    if (this._cachedHasEventControlled === undefined) {
      if (this._value.hasEventControlled) {
        this._cachedHasEventControlled = true;
      } else {
        this._cachedHasEventControlled = this._parent ? this._parent.hasEventControlled : false;
      }
    }
    return this._cachedHasEventControlled;
  }
  get eventControlled() {
    if (this._cachedEventControlled === undefined) {
      if (this._value.hasEventControlled) {
        this._cachedEventControlled = this._value.eventControlled;
      } else {
        this._cachedEventControlled = this._parent ? this._parent.eventControlled : this._value.eventControlled;
      }
    }
    return this._cachedEventControlled;
  }
  get hasTriggered() {
    if (this._cachedHasTriggered === undefined) {
      if (this._value.hasTriggered) {
        this._cachedHasTriggered = true;
      } else {
        this._cachedHasTriggered = this._parent ? this._parent.hasTriggered : false;
      }
    }
    return this._cachedHasTriggered;
  }
  get triggered() {
    if (this._cachedTriggered === undefined) {
      if (this._value.hasTriggered) {
        this._cachedTriggered = this._value.triggered;
      } else {
        this._cachedTriggered = this._parent ? this._parent.triggered : this._value.triggered;
      }
    }
    return this._cachedTriggered;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_Filter_WithParent(current, parent);
    if (this._selfHaveItems) {
      if (this._value.haveItems === current.haveItems) {
        result._selfHaveItems = this._selfHaveItems;
      } else {
        result._selfHaveItems = [];
        for (let i = 0; i < current.haveItems.length; i++) {
          const oldValue = this._value.haveItems[i];
          if (oldValue) {
            const oldCache = this._selfHaveItems[i];
            if (oldValue === current.haveItems[i]) {
              result._selfHaveItems[i] = oldCache;
            } else {
              result._selfHaveItems[i] = oldCache.update(current.haveItems[i], null);
            }
          } else {
            result._selfHaveItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.haveItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_Filter_WithParent.default = new InAppPurchaseData_Filter_WithParent(InAppPurchaseData_Filter.default, null);
InAppPurchaseData_Filter.WithParent = InAppPurchaseData_Filter_WithParent;
class InAppPurchaseData_Filter_Descriptor {
  get haveItems() {
    if (!this._haveItems) {
      this._haveItems = {
        name: "haveItems",
        Name: "HaveItems",
        number: 1,
        protoType: 11,
        protoName: "have_items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._haveItems;
  }
  get haveCards() {
    if (!this._haveCards) {
      this._haveCards = {
        name: "haveCards",
        Name: "HaveCards",
        number: 2,
        protoType: 9,
        protoName: "have_cards",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._haveCards;
  }
  get startVersion() {
    if (!this._startVersion) {
      this._startVersion = {
        name: "startVersion",
        Name: "StartVersion",
        number: 3,
        protoType: 9,
        protoName: "start_version",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startVersion;
  }
  get eventControlled() {
    if (!this._eventControlled) {
      this._eventControlled = {
        name: "eventControlled",
        Name: "EventControlled",
        number: 4,
        protoType: 8,
        protoName: "event_controlled",
        type: JsonToBoolean,
        options: {
          comments: "This product is part of event bundles, will not enable itself but enabled by events",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventControlled;
  }
  get triggered() {
    if (!this._triggered) {
      this._triggered = {
        name: "triggered",
        Name: "Triggered",
        number: 5,
        protoType: 8,
        protoName: "triggered",
        type: JsonToBoolean,
        options: {
          comments: "Triggered product will not enable themselves, but enabled by purchasing other products",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggered;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.haveItems,
        this.haveCards,
        this.startVersion,
        this.eventControlled,
        this.triggered,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStartVersion",
        Name: "DummyOneofForStartVersion",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventControlled",
        Name: "DummyOneofForEventControlled",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTriggered",
        Name: "DummyOneofForTriggered",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_Filter.descriptor = new InAppPurchaseData_Filter_Descriptor();
class InAppPurchaseData_IapTrigger {
  get descriptor() {
    return InAppPurchaseData_IapTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
  }
  isEmpty() {
    if (this._hasProductId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_IapTrigger) {
      return value;
    }
    return InAppPurchaseData_IapTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_IapTrigger();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_IapTrigger(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_IapTrigger(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_IapTrigger} other
   * @returns {InAppPurchaseData_IapTrigger}
   */
  merge(other) {
    const copy = new InAppPurchaseData_IapTrigger(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    return copy;
  }
}
InAppPurchaseData_IapTrigger.default = new InAppPurchaseData_IapTrigger();
class InAppPurchaseData_IapTrigger_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_IapTrigger(value);
  }
  build() {
    return new InAppPurchaseData_IapTrigger(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
}
InAppPurchaseData_IapTrigger.Builder = InAppPurchaseData_IapTrigger_Builder;
class InAppPurchaseData_IapTrigger_WithParent {
  /**
   * @param {InAppPurchaseData_IapTrigger} value
   * @param {InAppPurchaseData_IapTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_IapTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_IapTrigger_WithParent(current, parent);
    return result;
  }
}
InAppPurchaseData_IapTrigger_WithParent.default = new InAppPurchaseData_IapTrigger_WithParent(InAppPurchaseData_IapTrigger.default, null);
InAppPurchaseData_IapTrigger.WithParent = InAppPurchaseData_IapTrigger_WithParent;
class InAppPurchaseData_IapTrigger_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_IapTrigger.descriptor = new InAppPurchaseData_IapTrigger_Descriptor();
class InAppPurchaseData_Tab {
  get descriptor() {
    return InAppPurchaseData_Tab.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._productOrders = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDisplayName) return false;
    if (this._productOrders.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_Tab) {
      return value;
    }
    return InAppPurchaseData_Tab.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_Tab();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    result._productOrders = JsonToList(json.productOrders, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._productOrders.length > 0) {
      result.productOrders = ArrayToJson(this._productOrders, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string[]}
   */
  get productOrders() {
    return this._productOrders;
  }
  addProductOrders(path, value) {
    return {type: 'ADD', path: path.concat(['productOrders']), value};
  }
  setProductOrders(path, value) {
    return {type: 'SET', path: path.concat(['productOrders']), value: ArrayToJson(value, JsonToString)};
  }
  setProductOrdersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['productOrders', key]), value};
  }
  deleteProductOrders(path) {
    return {type: 'DELETE', path: path.concat(['productOrders'])};
  }
  deleteProductOrdersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['productOrders', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Tab(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new InAppPurchaseData_Tab(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Tab(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InAppPurchaseData_Tab(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "productOrders": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Tab(this);
              copy._productOrders = [];        for (let i of value) {
                copy._productOrders.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_Tab(this);
              copy._productOrders = copy._productOrders.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._productOrders.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_Tab(this);
              copy._productOrders = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._productOrders.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Tab(this);
              copy._productOrders = copy._productOrders.slice();
              copy._productOrders[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_Tab(this);
              copy._productOrders = copy._productOrders.slice(0, path[1]).concat(copy._productOrders.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._productOrders.length) {
            return this;
          }
          const oldValue = this._productOrders[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_Tab(this);
          copy._productOrders = copy._productOrders.slice();
          copy._productOrders[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_Tab} other
   * @returns {InAppPurchaseData_Tab}
   */
  merge(other) {
    const copy = new InAppPurchaseData_Tab(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    copy._productOrders = this._productOrders.concat(other._productOrders);
    return copy;
  }
}
InAppPurchaseData_Tab.default = new InAppPurchaseData_Tab();
class InAppPurchaseData_Tab_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_Tab(value);
  }
  build() {
    return new InAppPurchaseData_Tab(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  addAllProductOrders(values) {
    this._value._productOrders = this._value._productOrders.concat(values);
    return this;
  }
  addProductOrders(value) {
    this._value._productOrders = this._value._productOrders.concat([value]);
    return this;
  }
  setProductOrders(index, value) {
    this._value._productOrders = this._value._productOrders.concat();
    this._value._productOrders[index] = value;
    return this;
  }
  clearProductOrders() {
    this._value._productOrders = [];
    return this;
  }
}
InAppPurchaseData_Tab.Builder = InAppPurchaseData_Tab_Builder;
class InAppPurchaseData_Tab_WithParent {
  /**
   * @param {InAppPurchaseData_Tab} value
   * @param {InAppPurchaseData_Tab_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_Tab.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get selfProductOrders() {
    return this._value.productOrders;
  }
  get inherentProductOrders() {
    if (!this._inherentProductOrders) {
      this._inherentProductOrders = this._parent ? this._parent.productOrders : [];
    }
    return this._inherentProductOrders;
  }
  get productOrders() {
    if (!this._allProductOrders) {
      this._allProductOrders = this._parent ? this._parent.productOrders.concat(this.selfProductOrders) : this.selfProductOrders;
    }
    return this._allProductOrders;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_Tab_WithParent(current, parent);
    return result;
  }
}
InAppPurchaseData_Tab_WithParent.default = new InAppPurchaseData_Tab_WithParent(InAppPurchaseData_Tab.default, null);
InAppPurchaseData_Tab.WithParent = InAppPurchaseData_Tab_WithParent;
class InAppPurchaseData_Tab_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get productOrders() {
    if (!this._productOrders) {
      this._productOrders = {
        name: "productOrders",
        Name: "ProductOrders",
        number: 3,
        protoType: 9,
        protoName: "product_orders",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "This defines order of all items in the tab",
          valueDropdown: "ShopProductIdList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productOrders;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.displayName,
        this.productOrders,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_Tab.descriptor = new InAppPurchaseData_Tab_Descriptor();
class InAppPurchaseData_Subscription {
  get descriptor() {
    return InAppPurchaseData_Subscription.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
    this._hasKey = false;
    this._key = null;
    this._hasPrice = false;
    this._price = null;
    this._hasDuration = false;
    this._duration = null;
    this._hasPersistent = false;
    this._persistent = null;
    this._items = [];
    this._hasShowPip = false;
    this._showPip = null;
    this._postPurchaseTriggers = [];
    this._hasAsset = false;
    this._asset = null;
    this._hasTabKey = false;
    this._tabKey = null;
    this._hasBannerAsset = false;
    this._bannerAsset = null;
  }
  isEmpty() {
    if (this._hasProductId) return false;
    if (this._hasKey) return false;
    if (this._hasPrice) return false;
    if (this._hasDuration) return false;
    if (this._hasPersistent) return false;
    if (this._items.length > 0) return false;
    if (this._hasShowPip) return false;
    if (this._postPurchaseTriggers.length > 0) return false;
    if (this._hasAsset) return false;
    if (this._hasTabKey) return false;
    if (this._hasBannerAsset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_Subscription) {
      return value;
    }
    return InAppPurchaseData_Subscription.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_Subscription();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    if (json.persistent != null) {
      result._hasPersistent = true;
      result._persistent = JsonToBoolean.fromJson(json.persistent);
    }
    result._items = JsonToList(json.items, InAppPurchaseData_BundleItem);
    if (json.showPip != null) {
      result._hasShowPip = true;
      result._showPip = JsonToBoolean.fromJson(json.showPip);
    }
    result._postPurchaseTriggers = JsonToList(json.postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    if (json.asset != null) {
      result._hasAsset = true;
      result._asset = JsonToString.fromJson(json.asset);
    }
    if (json.tabKey != null) {
      result._hasTabKey = true;
      result._tabKey = JsonToString.fromJson(json.tabKey);
    }
    if (json.bannerAsset != null) {
      result._hasBannerAsset = true;
      result._bannerAsset = JsonToString.fromJson(json.bannerAsset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    if (this._hasPersistent) {
      result.persistent = JsonToBoolean.toJson(this._persistent);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InAppPurchaseData_BundleItem);
    }
    if (this._hasShowPip) {
      result.showPip = JsonToBoolean.toJson(this._showPip);
    }
    if (this._postPurchaseTriggers.length > 0) {
      result.postPurchaseTriggers = ArrayToJson(this._postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    }
    if (this._hasAsset) {
      result.asset = JsonToString.toJson(this._asset);
    }
    if (this._hasTabKey) {
      result.tabKey = JsonToString.toJson(this._tabKey);
    }
    if (this._hasBannerAsset) {
      result.bannerAsset = JsonToString.toJson(this._bannerAsset);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {boolean}
   */
  get persistent() {
    return this._hasPersistent ? this._persistent : JsonToBoolean.default;
  }
  get hasPersistent() {
    return this._hasPersistent;
  }
  setPersistent(path, value) {
    return {type: 'SET', path: path.concat(['persistent']), value};
  }
  deletePersistent(path) {
    return {type: 'DELETE', path: path.concat(['persistent'])};
  }
  /**
   * @returns {InAppPurchaseData_BundleItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InAppPurchaseData_BundleItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {boolean}
   */
  get showPip() {
    return this._hasShowPip ? this._showPip : JsonToBoolean.default;
  }
  get hasShowPip() {
    return this._hasShowPip;
  }
  setShowPip(path, value) {
    return {type: 'SET', path: path.concat(['showPip']), value};
  }
  deleteShowPip(path) {
    return {type: 'DELETE', path: path.concat(['showPip'])};
  }
  /**
   * @returns {InAppPurchaseData_IapTrigger[]}
   */
  get postPurchaseTriggers() {
    return this._postPurchaseTriggers;
  }
  addPostPurchaseTriggers(path, value) {
    return {type: 'ADD', path: path.concat(['postPurchaseTriggers']), value: value.toJson()};
  }
  setPostPurchaseTriggers(path, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers']), value: ArrayToJson(value, InAppPurchaseData_IapTrigger)};
  }
  setPostPurchaseTriggersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers', key]), value: value.toJson()};
  }
  deletePostPurchaseTriggers(path) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers'])};
  }
  deletePostPurchaseTriggersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers', key])};
  }
  /**
   * @returns {string}
   */
  get asset() {
    return this._hasAsset ? this._asset : JsonToString.default;
  }
  get hasAsset() {
    return this._hasAsset;
  }
  setAsset(path, value) {
    return {type: 'SET', path: path.concat(['asset']), value};
  }
  deleteAsset(path) {
    return {type: 'DELETE', path: path.concat(['asset'])};
  }
  /**
   * @returns {string}
   */
  get tabKey() {
    return this._hasTabKey ? this._tabKey : JsonToString.default;
  }
  get hasTabKey() {
    return this._hasTabKey;
  }
  setTabKey(path, value) {
    return {type: 'SET', path: path.concat(['tabKey']), value};
  }
  deleteTabKey(path) {
    return {type: 'DELETE', path: path.concat(['tabKey'])};
  }
  /**
   * @returns {string}
   */
  get bannerAsset() {
    return this._hasBannerAsset ? this._bannerAsset : JsonToString.default;
  }
  get hasBannerAsset() {
    return this._hasBannerAsset;
  }
  setBannerAsset(path, value) {
    return {type: 'SET', path: path.concat(['bannerAsset']), value};
  }
  deleteBannerAsset(path) {
    return {type: 'DELETE', path: path.concat(['bannerAsset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "persistent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasPersistent = true;
              copy._persistent = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPersistent) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasPersistent = false;
              copy._persistent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InAppPurchaseData_BundleItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._items = copy._items.concat([InAppPurchaseData_BundleItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InAppPurchaseData_BundleItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_Subscription(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "showPip": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasShowPip = true;
              copy._showPip = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowPip) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasShowPip = false;
              copy._showPip = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "postPurchaseTriggers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._postPurchaseTriggers = [];        for (let i of value) {
                copy._postPurchaseTriggers.push(InAppPurchaseData_IapTrigger.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.concat([InAppPurchaseData_IapTrigger.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._postPurchaseTriggers.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._postPurchaseTriggers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
              copy._postPurchaseTriggers[path[1]] = InAppPurchaseData_IapTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice(0, path[1]).concat(copy._postPurchaseTriggers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          const oldValue = this._postPurchaseTriggers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_Subscription(this);
          copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
          copy._postPurchaseTriggers[key] = newValue;
          return copy;
        }
      }
      case "asset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasAsset = true;
              copy._asset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasAsset = false;
              copy._asset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tabKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasTabKey = true;
              copy._tabKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTabKey) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasTabKey = false;
              copy._tabKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bannerAsset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasBannerAsset = true;
              copy._bannerAsset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBannerAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_Subscription(this);
              copy._hasBannerAsset = false;
              copy._bannerAsset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_Subscription} other
   * @returns {InAppPurchaseData_Subscription}
   */
  merge(other) {
    const copy = new InAppPurchaseData_Subscription(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasPersistent) {
      copy._hasPersistent = true;
      copy._persistent = other._persistent;
    }
    copy._items = this._items.concat(other._items);
    if (other._hasShowPip) {
      copy._hasShowPip = true;
      copy._showPip = other._showPip;
    }
    copy._postPurchaseTriggers = this._postPurchaseTriggers.concat(other._postPurchaseTriggers);
    if (other._hasAsset) {
      copy._hasAsset = true;
      copy._asset = other._asset;
    }
    if (other._hasTabKey) {
      copy._hasTabKey = true;
      copy._tabKey = other._tabKey;
    }
    if (other._hasBannerAsset) {
      copy._hasBannerAsset = true;
      copy._bannerAsset = other._bannerAsset;
    }
    return copy;
  }
}
InAppPurchaseData_Subscription.default = new InAppPurchaseData_Subscription();
class InAppPurchaseData_Subscription_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_Subscription(value);
  }
  build() {
    return new InAppPurchaseData_Subscription(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setPersistent(value) {
    this._value._hasPersistent = true;
    this._value._persistent = value;
    return this;
  }
  deletePersistent() {
    this._value._hasPersistent = false;
    this._value._persistent = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  setShowPip(value) {
    this._value._hasShowPip = true;
    this._value._showPip = value;
    return this;
  }
  deleteShowPip() {
    this._value._hasShowPip = false;
    this._value._showPip = null;
    return this;
  }
  addAllPostPurchaseTriggers(values) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat(values);
    return this;
  }
  addPostPurchaseTriggers(value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat([value]);
    return this;
  }
  setPostPurchaseTriggers(index, value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat();
    this._value._postPurchaseTriggers[index] = value;
    return this;
  }
  clearPostPurchaseTriggers() {
    this._value._postPurchaseTriggers = [];
    return this;
  }
  setAsset(value) {
    this._value._hasAsset = true;
    this._value._asset = value;
    return this;
  }
  deleteAsset() {
    this._value._hasAsset = false;
    this._value._asset = null;
    return this;
  }
  setTabKey(value) {
    this._value._hasTabKey = true;
    this._value._tabKey = value;
    return this;
  }
  deleteTabKey() {
    this._value._hasTabKey = false;
    this._value._tabKey = null;
    return this;
  }
  setBannerAsset(value) {
    this._value._hasBannerAsset = true;
    this._value._bannerAsset = value;
    return this;
  }
  deleteBannerAsset() {
    this._value._hasBannerAsset = false;
    this._value._bannerAsset = null;
    return this;
  }
}
InAppPurchaseData_Subscription.Builder = InAppPurchaseData_Subscription_Builder;
class InAppPurchaseData_Subscription_WithParent {
  /**
   * @param {InAppPurchaseData_Subscription} value
   * @param {InAppPurchaseData_Subscription_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_Subscription.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasPersistent() {
    if (this._cachedHasPersistent === undefined) {
      if (this._value.hasPersistent) {
        this._cachedHasPersistent = true;
      } else {
        this._cachedHasPersistent = this._parent ? this._parent.hasPersistent : false;
      }
    }
    return this._cachedHasPersistent;
  }
  get persistent() {
    if (this._cachedPersistent === undefined) {
      if (this._value.hasPersistent) {
        this._cachedPersistent = this._value.persistent;
      } else {
        this._cachedPersistent = this._parent ? this._parent.persistent : this._value.persistent;
      }
    }
    return this._cachedPersistent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InAppPurchaseData_BundleItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get hasShowPip() {
    if (this._cachedHasShowPip === undefined) {
      if (this._value.hasShowPip) {
        this._cachedHasShowPip = true;
      } else {
        this._cachedHasShowPip = this._parent ? this._parent.hasShowPip : false;
      }
    }
    return this._cachedHasShowPip;
  }
  get showPip() {
    if (this._cachedShowPip === undefined) {
      if (this._value.hasShowPip) {
        this._cachedShowPip = this._value.showPip;
      } else {
        this._cachedShowPip = this._parent ? this._parent.showPip : this._value.showPip;
      }
    }
    return this._cachedShowPip;
  }
  get selfPostPurchaseTriggers() {
    if (!this._selfPostPurchaseTriggers) {
      this._selfPostPurchaseTriggers = [];
      for (let i of this._value.postPurchaseTriggers) {
        this._selfPostPurchaseTriggers.push(new InAppPurchaseData_IapTrigger.WithParent(i, null));
      }
    }
    return this._selfPostPurchaseTriggers;
  }
  get inherentPostPurchaseTriggers() {
    if (!this._inherentPostPurchaseTriggers) {
      this._inherentPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers : [];
    }
    return this._inherentPostPurchaseTriggers;
  }
  get postPurchaseTriggers() {
    if (!this._allPostPurchaseTriggers) {
      this._allPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers.concat(this.selfPostPurchaseTriggers) : this.selfPostPurchaseTriggers;
    }
    return this._allPostPurchaseTriggers;
  }
  get hasAsset() {
    if (this._cachedHasAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedHasAsset = true;
      } else {
        this._cachedHasAsset = this._parent ? this._parent.hasAsset : false;
      }
    }
    return this._cachedHasAsset;
  }
  get asset() {
    if (this._cachedAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedAsset = this._value.asset;
      } else {
        this._cachedAsset = this._parent ? this._parent.asset : this._value.asset;
      }
    }
    return this._cachedAsset;
  }
  get hasTabKey() {
    if (this._cachedHasTabKey === undefined) {
      if (this._value.hasTabKey) {
        this._cachedHasTabKey = true;
      } else {
        this._cachedHasTabKey = this._parent ? this._parent.hasTabKey : false;
      }
    }
    return this._cachedHasTabKey;
  }
  get tabKey() {
    if (this._cachedTabKey === undefined) {
      if (this._value.hasTabKey) {
        this._cachedTabKey = this._value.tabKey;
      } else {
        this._cachedTabKey = this._parent ? this._parent.tabKey : this._value.tabKey;
      }
    }
    return this._cachedTabKey;
  }
  get hasBannerAsset() {
    if (this._cachedHasBannerAsset === undefined) {
      if (this._value.hasBannerAsset) {
        this._cachedHasBannerAsset = true;
      } else {
        this._cachedHasBannerAsset = this._parent ? this._parent.hasBannerAsset : false;
      }
    }
    return this._cachedHasBannerAsset;
  }
  get bannerAsset() {
    if (this._cachedBannerAsset === undefined) {
      if (this._value.hasBannerAsset) {
        this._cachedBannerAsset = this._value.bannerAsset;
      } else {
        this._cachedBannerAsset = this._parent ? this._parent.bannerAsset : this._value.bannerAsset;
      }
    }
    return this._cachedBannerAsset;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_Subscription_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InAppPurchaseData_BundleItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfPostPurchaseTriggers) {
      if (this._value.postPurchaseTriggers === current.postPurchaseTriggers) {
        result._selfPostPurchaseTriggers = this._selfPostPurchaseTriggers;
      } else {
        result._selfPostPurchaseTriggers = [];
        for (let i = 0; i < current.postPurchaseTriggers.length; i++) {
          const oldValue = this._value.postPurchaseTriggers[i];
          if (oldValue) {
            const oldCache = this._selfPostPurchaseTriggers[i];
            if (oldValue === current.postPurchaseTriggers[i]) {
              result._selfPostPurchaseTriggers[i] = oldCache;
            } else {
              result._selfPostPurchaseTriggers[i] = oldCache.update(current.postPurchaseTriggers[i], null);
            }
          } else {
            result._selfPostPurchaseTriggers[i] = new InAppPurchaseData_IapTrigger.WithParent(current.postPurchaseTriggers[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_Subscription_WithParent.default = new InAppPurchaseData_Subscription_WithParent(InAppPurchaseData_Subscription.default, null);
InAppPurchaseData_Subscription.WithParent = InAppPurchaseData_Subscription_WithParent;
class InAppPurchaseData_Subscription_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 3,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 5,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get persistent() {
    if (!this._persistent) {
      this._persistent = {
        name: "persistent",
        Name: "Persistent",
        number: 6,
        protoType: 8,
        protoName: "persistent",
        type: JsonToBoolean,
        options: {
          comments: "If not persistent, the purchase limit will be 1",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._persistent;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 7,
        protoType: 11,
        protoName: "items",
        type: InAppPurchaseData_BundleItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get showPip() {
    if (!this._showPip) {
      this._showPip = {
        name: "showPip",
        Name: "ShowPip",
        number: 11,
        protoType: 8,
        protoName: "show_pip",
        type: JsonToBoolean,
        options: {
          comments: "Whether or not to show red pip upon appearing for the first time",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showPip;
  }
  get postPurchaseTriggers() {
    if (!this._postPurchaseTriggers) {
      this._postPurchaseTriggers = {
        name: "postPurchaseTriggers",
        Name: "PostPurchaseTriggers",
        number: 13,
        protoType: 11,
        protoName: "post_purchase_triggers",
        type: InAppPurchaseData_IapTrigger,
        isRepeated: true,
        options: {
          comments: "Products that will be triggered after purchase",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postPurchaseTriggers;
  }
  get asset() {
    if (!this._asset) {
      this._asset = {
        name: "asset",
        Name: "Asset",
        number: 20,
        protoType: 9,
        protoName: "asset",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleAssetList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._asset;
  }
  get tabKey() {
    if (!this._tabKey) {
      this._tabKey = {
        name: "tabKey",
        Name: "TabKey",
        number: 21,
        protoType: 9,
        protoName: "tab_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabKey;
  }
  get bannerAsset() {
    if (!this._bannerAsset) {
      this._bannerAsset = {
        name: "bannerAsset",
        Name: "BannerAsset",
        number: 22,
        protoType: 9,
        protoName: "banner_asset",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleBannerNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bannerAsset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
        this.key,
        this.price,
        this.duration,
        this.persistent,
        this.items,
        this.showPip,
        this.postPurchaseTriggers,
        this.asset,
        this.tabKey,
        this.bannerAsset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPersistent",
        Name: "DummyOneofForPersistent",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowPip",
        Name: "DummyOneofForShowPip",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAsset",
        Name: "DummyOneofForAsset",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTabKey",
        Name: "DummyOneofForTabKey",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBannerAsset",
        Name: "DummyOneofForBannerAsset",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_Subscription.descriptor = new InAppPurchaseData_Subscription_Descriptor();
class InAppPurchaseData_BundleItem {
  get descriptor() {
    return InAppPurchaseData_BundleItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmount = false;
    this._amount = null;
    this._hasDescription = false;
    this._description = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmount) return false;
    if (this._hasDescription) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_BundleItem) {
      return value;
    }
    return InAppPurchaseData_BundleItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_BundleItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_BundleItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new InAppPurchaseData_BundleItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_BundleItem(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new InAppPurchaseData_BundleItem(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_BundleItem(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new InAppPurchaseData_BundleItem(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_BundleItem} other
   * @returns {InAppPurchaseData_BundleItem}
   */
  merge(other) {
    const copy = new InAppPurchaseData_BundleItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    return copy;
  }
}
InAppPurchaseData_BundleItem.default = new InAppPurchaseData_BundleItem();
class InAppPurchaseData_BundleItem_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_BundleItem(value);
  }
  build() {
    return new InAppPurchaseData_BundleItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
}
InAppPurchaseData_BundleItem.Builder = InAppPurchaseData_BundleItem_Builder;
class InAppPurchaseData_BundleItem_WithParent {
  /**
   * @param {InAppPurchaseData_BundleItem} value
   * @param {InAppPurchaseData_BundleItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_BundleItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_BundleItem_WithParent(current, parent);
    return result;
  }
}
InAppPurchaseData_BundleItem_WithParent.default = new InAppPurchaseData_BundleItem_WithParent(InAppPurchaseData_BundleItem.default, null);
InAppPurchaseData_BundleItem.WithParent = InAppPurchaseData_BundleItem_WithParent;
class InAppPurchaseData_BundleItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 3,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amount,
        this.description,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_BundleItem.descriptor = new InAppPurchaseData_BundleItem_Descriptor();
class InAppPurchaseData_LimitedBundles {
  get descriptor() {
    return InAppPurchaseData_LimitedBundles.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasPrice = false;
    this._price = null;
    this._hasDiscount = false;
    this._discount = null;
    this._hasPurchaseLimit = false;
    this._purchaseLimit = null;
    this._hasDuration = false;
    this._duration = null;
    this._cards = [];
    this._items = [];
    this._hasShowPip = false;
    this._showPip = null;
    this._postPurchaseTriggers = [];
    this._hasEnableFilter = false;
    this._enableFilter = null;
    this._hasAsset = false;
    this._asset = null;
    this._hasBannerAsset = false;
    this._bannerAsset = null;
    this._hasOverrideId = false;
    this._overrideId = null;
  }
  isEmpty() {
    if (this._hasProductId) return false;
    if (this._hasDisplayName) return false;
    if (this._hasPrice) return false;
    if (this._hasDiscount) return false;
    if (this._hasPurchaseLimit) return false;
    if (this._hasDuration) return false;
    if (this._cards.length > 0) return false;
    if (this._items.length > 0) return false;
    if (this._hasShowPip) return false;
    if (this._postPurchaseTriggers.length > 0) return false;
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) return false;
    if (this._hasAsset) return false;
    if (this._hasBannerAsset) return false;
    if (this._hasOverrideId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_LimitedBundles) {
      return value;
    }
    return InAppPurchaseData_LimitedBundles.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_LimitedBundles();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.discount != null) {
      result._hasDiscount = true;
      result._discount = JsonToDouble.fromJson(json.discount);
    }
    if (json.purchaseLimit != null) {
      result._hasPurchaseLimit = true;
      result._purchaseLimit = JsonToInt32.fromJson(json.purchaseLimit);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    result._cards = JsonToList(json.cards, JsonToString);
    result._items = JsonToList(json.items, InAppPurchaseData_BundleItem);
    if (json.showPip != null) {
      result._hasShowPip = true;
      result._showPip = JsonToBoolean.fromJson(json.showPip);
    }
    result._postPurchaseTriggers = JsonToList(json.postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    if (json.enableFilter != null) {
      result._hasEnableFilter = true;
      result._enableFilter = InAppPurchaseData_Filter.fromJson(json.enableFilter);
    }
    if (json.asset != null) {
      result._hasAsset = true;
      result._asset = JsonToString.fromJson(json.asset);
    }
    if (json.bannerAsset != null) {
      result._hasBannerAsset = true;
      result._bannerAsset = JsonToString.fromJson(json.bannerAsset);
    }
    if (json.overrideId != null) {
      result._hasOverrideId = true;
      result._overrideId = JsonToString.fromJson(json.overrideId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasDiscount) {
      result.discount = JsonToDouble.toJson(this._discount);
    }
    if (this._hasPurchaseLimit) {
      result.purchaseLimit = JsonToInt32.toJson(this._purchaseLimit);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    if (this._cards.length > 0) {
      result.cards = ArrayToJson(this._cards, JsonToString);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InAppPurchaseData_BundleItem);
    }
    if (this._hasShowPip) {
      result.showPip = JsonToBoolean.toJson(this._showPip);
    }
    if (this._postPurchaseTriggers.length > 0) {
      result.postPurchaseTriggers = ArrayToJson(this._postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    }
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) {
      result.enableFilter = InAppPurchaseData_Filter.toJson(this._enableFilter);
    }
    if (this._hasAsset) {
      result.asset = JsonToString.toJson(this._asset);
    }
    if (this._hasBannerAsset) {
      result.bannerAsset = JsonToString.toJson(this._bannerAsset);
    }
    if (this._hasOverrideId) {
      result.overrideId = JsonToString.toJson(this._overrideId);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get discount() {
    return this._hasDiscount ? this._discount : JsonToDouble.default;
  }
  get hasDiscount() {
    return this._hasDiscount;
  }
  setDiscount(path, value) {
    return {type: 'SET', path: path.concat(['discount']), value};
  }
  deleteDiscount(path) {
    return {type: 'DELETE', path: path.concat(['discount'])};
  }
  /**
   * @returns {number}
   */
  get purchaseLimit() {
    return this._hasPurchaseLimit ? this._purchaseLimit : JsonToInt32.default;
  }
  get hasPurchaseLimit() {
    return this._hasPurchaseLimit;
  }
  setPurchaseLimit(path, value) {
    return {type: 'SET', path: path.concat(['purchaseLimit']), value};
  }
  deletePurchaseLimit(path) {
    return {type: 'DELETE', path: path.concat(['purchaseLimit'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {string[]}
   */
  get cards() {
    return this._cards;
  }
  addCards(path, value) {
    return {type: 'ADD', path: path.concat(['cards']), value};
  }
  setCards(path, value) {
    return {type: 'SET', path: path.concat(['cards']), value: ArrayToJson(value, JsonToString)};
  }
  setCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cards', key]), value};
  }
  deleteCards(path) {
    return {type: 'DELETE', path: path.concat(['cards'])};
  }
  deleteCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cards', key])};
  }
  /**
   * @returns {InAppPurchaseData_BundleItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InAppPurchaseData_BundleItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {boolean}
   */
  get showPip() {
    return this._hasShowPip ? this._showPip : JsonToBoolean.default;
  }
  get hasShowPip() {
    return this._hasShowPip;
  }
  setShowPip(path, value) {
    return {type: 'SET', path: path.concat(['showPip']), value};
  }
  deleteShowPip(path) {
    return {type: 'DELETE', path: path.concat(['showPip'])};
  }
  /**
   * @returns {InAppPurchaseData_IapTrigger[]}
   */
  get postPurchaseTriggers() {
    return this._postPurchaseTriggers;
  }
  addPostPurchaseTriggers(path, value) {
    return {type: 'ADD', path: path.concat(['postPurchaseTriggers']), value: value.toJson()};
  }
  setPostPurchaseTriggers(path, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers']), value: ArrayToJson(value, InAppPurchaseData_IapTrigger)};
  }
  setPostPurchaseTriggersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers', key]), value: value.toJson()};
  }
  deletePostPurchaseTriggers(path) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers'])};
  }
  deletePostPurchaseTriggersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers', key])};
  }
  /**
   * @returns {InAppPurchaseData_Filter}
   */
  get enableFilter() {
    return this._hasEnableFilter ? this._enableFilter : InAppPurchaseData_Filter.default;
  }
  get hasEnableFilter() {
    return this._hasEnableFilter;
  }
  setEnableFilter(path, value) {
    return {type: 'SET', path: path.concat(['enableFilter']), value: value.toJson()};
  }
  deleteEnableFilter(path) {
    return {type: 'DELETE', path: path.concat(['enableFilter'])};
  }
  /**
   * @returns {string}
   */
  get asset() {
    return this._hasAsset ? this._asset : JsonToString.default;
  }
  get hasAsset() {
    return this._hasAsset;
  }
  setAsset(path, value) {
    return {type: 'SET', path: path.concat(['asset']), value};
  }
  deleteAsset(path) {
    return {type: 'DELETE', path: path.concat(['asset'])};
  }
  /**
   * @returns {string}
   */
  get bannerAsset() {
    return this._hasBannerAsset ? this._bannerAsset : JsonToString.default;
  }
  get hasBannerAsset() {
    return this._hasBannerAsset;
  }
  setBannerAsset(path, value) {
    return {type: 'SET', path: path.concat(['bannerAsset']), value};
  }
  deleteBannerAsset(path) {
    return {type: 'DELETE', path: path.concat(['bannerAsset'])};
  }
  /**
   * @returns {string}
   */
  get overrideId() {
    return this._hasOverrideId ? this._overrideId : JsonToString.default;
  }
  get hasOverrideId() {
    return this._hasOverrideId;
  }
  setOverrideId(path, value) {
    return {type: 'SET', path: path.concat(['overrideId']), value};
  }
  deleteOverrideId(path) {
    return {type: 'DELETE', path: path.concat(['overrideId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "discount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasDiscount = true;
              copy._discount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDiscount) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasDiscount = false;
              copy._discount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasPurchaseLimit = true;
              copy._purchaseLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseLimit) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasPurchaseLimit = false;
              copy._purchaseLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._cards = [];        for (let i of value) {
                copy._cards.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._cards = copy._cards.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cards.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._cards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._cards = copy._cards.slice();
              copy._cards[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._cards = copy._cards.slice(0, path[1]).concat(copy._cards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          const oldValue = this._cards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_LimitedBundles(this);
          copy._cards = copy._cards.slice();
          copy._cards[key] = newValue;
          return copy;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InAppPurchaseData_BundleItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._items = copy._items.concat([InAppPurchaseData_BundleItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InAppPurchaseData_BundleItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_LimitedBundles(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "showPip": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasShowPip = true;
              copy._showPip = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowPip) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasShowPip = false;
              copy._showPip = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "postPurchaseTriggers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._postPurchaseTriggers = [];        for (let i of value) {
                copy._postPurchaseTriggers.push(InAppPurchaseData_IapTrigger.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.concat([InAppPurchaseData_IapTrigger.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._postPurchaseTriggers.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._postPurchaseTriggers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
              copy._postPurchaseTriggers[path[1]] = InAppPurchaseData_IapTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice(0, path[1]).concat(copy._postPurchaseTriggers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          const oldValue = this._postPurchaseTriggers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_LimitedBundles(this);
          copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
          copy._postPurchaseTriggers[key] = newValue;
          return copy;
        }
      }
      case "enableFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasEnableFilter = true;
              copy._enableFilter = InAppPurchaseData_Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableFilter) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasEnableFilter = false;
              copy._enableFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEnableFilter) {
            const copy = new InAppPurchaseData_LimitedBundles(this);
            copy._hasEnableFilter = true;
            copy._enableFilter = InAppPurchaseData_Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._enableFilter.apply(type, path.slice(1), value);
          if (newValue === this._enableFilter) {
            return this;
          }
          const copy = new InAppPurchaseData_LimitedBundles(this);
          copy._enableFilter = copy._enableFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "asset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasAsset = true;
              copy._asset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasAsset = false;
              copy._asset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bannerAsset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasBannerAsset = true;
              copy._bannerAsset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBannerAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasBannerAsset = false;
              copy._bannerAsset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "overrideId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasOverrideId = true;
              copy._overrideId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOverrideId) {
                return this;
              }
              const copy = new InAppPurchaseData_LimitedBundles(this);
              copy._hasOverrideId = false;
              copy._overrideId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_LimitedBundles} other
   * @returns {InAppPurchaseData_LimitedBundles}
   */
  merge(other) {
    const copy = new InAppPurchaseData_LimitedBundles(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasDiscount) {
      copy._hasDiscount = true;
      copy._discount = other._discount;
    }
    if (other._hasPurchaseLimit) {
      copy._hasPurchaseLimit = true;
      copy._purchaseLimit = other._purchaseLimit;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    copy._cards = this._cards.concat(other._cards);
    copy._items = this._items.concat(other._items);
    if (other._hasShowPip) {
      copy._hasShowPip = true;
      copy._showPip = other._showPip;
    }
    copy._postPurchaseTriggers = this._postPurchaseTriggers.concat(other._postPurchaseTriggers);
    if (other._hasEnableFilter) {
      if (copy._hasEnableFilter) {
        copy._enableFilter = copy.enableFilter.merge(other.enableFilter);
      } else {
        copy._enableFilter = other._enableFilter;
      }
      copy._hasEnableFilter = true;
    }
    if (other._hasAsset) {
      copy._hasAsset = true;
      copy._asset = other._asset;
    }
    if (other._hasBannerAsset) {
      copy._hasBannerAsset = true;
      copy._bannerAsset = other._bannerAsset;
    }
    if (other._hasOverrideId) {
      copy._hasOverrideId = true;
      copy._overrideId = other._overrideId;
    }
    return copy;
  }
}
InAppPurchaseData_LimitedBundles.default = new InAppPurchaseData_LimitedBundles();
class InAppPurchaseData_LimitedBundles_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_LimitedBundles(value);
  }
  build() {
    return new InAppPurchaseData_LimitedBundles(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setDiscount(value) {
    this._value._hasDiscount = true;
    this._value._discount = value;
    return this;
  }
  deleteDiscount() {
    this._value._hasDiscount = false;
    this._value._discount = null;
    return this;
  }
  setPurchaseLimit(value) {
    this._value._hasPurchaseLimit = true;
    this._value._purchaseLimit = value;
    return this;
  }
  deletePurchaseLimit() {
    this._value._hasPurchaseLimit = false;
    this._value._purchaseLimit = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  addAllCards(values) {
    this._value._cards = this._value._cards.concat(values);
    return this;
  }
  addCards(value) {
    this._value._cards = this._value._cards.concat([value]);
    return this;
  }
  setCards(index, value) {
    this._value._cards = this._value._cards.concat();
    this._value._cards[index] = value;
    return this;
  }
  clearCards() {
    this._value._cards = [];
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  setShowPip(value) {
    this._value._hasShowPip = true;
    this._value._showPip = value;
    return this;
  }
  deleteShowPip() {
    this._value._hasShowPip = false;
    this._value._showPip = null;
    return this;
  }
  addAllPostPurchaseTriggers(values) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat(values);
    return this;
  }
  addPostPurchaseTriggers(value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat([value]);
    return this;
  }
  setPostPurchaseTriggers(index, value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat();
    this._value._postPurchaseTriggers[index] = value;
    return this;
  }
  clearPostPurchaseTriggers() {
    this._value._postPurchaseTriggers = [];
    return this;
  }
  setEnableFilter(value) {
    this._value._hasEnableFilter = true;
    this._value._enableFilter = value;
    return this;
  }
  deleteEnableFilter() {
    this._value._hasEnableFilter = false;
    this._value._enableFilter = null;
    return this;
  }
  setAsset(value) {
    this._value._hasAsset = true;
    this._value._asset = value;
    return this;
  }
  deleteAsset() {
    this._value._hasAsset = false;
    this._value._asset = null;
    return this;
  }
  setBannerAsset(value) {
    this._value._hasBannerAsset = true;
    this._value._bannerAsset = value;
    return this;
  }
  deleteBannerAsset() {
    this._value._hasBannerAsset = false;
    this._value._bannerAsset = null;
    return this;
  }
  setOverrideId(value) {
    this._value._hasOverrideId = true;
    this._value._overrideId = value;
    return this;
  }
  deleteOverrideId() {
    this._value._hasOverrideId = false;
    this._value._overrideId = null;
    return this;
  }
}
InAppPurchaseData_LimitedBundles.Builder = InAppPurchaseData_LimitedBundles_Builder;
class InAppPurchaseData_LimitedBundles_WithParent {
  /**
   * @param {InAppPurchaseData_LimitedBundles} value
   * @param {InAppPurchaseData_LimitedBundles_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_LimitedBundles.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasDiscount() {
    if (this._cachedHasDiscount === undefined) {
      if (this._value.hasDiscount) {
        this._cachedHasDiscount = true;
      } else {
        this._cachedHasDiscount = this._parent ? this._parent.hasDiscount : false;
      }
    }
    return this._cachedHasDiscount;
  }
  get discount() {
    if (this._cachedDiscount === undefined) {
      if (this._value.hasDiscount) {
        this._cachedDiscount = this._value.discount;
      } else {
        this._cachedDiscount = this._parent ? this._parent.discount : this._value.discount;
      }
    }
    return this._cachedDiscount;
  }
  get hasPurchaseLimit() {
    if (this._cachedHasPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedHasPurchaseLimit = true;
      } else {
        this._cachedHasPurchaseLimit = this._parent ? this._parent.hasPurchaseLimit : false;
      }
    }
    return this._cachedHasPurchaseLimit;
  }
  get purchaseLimit() {
    if (this._cachedPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedPurchaseLimit = this._value.purchaseLimit;
      } else {
        this._cachedPurchaseLimit = this._parent ? this._parent.purchaseLimit : this._value.purchaseLimit;
      }
    }
    return this._cachedPurchaseLimit;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get selfCards() {
    return this._value.cards;
  }
  get inherentCards() {
    if (!this._inherentCards) {
      this._inherentCards = this._parent ? this._parent.cards : [];
    }
    return this._inherentCards;
  }
  get cards() {
    if (!this._allCards) {
      this._allCards = this._parent ? this._parent.cards.concat(this.selfCards) : this.selfCards;
    }
    return this._allCards;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InAppPurchaseData_BundleItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get hasShowPip() {
    if (this._cachedHasShowPip === undefined) {
      if (this._value.hasShowPip) {
        this._cachedHasShowPip = true;
      } else {
        this._cachedHasShowPip = this._parent ? this._parent.hasShowPip : false;
      }
    }
    return this._cachedHasShowPip;
  }
  get showPip() {
    if (this._cachedShowPip === undefined) {
      if (this._value.hasShowPip) {
        this._cachedShowPip = this._value.showPip;
      } else {
        this._cachedShowPip = this._parent ? this._parent.showPip : this._value.showPip;
      }
    }
    return this._cachedShowPip;
  }
  get selfPostPurchaseTriggers() {
    if (!this._selfPostPurchaseTriggers) {
      this._selfPostPurchaseTriggers = [];
      for (let i of this._value.postPurchaseTriggers) {
        this._selfPostPurchaseTriggers.push(new InAppPurchaseData_IapTrigger.WithParent(i, null));
      }
    }
    return this._selfPostPurchaseTriggers;
  }
  get inherentPostPurchaseTriggers() {
    if (!this._inherentPostPurchaseTriggers) {
      this._inherentPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers : [];
    }
    return this._inherentPostPurchaseTriggers;
  }
  get postPurchaseTriggers() {
    if (!this._allPostPurchaseTriggers) {
      this._allPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers.concat(this.selfPostPurchaseTriggers) : this.selfPostPurchaseTriggers;
    }
    return this._allPostPurchaseTriggers;
  }
  get hasEnableFilter() {
    if (this._cachedHasEnableFilter === undefined) {
      if (this._value.hasEnableFilter) {
        this._cachedHasEnableFilter = true;
      } else {
        this._cachedHasEnableFilter = this._parent ? this._parent.hasEnableFilter : false;
      }
    }
    return this._cachedHasEnableFilter;
  }
  get enableFilter() {
    if (!this._cachedEnableFilter) {
      if (this._value.hasEnableFilter) {
        this._cachedEnableFilter = new InAppPurchaseData_Filter.WithParent(this._value.enableFilter, this._parent && this._parent.hasEnableFilter ? this._parent.enableFilter : null);
      } else {
        this._cachedEnableFilter = this._parent ? new InAppPurchaseData_Filter.WithParent(InAppPurchaseData_Filter.default, this._parent.enableFilter) : InAppPurchaseData_Filter.WithParent.default;
      }
    }
    return this._cachedEnableFilter;
  }
  get hasAsset() {
    if (this._cachedHasAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedHasAsset = true;
      } else {
        this._cachedHasAsset = this._parent ? this._parent.hasAsset : false;
      }
    }
    return this._cachedHasAsset;
  }
  get asset() {
    if (this._cachedAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedAsset = this._value.asset;
      } else {
        this._cachedAsset = this._parent ? this._parent.asset : this._value.asset;
      }
    }
    return this._cachedAsset;
  }
  get hasBannerAsset() {
    if (this._cachedHasBannerAsset === undefined) {
      if (this._value.hasBannerAsset) {
        this._cachedHasBannerAsset = true;
      } else {
        this._cachedHasBannerAsset = this._parent ? this._parent.hasBannerAsset : false;
      }
    }
    return this._cachedHasBannerAsset;
  }
  get bannerAsset() {
    if (this._cachedBannerAsset === undefined) {
      if (this._value.hasBannerAsset) {
        this._cachedBannerAsset = this._value.bannerAsset;
      } else {
        this._cachedBannerAsset = this._parent ? this._parent.bannerAsset : this._value.bannerAsset;
      }
    }
    return this._cachedBannerAsset;
  }
  get hasOverrideId() {
    if (this._cachedHasOverrideId === undefined) {
      if (this._value.hasOverrideId) {
        this._cachedHasOverrideId = true;
      } else {
        this._cachedHasOverrideId = this._parent ? this._parent.hasOverrideId : false;
      }
    }
    return this._cachedHasOverrideId;
  }
  get overrideId() {
    if (this._cachedOverrideId === undefined) {
      if (this._value.hasOverrideId) {
        this._cachedOverrideId = this._value.overrideId;
      } else {
        this._cachedOverrideId = this._parent ? this._parent.overrideId : this._value.overrideId;
      }
    }
    return this._cachedOverrideId;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_LimitedBundles_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InAppPurchaseData_BundleItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfPostPurchaseTriggers) {
      if (this._value.postPurchaseTriggers === current.postPurchaseTriggers) {
        result._selfPostPurchaseTriggers = this._selfPostPurchaseTriggers;
      } else {
        result._selfPostPurchaseTriggers = [];
        for (let i = 0; i < current.postPurchaseTriggers.length; i++) {
          const oldValue = this._value.postPurchaseTriggers[i];
          if (oldValue) {
            const oldCache = this._selfPostPurchaseTriggers[i];
            if (oldValue === current.postPurchaseTriggers[i]) {
              result._selfPostPurchaseTriggers[i] = oldCache;
            } else {
              result._selfPostPurchaseTriggers[i] = oldCache.update(current.postPurchaseTriggers[i], null);
            }
          } else {
            result._selfPostPurchaseTriggers[i] = new InAppPurchaseData_IapTrigger.WithParent(current.postPurchaseTriggers[i], null);
          }
        }
      }
    }
    if (this._cachedEnableFilter && this._value.hasEnableFilter && current.hasEnableFilter) {
      if (this._value.enableFilter === current.enableFilter && this._parent === parent) {
        result._cachedEnableFilter = this._cachedEnableFilter;
      } else {
        result._cachedEnableFilter = this._cachedEnableFilter.update(current.enableFilter, parent && parent.hasEnableFilter ? parent.enableFilter : null);
      }
    }
    return result;
  }
}
InAppPurchaseData_LimitedBundles_WithParent.default = new InAppPurchaseData_LimitedBundles_WithParent(InAppPurchaseData_LimitedBundles.default, null);
InAppPurchaseData_LimitedBundles.WithParent = InAppPurchaseData_LimitedBundles_WithParent;
class InAppPurchaseData_LimitedBundles_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 3,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
          comments: "Price in US dollers.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get discount() {
    if (!this._discount) {
      this._discount = {
        name: "discount",
        Name: "Discount",
        number: 4,
        protoType: 1,
        protoName: "discount",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._discount;
  }
  get purchaseLimit() {
    if (!this._purchaseLimit) {
      this._purchaseLimit = {
        name: "purchaseLimit",
        Name: "PurchaseLimit",
        number: 5,
        protoType: 5,
        protoName: "purchase_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseLimit;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 6,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get cards() {
    if (!this._cards) {
      this._cards = {
        name: "cards",
        Name: "Cards",
        number: 7,
        protoType: 9,
        protoName: "cards",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cards;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 8,
        protoType: 11,
        protoName: "items",
        type: InAppPurchaseData_BundleItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get showPip() {
    if (!this._showPip) {
      this._showPip = {
        name: "showPip",
        Name: "ShowPip",
        number: 12,
        protoType: 8,
        protoName: "show_pip",
        type: JsonToBoolean,
        options: {
          comments: "Whether or not to show red pip upon appearing for the first time",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showPip;
  }
  get postPurchaseTriggers() {
    if (!this._postPurchaseTriggers) {
      this._postPurchaseTriggers = {
        name: "postPurchaseTriggers",
        Name: "PostPurchaseTriggers",
        number: 16,
        protoType: 11,
        protoName: "post_purchase_triggers",
        type: InAppPurchaseData_IapTrigger,
        isRepeated: true,
        options: {
          comments: "Products that will be triggered after hide",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postPurchaseTriggers;
  }
  get enableFilter() {
    if (!this._enableFilter) {
      this._enableFilter = {
        name: "enableFilter",
        Name: "EnableFilter",
        number: 18,
        protoType: 11,
        protoName: "enable_filter",
        type: InAppPurchaseData_Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableFilter;
  }
  get asset() {
    if (!this._asset) {
      this._asset = {
        name: "asset",
        Name: "Asset",
        number: 20,
        protoType: 9,
        protoName: "asset",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleAssetList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._asset;
  }
  get bannerAsset() {
    if (!this._bannerAsset) {
      this._bannerAsset = {
        name: "bannerAsset",
        Name: "BannerAsset",
        number: 22,
        protoType: 9,
        protoName: "banner_asset",
        type: JsonToString,
        options: {
          comments: "(Optional) Determines which banner(sprite name) to use other than the default",
          valueDropdown: "IapBundleBannerNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bannerAsset;
  }
  get overrideId() {
    if (!this._overrideId) {
      this._overrideId = {
        name: "overrideId",
        Name: "OverrideId",
        number: 23,
        protoType: 9,
        protoName: "override_id",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overrideId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
        this.displayName,
        this.price,
        this.discount,
        this.purchaseLimit,
        this.duration,
        this.cards,
        this.items,
        this.showPip,
        this.postPurchaseTriggers,
        this.enableFilter,
        this.asset,
        this.bannerAsset,
        this.overrideId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDiscount",
        Name: "DummyOneofForDiscount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseLimit",
        Name: "DummyOneofForPurchaseLimit",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowPip",
        Name: "DummyOneofForShowPip",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableFilter",
        Name: "DummyOneofForEnableFilter",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAsset",
        Name: "DummyOneofForAsset",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBannerAsset",
        Name: "DummyOneofForBannerAsset",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOverrideId",
        Name: "DummyOneofForOverrideId",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_LimitedBundles.descriptor = new InAppPurchaseData_LimitedBundles_Descriptor();
class InAppPurchaseData_SaleBundle {
  get descriptor() {
    return InAppPurchaseData_SaleBundle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasPrice = false;
    this._price = null;
    this._hasDiscount = false;
    this._discount = null;
    this._hasPurchaseLimit = false;
    this._purchaseLimit = null;
    this._hasDuration = false;
    this._duration = null;
    this._cards = [];
    this._items = [];
    this._postPurchaseTriggers = [];
    this._hasEnableFilter = false;
    this._enableFilter = null;
    this._hasAsset = false;
    this._asset = null;
  }
  isEmpty() {
    if (this._hasProductId) return false;
    if (this._hasDisplayName) return false;
    if (this._hasPrice) return false;
    if (this._hasDiscount) return false;
    if (this._hasPurchaseLimit) return false;
    if (this._hasDuration) return false;
    if (this._cards.length > 0) return false;
    if (this._items.length > 0) return false;
    if (this._postPurchaseTriggers.length > 0) return false;
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) return false;
    if (this._hasAsset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_SaleBundle) {
      return value;
    }
    return InAppPurchaseData_SaleBundle.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_SaleBundle();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.discount != null) {
      result._hasDiscount = true;
      result._discount = JsonToDouble.fromJson(json.discount);
    }
    if (json.purchaseLimit != null) {
      result._hasPurchaseLimit = true;
      result._purchaseLimit = JsonToInt32.fromJson(json.purchaseLimit);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    result._cards = JsonToList(json.cards, JsonToString);
    result._items = JsonToList(json.items, InAppPurchaseData_BundleItem);
    result._postPurchaseTriggers = JsonToList(json.postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    if (json.enableFilter != null) {
      result._hasEnableFilter = true;
      result._enableFilter = InAppPurchaseData_Filter.fromJson(json.enableFilter);
    }
    if (json.asset != null) {
      result._hasAsset = true;
      result._asset = JsonToString.fromJson(json.asset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasDiscount) {
      result.discount = JsonToDouble.toJson(this._discount);
    }
    if (this._hasPurchaseLimit) {
      result.purchaseLimit = JsonToInt32.toJson(this._purchaseLimit);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    if (this._cards.length > 0) {
      result.cards = ArrayToJson(this._cards, JsonToString);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InAppPurchaseData_BundleItem);
    }
    if (this._postPurchaseTriggers.length > 0) {
      result.postPurchaseTriggers = ArrayToJson(this._postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    }
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) {
      result.enableFilter = InAppPurchaseData_Filter.toJson(this._enableFilter);
    }
    if (this._hasAsset) {
      result.asset = JsonToString.toJson(this._asset);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get discount() {
    return this._hasDiscount ? this._discount : JsonToDouble.default;
  }
  get hasDiscount() {
    return this._hasDiscount;
  }
  setDiscount(path, value) {
    return {type: 'SET', path: path.concat(['discount']), value};
  }
  deleteDiscount(path) {
    return {type: 'DELETE', path: path.concat(['discount'])};
  }
  /**
   * @returns {number}
   */
  get purchaseLimit() {
    return this._hasPurchaseLimit ? this._purchaseLimit : JsonToInt32.default;
  }
  get hasPurchaseLimit() {
    return this._hasPurchaseLimit;
  }
  setPurchaseLimit(path, value) {
    return {type: 'SET', path: path.concat(['purchaseLimit']), value};
  }
  deletePurchaseLimit(path) {
    return {type: 'DELETE', path: path.concat(['purchaseLimit'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {string[]}
   */
  get cards() {
    return this._cards;
  }
  addCards(path, value) {
    return {type: 'ADD', path: path.concat(['cards']), value};
  }
  setCards(path, value) {
    return {type: 'SET', path: path.concat(['cards']), value: ArrayToJson(value, JsonToString)};
  }
  setCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cards', key]), value};
  }
  deleteCards(path) {
    return {type: 'DELETE', path: path.concat(['cards'])};
  }
  deleteCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cards', key])};
  }
  /**
   * @returns {InAppPurchaseData_BundleItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InAppPurchaseData_BundleItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {InAppPurchaseData_IapTrigger[]}
   */
  get postPurchaseTriggers() {
    return this._postPurchaseTriggers;
  }
  addPostPurchaseTriggers(path, value) {
    return {type: 'ADD', path: path.concat(['postPurchaseTriggers']), value: value.toJson()};
  }
  setPostPurchaseTriggers(path, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers']), value: ArrayToJson(value, InAppPurchaseData_IapTrigger)};
  }
  setPostPurchaseTriggersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers', key]), value: value.toJson()};
  }
  deletePostPurchaseTriggers(path) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers'])};
  }
  deletePostPurchaseTriggersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers', key])};
  }
  /**
   * @returns {InAppPurchaseData_Filter}
   */
  get enableFilter() {
    return this._hasEnableFilter ? this._enableFilter : InAppPurchaseData_Filter.default;
  }
  get hasEnableFilter() {
    return this._hasEnableFilter;
  }
  setEnableFilter(path, value) {
    return {type: 'SET', path: path.concat(['enableFilter']), value: value.toJson()};
  }
  deleteEnableFilter(path) {
    return {type: 'DELETE', path: path.concat(['enableFilter'])};
  }
  /**
   * @returns {string}
   */
  get asset() {
    return this._hasAsset ? this._asset : JsonToString.default;
  }
  get hasAsset() {
    return this._hasAsset;
  }
  setAsset(path, value) {
    return {type: 'SET', path: path.concat(['asset']), value};
  }
  deleteAsset(path) {
    return {type: 'DELETE', path: path.concat(['asset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "discount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasDiscount = true;
              copy._discount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDiscount) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasDiscount = false;
              copy._discount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasPurchaseLimit = true;
              copy._purchaseLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseLimit) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasPurchaseLimit = false;
              copy._purchaseLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._cards = [];        for (let i of value) {
                copy._cards.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._cards = copy._cards.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cards.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._cards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._cards = copy._cards.slice();
              copy._cards[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._cards = copy._cards.slice(0, path[1]).concat(copy._cards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          const oldValue = this._cards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_SaleBundle(this);
          copy._cards = copy._cards.slice();
          copy._cards[key] = newValue;
          return copy;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InAppPurchaseData_BundleItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._items = copy._items.concat([InAppPurchaseData_BundleItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InAppPurchaseData_BundleItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_SaleBundle(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "postPurchaseTriggers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._postPurchaseTriggers = [];        for (let i of value) {
                copy._postPurchaseTriggers.push(InAppPurchaseData_IapTrigger.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.concat([InAppPurchaseData_IapTrigger.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._postPurchaseTriggers.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._postPurchaseTriggers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
              copy._postPurchaseTriggers[path[1]] = InAppPurchaseData_IapTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice(0, path[1]).concat(copy._postPurchaseTriggers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          const oldValue = this._postPurchaseTriggers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_SaleBundle(this);
          copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
          copy._postPurchaseTriggers[key] = newValue;
          return copy;
        }
      }
      case "enableFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasEnableFilter = true;
              copy._enableFilter = InAppPurchaseData_Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableFilter) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasEnableFilter = false;
              copy._enableFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEnableFilter) {
            const copy = new InAppPurchaseData_SaleBundle(this);
            copy._hasEnableFilter = true;
            copy._enableFilter = InAppPurchaseData_Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._enableFilter.apply(type, path.slice(1), value);
          if (newValue === this._enableFilter) {
            return this;
          }
          const copy = new InAppPurchaseData_SaleBundle(this);
          copy._enableFilter = copy._enableFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "asset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasAsset = true;
              copy._asset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundle(this);
              copy._hasAsset = false;
              copy._asset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_SaleBundle} other
   * @returns {InAppPurchaseData_SaleBundle}
   */
  merge(other) {
    const copy = new InAppPurchaseData_SaleBundle(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasDiscount) {
      copy._hasDiscount = true;
      copy._discount = other._discount;
    }
    if (other._hasPurchaseLimit) {
      copy._hasPurchaseLimit = true;
      copy._purchaseLimit = other._purchaseLimit;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    copy._cards = this._cards.concat(other._cards);
    copy._items = this._items.concat(other._items);
    copy._postPurchaseTriggers = this._postPurchaseTriggers.concat(other._postPurchaseTriggers);
    if (other._hasEnableFilter) {
      if (copy._hasEnableFilter) {
        copy._enableFilter = copy.enableFilter.merge(other.enableFilter);
      } else {
        copy._enableFilter = other._enableFilter;
      }
      copy._hasEnableFilter = true;
    }
    if (other._hasAsset) {
      copy._hasAsset = true;
      copy._asset = other._asset;
    }
    return copy;
  }
}
InAppPurchaseData_SaleBundle.default = new InAppPurchaseData_SaleBundle();
class InAppPurchaseData_SaleBundle_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_SaleBundle(value);
  }
  build() {
    return new InAppPurchaseData_SaleBundle(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setDiscount(value) {
    this._value._hasDiscount = true;
    this._value._discount = value;
    return this;
  }
  deleteDiscount() {
    this._value._hasDiscount = false;
    this._value._discount = null;
    return this;
  }
  setPurchaseLimit(value) {
    this._value._hasPurchaseLimit = true;
    this._value._purchaseLimit = value;
    return this;
  }
  deletePurchaseLimit() {
    this._value._hasPurchaseLimit = false;
    this._value._purchaseLimit = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  addAllCards(values) {
    this._value._cards = this._value._cards.concat(values);
    return this;
  }
  addCards(value) {
    this._value._cards = this._value._cards.concat([value]);
    return this;
  }
  setCards(index, value) {
    this._value._cards = this._value._cards.concat();
    this._value._cards[index] = value;
    return this;
  }
  clearCards() {
    this._value._cards = [];
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  addAllPostPurchaseTriggers(values) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat(values);
    return this;
  }
  addPostPurchaseTriggers(value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat([value]);
    return this;
  }
  setPostPurchaseTriggers(index, value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat();
    this._value._postPurchaseTriggers[index] = value;
    return this;
  }
  clearPostPurchaseTriggers() {
    this._value._postPurchaseTriggers = [];
    return this;
  }
  setEnableFilter(value) {
    this._value._hasEnableFilter = true;
    this._value._enableFilter = value;
    return this;
  }
  deleteEnableFilter() {
    this._value._hasEnableFilter = false;
    this._value._enableFilter = null;
    return this;
  }
  setAsset(value) {
    this._value._hasAsset = true;
    this._value._asset = value;
    return this;
  }
  deleteAsset() {
    this._value._hasAsset = false;
    this._value._asset = null;
    return this;
  }
}
InAppPurchaseData_SaleBundle.Builder = InAppPurchaseData_SaleBundle_Builder;
class InAppPurchaseData_SaleBundle_WithParent {
  /**
   * @param {InAppPurchaseData_SaleBundle} value
   * @param {InAppPurchaseData_SaleBundle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_SaleBundle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasDiscount() {
    if (this._cachedHasDiscount === undefined) {
      if (this._value.hasDiscount) {
        this._cachedHasDiscount = true;
      } else {
        this._cachedHasDiscount = this._parent ? this._parent.hasDiscount : false;
      }
    }
    return this._cachedHasDiscount;
  }
  get discount() {
    if (this._cachedDiscount === undefined) {
      if (this._value.hasDiscount) {
        this._cachedDiscount = this._value.discount;
      } else {
        this._cachedDiscount = this._parent ? this._parent.discount : this._value.discount;
      }
    }
    return this._cachedDiscount;
  }
  get hasPurchaseLimit() {
    if (this._cachedHasPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedHasPurchaseLimit = true;
      } else {
        this._cachedHasPurchaseLimit = this._parent ? this._parent.hasPurchaseLimit : false;
      }
    }
    return this._cachedHasPurchaseLimit;
  }
  get purchaseLimit() {
    if (this._cachedPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedPurchaseLimit = this._value.purchaseLimit;
      } else {
        this._cachedPurchaseLimit = this._parent ? this._parent.purchaseLimit : this._value.purchaseLimit;
      }
    }
    return this._cachedPurchaseLimit;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get selfCards() {
    return this._value.cards;
  }
  get inherentCards() {
    if (!this._inherentCards) {
      this._inherentCards = this._parent ? this._parent.cards : [];
    }
    return this._inherentCards;
  }
  get cards() {
    if (!this._allCards) {
      this._allCards = this._parent ? this._parent.cards.concat(this.selfCards) : this.selfCards;
    }
    return this._allCards;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InAppPurchaseData_BundleItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get selfPostPurchaseTriggers() {
    if (!this._selfPostPurchaseTriggers) {
      this._selfPostPurchaseTriggers = [];
      for (let i of this._value.postPurchaseTriggers) {
        this._selfPostPurchaseTriggers.push(new InAppPurchaseData_IapTrigger.WithParent(i, null));
      }
    }
    return this._selfPostPurchaseTriggers;
  }
  get inherentPostPurchaseTriggers() {
    if (!this._inherentPostPurchaseTriggers) {
      this._inherentPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers : [];
    }
    return this._inherentPostPurchaseTriggers;
  }
  get postPurchaseTriggers() {
    if (!this._allPostPurchaseTriggers) {
      this._allPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers.concat(this.selfPostPurchaseTriggers) : this.selfPostPurchaseTriggers;
    }
    return this._allPostPurchaseTriggers;
  }
  get hasEnableFilter() {
    if (this._cachedHasEnableFilter === undefined) {
      if (this._value.hasEnableFilter) {
        this._cachedHasEnableFilter = true;
      } else {
        this._cachedHasEnableFilter = this._parent ? this._parent.hasEnableFilter : false;
      }
    }
    return this._cachedHasEnableFilter;
  }
  get enableFilter() {
    if (!this._cachedEnableFilter) {
      if (this._value.hasEnableFilter) {
        this._cachedEnableFilter = new InAppPurchaseData_Filter.WithParent(this._value.enableFilter, this._parent && this._parent.hasEnableFilter ? this._parent.enableFilter : null);
      } else {
        this._cachedEnableFilter = this._parent ? new InAppPurchaseData_Filter.WithParent(InAppPurchaseData_Filter.default, this._parent.enableFilter) : InAppPurchaseData_Filter.WithParent.default;
      }
    }
    return this._cachedEnableFilter;
  }
  get hasAsset() {
    if (this._cachedHasAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedHasAsset = true;
      } else {
        this._cachedHasAsset = this._parent ? this._parent.hasAsset : false;
      }
    }
    return this._cachedHasAsset;
  }
  get asset() {
    if (this._cachedAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedAsset = this._value.asset;
      } else {
        this._cachedAsset = this._parent ? this._parent.asset : this._value.asset;
      }
    }
    return this._cachedAsset;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_SaleBundle_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InAppPurchaseData_BundleItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfPostPurchaseTriggers) {
      if (this._value.postPurchaseTriggers === current.postPurchaseTriggers) {
        result._selfPostPurchaseTriggers = this._selfPostPurchaseTriggers;
      } else {
        result._selfPostPurchaseTriggers = [];
        for (let i = 0; i < current.postPurchaseTriggers.length; i++) {
          const oldValue = this._value.postPurchaseTriggers[i];
          if (oldValue) {
            const oldCache = this._selfPostPurchaseTriggers[i];
            if (oldValue === current.postPurchaseTriggers[i]) {
              result._selfPostPurchaseTriggers[i] = oldCache;
            } else {
              result._selfPostPurchaseTriggers[i] = oldCache.update(current.postPurchaseTriggers[i], null);
            }
          } else {
            result._selfPostPurchaseTriggers[i] = new InAppPurchaseData_IapTrigger.WithParent(current.postPurchaseTriggers[i], null);
          }
        }
      }
    }
    if (this._cachedEnableFilter && this._value.hasEnableFilter && current.hasEnableFilter) {
      if (this._value.enableFilter === current.enableFilter && this._parent === parent) {
        result._cachedEnableFilter = this._cachedEnableFilter;
      } else {
        result._cachedEnableFilter = this._cachedEnableFilter.update(current.enableFilter, parent && parent.hasEnableFilter ? parent.enableFilter : null);
      }
    }
    return result;
  }
}
InAppPurchaseData_SaleBundle_WithParent.default = new InAppPurchaseData_SaleBundle_WithParent(InAppPurchaseData_SaleBundle.default, null);
InAppPurchaseData_SaleBundle.WithParent = InAppPurchaseData_SaleBundle_WithParent;
class InAppPurchaseData_SaleBundle_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 3,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
          comments: "If currency key is defined, this is amount of inventory item, otherwise it\'s price in US dollers.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get discount() {
    if (!this._discount) {
      this._discount = {
        name: "discount",
        Name: "Discount",
        number: 4,
        protoType: 1,
        protoName: "discount",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._discount;
  }
  get purchaseLimit() {
    if (!this._purchaseLimit) {
      this._purchaseLimit = {
        name: "purchaseLimit",
        Name: "PurchaseLimit",
        number: 5,
        protoType: 5,
        protoName: "purchase_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseLimit;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 6,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get cards() {
    if (!this._cards) {
      this._cards = {
        name: "cards",
        Name: "Cards",
        number: 7,
        protoType: 9,
        protoName: "cards",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cards;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 8,
        protoType: 11,
        protoName: "items",
        type: InAppPurchaseData_BundleItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get postPurchaseTriggers() {
    if (!this._postPurchaseTriggers) {
      this._postPurchaseTriggers = {
        name: "postPurchaseTriggers",
        Name: "PostPurchaseTriggers",
        number: 16,
        protoType: 11,
        protoName: "post_purchase_triggers",
        type: InAppPurchaseData_IapTrigger,
        isRepeated: true,
        options: {
          comments: "Products that will be triggered after hide",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postPurchaseTriggers;
  }
  get enableFilter() {
    if (!this._enableFilter) {
      this._enableFilter = {
        name: "enableFilter",
        Name: "EnableFilter",
        number: 18,
        protoType: 11,
        protoName: "enable_filter",
        type: InAppPurchaseData_Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableFilter;
  }
  get asset() {
    if (!this._asset) {
      this._asset = {
        name: "asset",
        Name: "Asset",
        number: 20,
        protoType: 9,
        protoName: "asset",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleAssetList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._asset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
        this.displayName,
        this.price,
        this.discount,
        this.purchaseLimit,
        this.duration,
        this.cards,
        this.items,
        this.postPurchaseTriggers,
        this.enableFilter,
        this.asset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDiscount",
        Name: "DummyOneofForDiscount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseLimit",
        Name: "DummyOneofForPurchaseLimit",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableFilter",
        Name: "DummyOneofForEnableFilter",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAsset",
        Name: "DummyOneofForAsset",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_SaleBundle.descriptor = new InAppPurchaseData_SaleBundle_Descriptor();
class InAppPurchaseData_DailyTrialBundle {
  get descriptor() {
    return InAppPurchaseData_DailyTrialBundle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasPrice = false;
    this._price = null;
    this._hasPurchaseLimit = false;
    this._purchaseLimit = null;
    this._cards = [];
    this._items = [];
  }
  isEmpty() {
    if (this._hasProductId) return false;
    if (this._hasDisplayName) return false;
    if (this._hasPrice) return false;
    if (this._hasPurchaseLimit) return false;
    if (this._cards.length > 0) return false;
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DailyTrialBundle) {
      return value;
    }
    return InAppPurchaseData_DailyTrialBundle.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DailyTrialBundle();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.purchaseLimit != null) {
      result._hasPurchaseLimit = true;
      result._purchaseLimit = JsonToInt32.fromJson(json.purchaseLimit);
    }
    result._cards = JsonToList(json.cards, JsonToString);
    result._items = JsonToList(json.items, InAppPurchaseData_BundleItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasPurchaseLimit) {
      result.purchaseLimit = JsonToInt32.toJson(this._purchaseLimit);
    }
    if (this._cards.length > 0) {
      result.cards = ArrayToJson(this._cards, JsonToString);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InAppPurchaseData_BundleItem);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get purchaseLimit() {
    return this._hasPurchaseLimit ? this._purchaseLimit : JsonToInt32.default;
  }
  get hasPurchaseLimit() {
    return this._hasPurchaseLimit;
  }
  setPurchaseLimit(path, value) {
    return {type: 'SET', path: path.concat(['purchaseLimit']), value};
  }
  deletePurchaseLimit(path) {
    return {type: 'DELETE', path: path.concat(['purchaseLimit'])};
  }
  /**
   * @returns {string[]}
   */
  get cards() {
    return this._cards;
  }
  addCards(path, value) {
    return {type: 'ADD', path: path.concat(['cards']), value};
  }
  setCards(path, value) {
    return {type: 'SET', path: path.concat(['cards']), value: ArrayToJson(value, JsonToString)};
  }
  setCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cards', key]), value};
  }
  deleteCards(path) {
    return {type: 'DELETE', path: path.concat(['cards'])};
  }
  deleteCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cards', key])};
  }
  /**
   * @returns {InAppPurchaseData_BundleItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InAppPurchaseData_BundleItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasPurchaseLimit = true;
              copy._purchaseLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseLimit) {
                return this;
              }
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._hasPurchaseLimit = false;
              copy._purchaseLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._cards = [];        for (let i of value) {
                copy._cards.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._cards = copy._cards.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cards.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._cards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._cards = copy._cards.slice();
              copy._cards[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._cards = copy._cards.slice(0, path[1]).concat(copy._cards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          const oldValue = this._cards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DailyTrialBundle(this);
          copy._cards = copy._cards.slice();
          copy._cards[key] = newValue;
          return copy;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InAppPurchaseData_BundleItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._items = copy._items.concat([InAppPurchaseData_BundleItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InAppPurchaseData_BundleItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DailyTrialBundle(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DailyTrialBundle(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DailyTrialBundle} other
   * @returns {InAppPurchaseData_DailyTrialBundle}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DailyTrialBundle(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasPurchaseLimit) {
      copy._hasPurchaseLimit = true;
      copy._purchaseLimit = other._purchaseLimit;
    }
    copy._cards = this._cards.concat(other._cards);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
InAppPurchaseData_DailyTrialBundle.default = new InAppPurchaseData_DailyTrialBundle();
class InAppPurchaseData_DailyTrialBundle_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DailyTrialBundle(value);
  }
  build() {
    return new InAppPurchaseData_DailyTrialBundle(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setPurchaseLimit(value) {
    this._value._hasPurchaseLimit = true;
    this._value._purchaseLimit = value;
    return this;
  }
  deletePurchaseLimit() {
    this._value._hasPurchaseLimit = false;
    this._value._purchaseLimit = null;
    return this;
  }
  addAllCards(values) {
    this._value._cards = this._value._cards.concat(values);
    return this;
  }
  addCards(value) {
    this._value._cards = this._value._cards.concat([value]);
    return this;
  }
  setCards(index, value) {
    this._value._cards = this._value._cards.concat();
    this._value._cards[index] = value;
    return this;
  }
  clearCards() {
    this._value._cards = [];
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
InAppPurchaseData_DailyTrialBundle.Builder = InAppPurchaseData_DailyTrialBundle_Builder;
class InAppPurchaseData_DailyTrialBundle_WithParent {
  /**
   * @param {InAppPurchaseData_DailyTrialBundle} value
   * @param {InAppPurchaseData_DailyTrialBundle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DailyTrialBundle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasPurchaseLimit() {
    if (this._cachedHasPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedHasPurchaseLimit = true;
      } else {
        this._cachedHasPurchaseLimit = this._parent ? this._parent.hasPurchaseLimit : false;
      }
    }
    return this._cachedHasPurchaseLimit;
  }
  get purchaseLimit() {
    if (this._cachedPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedPurchaseLimit = this._value.purchaseLimit;
      } else {
        this._cachedPurchaseLimit = this._parent ? this._parent.purchaseLimit : this._value.purchaseLimit;
      }
    }
    return this._cachedPurchaseLimit;
  }
  get selfCards() {
    return this._value.cards;
  }
  get inherentCards() {
    if (!this._inherentCards) {
      this._inherentCards = this._parent ? this._parent.cards : [];
    }
    return this._inherentCards;
  }
  get cards() {
    if (!this._allCards) {
      this._allCards = this._parent ? this._parent.cards.concat(this.selfCards) : this.selfCards;
    }
    return this._allCards;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InAppPurchaseData_BundleItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DailyTrialBundle_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InAppPurchaseData_BundleItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_DailyTrialBundle_WithParent.default = new InAppPurchaseData_DailyTrialBundle_WithParent(InAppPurchaseData_DailyTrialBundle.default, null);
InAppPurchaseData_DailyTrialBundle.WithParent = InAppPurchaseData_DailyTrialBundle_WithParent;
class InAppPurchaseData_DailyTrialBundle_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 3,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
          comments: "price in US dollers.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get purchaseLimit() {
    if (!this._purchaseLimit) {
      this._purchaseLimit = {
        name: "purchaseLimit",
        Name: "PurchaseLimit",
        number: 5,
        protoType: 5,
        protoName: "purchase_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseLimit;
  }
  get cards() {
    if (!this._cards) {
      this._cards = {
        name: "cards",
        Name: "Cards",
        number: 7,
        protoType: 9,
        protoName: "cards",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "int32 duration = 6;",
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cards;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 8,
        protoType: 11,
        protoName: "items",
        type: InAppPurchaseData_BundleItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
        this.displayName,
        this.price,
        this.purchaseLimit,
        this.cards,
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseLimit",
        Name: "DummyOneofForPurchaseLimit",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DailyTrialBundle.descriptor = new InAppPurchaseData_DailyTrialBundle_Descriptor();
class InAppPurchaseData_CampaignSaleBundle {
  get descriptor() {
    return InAppPurchaseData_CampaignSaleBundle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasPrice = false;
    this._price = null;
    this._hasDiscount = false;
    this._discount = null;
    this._hasPurchaseLimit = false;
    this._purchaseLimit = null;
    this._hasDuration = false;
    this._duration = null;
    this._cards = [];
    this._items = [];
    this._postPurchaseTriggers = [];
    this._hasEnableFilter = false;
    this._enableFilter = null;
    this._hasAsset = false;
    this._asset = null;
    this._hasUnlockProgress = false;
    this._unlockProgress = null;
  }
  isEmpty() {
    if (this._hasProductId) return false;
    if (this._hasDisplayName) return false;
    if (this._hasPrice) return false;
    if (this._hasDiscount) return false;
    if (this._hasPurchaseLimit) return false;
    if (this._hasDuration) return false;
    if (this._cards.length > 0) return false;
    if (this._items.length > 0) return false;
    if (this._postPurchaseTriggers.length > 0) return false;
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) return false;
    if (this._hasAsset) return false;
    if (this._hasUnlockProgress) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_CampaignSaleBundle) {
      return value;
    }
    return InAppPurchaseData_CampaignSaleBundle.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_CampaignSaleBundle();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.discount != null) {
      result._hasDiscount = true;
      result._discount = JsonToDouble.fromJson(json.discount);
    }
    if (json.purchaseLimit != null) {
      result._hasPurchaseLimit = true;
      result._purchaseLimit = JsonToInt32.fromJson(json.purchaseLimit);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    result._cards = JsonToList(json.cards, JsonToString);
    result._items = JsonToList(json.items, InAppPurchaseData_BundleItem);
    result._postPurchaseTriggers = JsonToList(json.postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    if (json.enableFilter != null) {
      result._hasEnableFilter = true;
      result._enableFilter = InAppPurchaseData_Filter.fromJson(json.enableFilter);
    }
    if (json.asset != null) {
      result._hasAsset = true;
      result._asset = JsonToString.fromJson(json.asset);
    }
    if (json.unlockProgress != null) {
      result._hasUnlockProgress = true;
      result._unlockProgress = JsonToInt32.fromJson(json.unlockProgress);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasDiscount) {
      result.discount = JsonToDouble.toJson(this._discount);
    }
    if (this._hasPurchaseLimit) {
      result.purchaseLimit = JsonToInt32.toJson(this._purchaseLimit);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    if (this._cards.length > 0) {
      result.cards = ArrayToJson(this._cards, JsonToString);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InAppPurchaseData_BundleItem);
    }
    if (this._postPurchaseTriggers.length > 0) {
      result.postPurchaseTriggers = ArrayToJson(this._postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    }
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) {
      result.enableFilter = InAppPurchaseData_Filter.toJson(this._enableFilter);
    }
    if (this._hasAsset) {
      result.asset = JsonToString.toJson(this._asset);
    }
    if (this._hasUnlockProgress) {
      result.unlockProgress = JsonToInt32.toJson(this._unlockProgress);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get discount() {
    return this._hasDiscount ? this._discount : JsonToDouble.default;
  }
  get hasDiscount() {
    return this._hasDiscount;
  }
  setDiscount(path, value) {
    return {type: 'SET', path: path.concat(['discount']), value};
  }
  deleteDiscount(path) {
    return {type: 'DELETE', path: path.concat(['discount'])};
  }
  /**
   * @returns {number}
   */
  get purchaseLimit() {
    return this._hasPurchaseLimit ? this._purchaseLimit : JsonToInt32.default;
  }
  get hasPurchaseLimit() {
    return this._hasPurchaseLimit;
  }
  setPurchaseLimit(path, value) {
    return {type: 'SET', path: path.concat(['purchaseLimit']), value};
  }
  deletePurchaseLimit(path) {
    return {type: 'DELETE', path: path.concat(['purchaseLimit'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {string[]}
   */
  get cards() {
    return this._cards;
  }
  addCards(path, value) {
    return {type: 'ADD', path: path.concat(['cards']), value};
  }
  setCards(path, value) {
    return {type: 'SET', path: path.concat(['cards']), value: ArrayToJson(value, JsonToString)};
  }
  setCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cards', key]), value};
  }
  deleteCards(path) {
    return {type: 'DELETE', path: path.concat(['cards'])};
  }
  deleteCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cards', key])};
  }
  /**
   * @returns {InAppPurchaseData_BundleItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InAppPurchaseData_BundleItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {InAppPurchaseData_IapTrigger[]}
   */
  get postPurchaseTriggers() {
    return this._postPurchaseTriggers;
  }
  addPostPurchaseTriggers(path, value) {
    return {type: 'ADD', path: path.concat(['postPurchaseTriggers']), value: value.toJson()};
  }
  setPostPurchaseTriggers(path, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers']), value: ArrayToJson(value, InAppPurchaseData_IapTrigger)};
  }
  setPostPurchaseTriggersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers', key]), value: value.toJson()};
  }
  deletePostPurchaseTriggers(path) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers'])};
  }
  deletePostPurchaseTriggersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers', key])};
  }
  /**
   * @returns {InAppPurchaseData_Filter}
   */
  get enableFilter() {
    return this._hasEnableFilter ? this._enableFilter : InAppPurchaseData_Filter.default;
  }
  get hasEnableFilter() {
    return this._hasEnableFilter;
  }
  setEnableFilter(path, value) {
    return {type: 'SET', path: path.concat(['enableFilter']), value: value.toJson()};
  }
  deleteEnableFilter(path) {
    return {type: 'DELETE', path: path.concat(['enableFilter'])};
  }
  /**
   * @returns {string}
   */
  get asset() {
    return this._hasAsset ? this._asset : JsonToString.default;
  }
  get hasAsset() {
    return this._hasAsset;
  }
  setAsset(path, value) {
    return {type: 'SET', path: path.concat(['asset']), value};
  }
  deleteAsset(path) {
    return {type: 'DELETE', path: path.concat(['asset'])};
  }
  /**
   * @returns {number}
   */
  get unlockProgress() {
    return this._hasUnlockProgress ? this._unlockProgress : JsonToInt32.default;
  }
  get hasUnlockProgress() {
    return this._hasUnlockProgress;
  }
  setUnlockProgress(path, value) {
    return {type: 'SET', path: path.concat(['unlockProgress']), value};
  }
  deleteUnlockProgress(path) {
    return {type: 'DELETE', path: path.concat(['unlockProgress'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "discount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasDiscount = true;
              copy._discount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDiscount) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasDiscount = false;
              copy._discount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasPurchaseLimit = true;
              copy._purchaseLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseLimit) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasPurchaseLimit = false;
              copy._purchaseLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._cards = [];        for (let i of value) {
                copy._cards.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._cards = copy._cards.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cards.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._cards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._cards = copy._cards.slice();
              copy._cards[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._cards = copy._cards.slice(0, path[1]).concat(copy._cards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          const oldValue = this._cards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_CampaignSaleBundle(this);
          copy._cards = copy._cards.slice();
          copy._cards[key] = newValue;
          return copy;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InAppPurchaseData_BundleItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._items = copy._items.concat([InAppPurchaseData_BundleItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InAppPurchaseData_BundleItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_CampaignSaleBundle(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "postPurchaseTriggers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._postPurchaseTriggers = [];        for (let i of value) {
                copy._postPurchaseTriggers.push(InAppPurchaseData_IapTrigger.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.concat([InAppPurchaseData_IapTrigger.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._postPurchaseTriggers.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._postPurchaseTriggers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
              copy._postPurchaseTriggers[path[1]] = InAppPurchaseData_IapTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice(0, path[1]).concat(copy._postPurchaseTriggers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          const oldValue = this._postPurchaseTriggers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_CampaignSaleBundle(this);
          copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
          copy._postPurchaseTriggers[key] = newValue;
          return copy;
        }
      }
      case "enableFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasEnableFilter = true;
              copy._enableFilter = InAppPurchaseData_Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableFilter) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasEnableFilter = false;
              copy._enableFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEnableFilter) {
            const copy = new InAppPurchaseData_CampaignSaleBundle(this);
            copy._hasEnableFilter = true;
            copy._enableFilter = InAppPurchaseData_Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._enableFilter.apply(type, path.slice(1), value);
          if (newValue === this._enableFilter) {
            return this;
          }
          const copy = new InAppPurchaseData_CampaignSaleBundle(this);
          copy._enableFilter = copy._enableFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "asset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasAsset = true;
              copy._asset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasAsset = false;
              copy._asset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unlockProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasUnlockProgress = true;
              copy._unlockProgress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnlockProgress) {
                return this;
              }
              const copy = new InAppPurchaseData_CampaignSaleBundle(this);
              copy._hasUnlockProgress = false;
              copy._unlockProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_CampaignSaleBundle} other
   * @returns {InAppPurchaseData_CampaignSaleBundle}
   */
  merge(other) {
    const copy = new InAppPurchaseData_CampaignSaleBundle(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasDiscount) {
      copy._hasDiscount = true;
      copy._discount = other._discount;
    }
    if (other._hasPurchaseLimit) {
      copy._hasPurchaseLimit = true;
      copy._purchaseLimit = other._purchaseLimit;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    copy._cards = this._cards.concat(other._cards);
    copy._items = this._items.concat(other._items);
    copy._postPurchaseTriggers = this._postPurchaseTriggers.concat(other._postPurchaseTriggers);
    if (other._hasEnableFilter) {
      if (copy._hasEnableFilter) {
        copy._enableFilter = copy.enableFilter.merge(other.enableFilter);
      } else {
        copy._enableFilter = other._enableFilter;
      }
      copy._hasEnableFilter = true;
    }
    if (other._hasAsset) {
      copy._hasAsset = true;
      copy._asset = other._asset;
    }
    if (other._hasUnlockProgress) {
      copy._hasUnlockProgress = true;
      copy._unlockProgress = other._unlockProgress;
    }
    return copy;
  }
}
InAppPurchaseData_CampaignSaleBundle.default = new InAppPurchaseData_CampaignSaleBundle();
class InAppPurchaseData_CampaignSaleBundle_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_CampaignSaleBundle(value);
  }
  build() {
    return new InAppPurchaseData_CampaignSaleBundle(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setDiscount(value) {
    this._value._hasDiscount = true;
    this._value._discount = value;
    return this;
  }
  deleteDiscount() {
    this._value._hasDiscount = false;
    this._value._discount = null;
    return this;
  }
  setPurchaseLimit(value) {
    this._value._hasPurchaseLimit = true;
    this._value._purchaseLimit = value;
    return this;
  }
  deletePurchaseLimit() {
    this._value._hasPurchaseLimit = false;
    this._value._purchaseLimit = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  addAllCards(values) {
    this._value._cards = this._value._cards.concat(values);
    return this;
  }
  addCards(value) {
    this._value._cards = this._value._cards.concat([value]);
    return this;
  }
  setCards(index, value) {
    this._value._cards = this._value._cards.concat();
    this._value._cards[index] = value;
    return this;
  }
  clearCards() {
    this._value._cards = [];
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  addAllPostPurchaseTriggers(values) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat(values);
    return this;
  }
  addPostPurchaseTriggers(value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat([value]);
    return this;
  }
  setPostPurchaseTriggers(index, value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat();
    this._value._postPurchaseTriggers[index] = value;
    return this;
  }
  clearPostPurchaseTriggers() {
    this._value._postPurchaseTriggers = [];
    return this;
  }
  setEnableFilter(value) {
    this._value._hasEnableFilter = true;
    this._value._enableFilter = value;
    return this;
  }
  deleteEnableFilter() {
    this._value._hasEnableFilter = false;
    this._value._enableFilter = null;
    return this;
  }
  setAsset(value) {
    this._value._hasAsset = true;
    this._value._asset = value;
    return this;
  }
  deleteAsset() {
    this._value._hasAsset = false;
    this._value._asset = null;
    return this;
  }
  setUnlockProgress(value) {
    this._value._hasUnlockProgress = true;
    this._value._unlockProgress = value;
    return this;
  }
  deleteUnlockProgress() {
    this._value._hasUnlockProgress = false;
    this._value._unlockProgress = null;
    return this;
  }
}
InAppPurchaseData_CampaignSaleBundle.Builder = InAppPurchaseData_CampaignSaleBundle_Builder;
class InAppPurchaseData_CampaignSaleBundle_WithParent {
  /**
   * @param {InAppPurchaseData_CampaignSaleBundle} value
   * @param {InAppPurchaseData_CampaignSaleBundle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_CampaignSaleBundle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasDiscount() {
    if (this._cachedHasDiscount === undefined) {
      if (this._value.hasDiscount) {
        this._cachedHasDiscount = true;
      } else {
        this._cachedHasDiscount = this._parent ? this._parent.hasDiscount : false;
      }
    }
    return this._cachedHasDiscount;
  }
  get discount() {
    if (this._cachedDiscount === undefined) {
      if (this._value.hasDiscount) {
        this._cachedDiscount = this._value.discount;
      } else {
        this._cachedDiscount = this._parent ? this._parent.discount : this._value.discount;
      }
    }
    return this._cachedDiscount;
  }
  get hasPurchaseLimit() {
    if (this._cachedHasPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedHasPurchaseLimit = true;
      } else {
        this._cachedHasPurchaseLimit = this._parent ? this._parent.hasPurchaseLimit : false;
      }
    }
    return this._cachedHasPurchaseLimit;
  }
  get purchaseLimit() {
    if (this._cachedPurchaseLimit === undefined) {
      if (this._value.hasPurchaseLimit) {
        this._cachedPurchaseLimit = this._value.purchaseLimit;
      } else {
        this._cachedPurchaseLimit = this._parent ? this._parent.purchaseLimit : this._value.purchaseLimit;
      }
    }
    return this._cachedPurchaseLimit;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get selfCards() {
    return this._value.cards;
  }
  get inherentCards() {
    if (!this._inherentCards) {
      this._inherentCards = this._parent ? this._parent.cards : [];
    }
    return this._inherentCards;
  }
  get cards() {
    if (!this._allCards) {
      this._allCards = this._parent ? this._parent.cards.concat(this.selfCards) : this.selfCards;
    }
    return this._allCards;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InAppPurchaseData_BundleItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get selfPostPurchaseTriggers() {
    if (!this._selfPostPurchaseTriggers) {
      this._selfPostPurchaseTriggers = [];
      for (let i of this._value.postPurchaseTriggers) {
        this._selfPostPurchaseTriggers.push(new InAppPurchaseData_IapTrigger.WithParent(i, null));
      }
    }
    return this._selfPostPurchaseTriggers;
  }
  get inherentPostPurchaseTriggers() {
    if (!this._inherentPostPurchaseTriggers) {
      this._inherentPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers : [];
    }
    return this._inherentPostPurchaseTriggers;
  }
  get postPurchaseTriggers() {
    if (!this._allPostPurchaseTriggers) {
      this._allPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers.concat(this.selfPostPurchaseTriggers) : this.selfPostPurchaseTriggers;
    }
    return this._allPostPurchaseTriggers;
  }
  get hasEnableFilter() {
    if (this._cachedHasEnableFilter === undefined) {
      if (this._value.hasEnableFilter) {
        this._cachedHasEnableFilter = true;
      } else {
        this._cachedHasEnableFilter = this._parent ? this._parent.hasEnableFilter : false;
      }
    }
    return this._cachedHasEnableFilter;
  }
  get enableFilter() {
    if (!this._cachedEnableFilter) {
      if (this._value.hasEnableFilter) {
        this._cachedEnableFilter = new InAppPurchaseData_Filter.WithParent(this._value.enableFilter, this._parent && this._parent.hasEnableFilter ? this._parent.enableFilter : null);
      } else {
        this._cachedEnableFilter = this._parent ? new InAppPurchaseData_Filter.WithParent(InAppPurchaseData_Filter.default, this._parent.enableFilter) : InAppPurchaseData_Filter.WithParent.default;
      }
    }
    return this._cachedEnableFilter;
  }
  get hasAsset() {
    if (this._cachedHasAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedHasAsset = true;
      } else {
        this._cachedHasAsset = this._parent ? this._parent.hasAsset : false;
      }
    }
    return this._cachedHasAsset;
  }
  get asset() {
    if (this._cachedAsset === undefined) {
      if (this._value.hasAsset) {
        this._cachedAsset = this._value.asset;
      } else {
        this._cachedAsset = this._parent ? this._parent.asset : this._value.asset;
      }
    }
    return this._cachedAsset;
  }
  get hasUnlockProgress() {
    if (this._cachedHasUnlockProgress === undefined) {
      if (this._value.hasUnlockProgress) {
        this._cachedHasUnlockProgress = true;
      } else {
        this._cachedHasUnlockProgress = this._parent ? this._parent.hasUnlockProgress : false;
      }
    }
    return this._cachedHasUnlockProgress;
  }
  get unlockProgress() {
    if (this._cachedUnlockProgress === undefined) {
      if (this._value.hasUnlockProgress) {
        this._cachedUnlockProgress = this._value.unlockProgress;
      } else {
        this._cachedUnlockProgress = this._parent ? this._parent.unlockProgress : this._value.unlockProgress;
      }
    }
    return this._cachedUnlockProgress;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_CampaignSaleBundle_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InAppPurchaseData_BundleItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfPostPurchaseTriggers) {
      if (this._value.postPurchaseTriggers === current.postPurchaseTriggers) {
        result._selfPostPurchaseTriggers = this._selfPostPurchaseTriggers;
      } else {
        result._selfPostPurchaseTriggers = [];
        for (let i = 0; i < current.postPurchaseTriggers.length; i++) {
          const oldValue = this._value.postPurchaseTriggers[i];
          if (oldValue) {
            const oldCache = this._selfPostPurchaseTriggers[i];
            if (oldValue === current.postPurchaseTriggers[i]) {
              result._selfPostPurchaseTriggers[i] = oldCache;
            } else {
              result._selfPostPurchaseTriggers[i] = oldCache.update(current.postPurchaseTriggers[i], null);
            }
          } else {
            result._selfPostPurchaseTriggers[i] = new InAppPurchaseData_IapTrigger.WithParent(current.postPurchaseTriggers[i], null);
          }
        }
      }
    }
    if (this._cachedEnableFilter && this._value.hasEnableFilter && current.hasEnableFilter) {
      if (this._value.enableFilter === current.enableFilter && this._parent === parent) {
        result._cachedEnableFilter = this._cachedEnableFilter;
      } else {
        result._cachedEnableFilter = this._cachedEnableFilter.update(current.enableFilter, parent && parent.hasEnableFilter ? parent.enableFilter : null);
      }
    }
    return result;
  }
}
InAppPurchaseData_CampaignSaleBundle_WithParent.default = new InAppPurchaseData_CampaignSaleBundle_WithParent(InAppPurchaseData_CampaignSaleBundle.default, null);
InAppPurchaseData_CampaignSaleBundle.WithParent = InAppPurchaseData_CampaignSaleBundle_WithParent;
class InAppPurchaseData_CampaignSaleBundle_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 3,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
          comments: "If currency key is defined, this is amount of inventory item, otherwise it\'s price in US dollers.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get discount() {
    if (!this._discount) {
      this._discount = {
        name: "discount",
        Name: "Discount",
        number: 4,
        protoType: 1,
        protoName: "discount",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._discount;
  }
  get purchaseLimit() {
    if (!this._purchaseLimit) {
      this._purchaseLimit = {
        name: "purchaseLimit",
        Name: "PurchaseLimit",
        number: 5,
        protoType: 5,
        protoName: "purchase_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseLimit;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 6,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get cards() {
    if (!this._cards) {
      this._cards = {
        name: "cards",
        Name: "Cards",
        number: 7,
        protoType: 9,
        protoName: "cards",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cards;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 8,
        protoType: 11,
        protoName: "items",
        type: InAppPurchaseData_BundleItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get postPurchaseTriggers() {
    if (!this._postPurchaseTriggers) {
      this._postPurchaseTriggers = {
        name: "postPurchaseTriggers",
        Name: "PostPurchaseTriggers",
        number: 16,
        protoType: 11,
        protoName: "post_purchase_triggers",
        type: InAppPurchaseData_IapTrigger,
        isRepeated: true,
        options: {
          comments: "Products that will be triggered after hide",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postPurchaseTriggers;
  }
  get enableFilter() {
    if (!this._enableFilter) {
      this._enableFilter = {
        name: "enableFilter",
        Name: "EnableFilter",
        number: 18,
        protoType: 11,
        protoName: "enable_filter",
        type: InAppPurchaseData_Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableFilter;
  }
  get asset() {
    if (!this._asset) {
      this._asset = {
        name: "asset",
        Name: "Asset",
        number: 20,
        protoType: 9,
        protoName: "asset",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleAssetList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._asset;
  }
  get unlockProgress() {
    if (!this._unlockProgress) {
      this._unlockProgress = {
        name: "unlockProgress",
        Name: "UnlockProgress",
        number: 23,
        protoType: 5,
        protoName: "unlock_progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockProgress;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
        this.displayName,
        this.price,
        this.discount,
        this.purchaseLimit,
        this.duration,
        this.cards,
        this.items,
        this.postPurchaseTriggers,
        this.enableFilter,
        this.asset,
        this.unlockProgress,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDiscount",
        Name: "DummyOneofForDiscount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseLimit",
        Name: "DummyOneofForPurchaseLimit",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableFilter",
        Name: "DummyOneofForEnableFilter",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAsset",
        Name: "DummyOneofForAsset",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnlockProgress",
        Name: "DummyOneofForUnlockProgress",
        fields: [
          this.fields[11],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_CampaignSaleBundle.descriptor = new InAppPurchaseData_CampaignSaleBundle_Descriptor();
class InAppPurchaseData_Product {
  get descriptor() {
    return InAppPurchaseData_Product.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasId = false;
    this._id = null;
    this._hasGems = false;
    this._gems = null;
    this._hasIcon = false;
    this._icon = null;
    this._hasUnbonusedGems = false;
    this._unbonusedGems = null;
    this._hasUsDollars = false;
    this._usDollars = null;
    this._hasTabKey = false;
    this._tabKey = null;
  }
  isEmpty() {
    if (this._hasId) return false;
    if (this._hasGems) return false;
    if (this._hasIcon) return false;
    if (this._hasUnbonusedGems) return false;
    if (this._hasUsDollars) return false;
    if (this._hasTabKey) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_Product) {
      return value;
    }
    return InAppPurchaseData_Product.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_Product();
    if (json.id != null) {
      result._hasId = true;
      result._id = JsonToString.fromJson(json.id);
    }
    if (json.gems != null) {
      result._hasGems = true;
      result._gems = JsonToInt32.fromJson(json.gems);
    }
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    if (json.unbonusedGems != null) {
      result._hasUnbonusedGems = true;
      result._unbonusedGems = JsonToInt32.fromJson(json.unbonusedGems);
    }
    if (json.usDollars != null) {
      result._hasUsDollars = true;
      result._usDollars = JsonToDouble.fromJson(json.usDollars);
    }
    if (json.tabKey != null) {
      result._hasTabKey = true;
      result._tabKey = JsonToString.fromJson(json.tabKey);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasId) {
      result.id = JsonToString.toJson(this._id);
    }
    if (this._hasGems) {
      result.gems = JsonToInt32.toJson(this._gems);
    }
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    if (this._hasUnbonusedGems) {
      result.unbonusedGems = JsonToInt32.toJson(this._unbonusedGems);
    }
    if (this._hasUsDollars) {
      result.usDollars = JsonToDouble.toJson(this._usDollars);
    }
    if (this._hasTabKey) {
      result.tabKey = JsonToString.toJson(this._tabKey);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get id() {
    return this._hasId ? this._id : JsonToString.default;
  }
  get hasId() {
    return this._hasId;
  }
  setId(path, value) {
    return {type: 'SET', path: path.concat(['id']), value};
  }
  deleteId(path) {
    return {type: 'DELETE', path: path.concat(['id'])};
  }
  /**
   * @returns {number}
   */
  get gems() {
    return this._hasGems ? this._gems : JsonToInt32.default;
  }
  get hasGems() {
    return this._hasGems;
  }
  setGems(path, value) {
    return {type: 'SET', path: path.concat(['gems']), value};
  }
  deleteGems(path) {
    return {type: 'DELETE', path: path.concat(['gems'])};
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  /**
   * @returns {number}
   */
  get unbonusedGems() {
    return this._hasUnbonusedGems ? this._unbonusedGems : JsonToInt32.default;
  }
  get hasUnbonusedGems() {
    return this._hasUnbonusedGems;
  }
  setUnbonusedGems(path, value) {
    return {type: 'SET', path: path.concat(['unbonusedGems']), value};
  }
  deleteUnbonusedGems(path) {
    return {type: 'DELETE', path: path.concat(['unbonusedGems'])};
  }
  /**
   * @returns {number}
   */
  get usDollars() {
    return this._hasUsDollars ? this._usDollars : JsonToDouble.default;
  }
  get hasUsDollars() {
    return this._hasUsDollars;
  }
  setUsDollars(path, value) {
    return {type: 'SET', path: path.concat(['usDollars']), value};
  }
  deleteUsDollars(path) {
    return {type: 'DELETE', path: path.concat(['usDollars'])};
  }
  /**
   * @returns {string}
   */
  get tabKey() {
    return this._hasTabKey ? this._tabKey : JsonToString.default;
  }
  get hasTabKey() {
    return this._hasTabKey;
  }
  setTabKey(path, value) {
    return {type: 'SET', path: path.concat(['tabKey']), value};
  }
  deleteTabKey(path) {
    return {type: 'DELETE', path: path.concat(['tabKey'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "id": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Product(this);
              copy._hasId = true;
              copy._id = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasId) {
                return this;
              }
              const copy = new InAppPurchaseData_Product(this);
              copy._hasId = false;
              copy._id = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Product(this);
              copy._hasGems = true;
              copy._gems = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGems) {
                return this;
              }
              const copy = new InAppPurchaseData_Product(this);
              copy._hasGems = false;
              copy._gems = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Product(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new InAppPurchaseData_Product(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unbonusedGems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Product(this);
              copy._hasUnbonusedGems = true;
              copy._unbonusedGems = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnbonusedGems) {
                return this;
              }
              const copy = new InAppPurchaseData_Product(this);
              copy._hasUnbonusedGems = false;
              copy._unbonusedGems = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "usDollars": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Product(this);
              copy._hasUsDollars = true;
              copy._usDollars = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUsDollars) {
                return this;
              }
              const copy = new InAppPurchaseData_Product(this);
              copy._hasUsDollars = false;
              copy._usDollars = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tabKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_Product(this);
              copy._hasTabKey = true;
              copy._tabKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTabKey) {
                return this;
              }
              const copy = new InAppPurchaseData_Product(this);
              copy._hasTabKey = false;
              copy._tabKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_Product} other
   * @returns {InAppPurchaseData_Product}
   */
  merge(other) {
    const copy = new InAppPurchaseData_Product(this);
    if (other._hasId) {
      copy._hasId = true;
      copy._id = other._id;
    }
    if (other._hasGems) {
      copy._hasGems = true;
      copy._gems = other._gems;
    }
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    if (other._hasUnbonusedGems) {
      copy._hasUnbonusedGems = true;
      copy._unbonusedGems = other._unbonusedGems;
    }
    if (other._hasUsDollars) {
      copy._hasUsDollars = true;
      copy._usDollars = other._usDollars;
    }
    if (other._hasTabKey) {
      copy._hasTabKey = true;
      copy._tabKey = other._tabKey;
    }
    return copy;
  }
}
InAppPurchaseData_Product.default = new InAppPurchaseData_Product();
class InAppPurchaseData_Product_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_Product(value);
  }
  build() {
    return new InAppPurchaseData_Product(this._value);
  }
  setId(value) {
    this._value._hasId = true;
    this._value._id = value;
    return this;
  }
  deleteId() {
    this._value._hasId = false;
    this._value._id = null;
    return this;
  }
  setGems(value) {
    this._value._hasGems = true;
    this._value._gems = value;
    return this;
  }
  deleteGems() {
    this._value._hasGems = false;
    this._value._gems = null;
    return this;
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
  setUnbonusedGems(value) {
    this._value._hasUnbonusedGems = true;
    this._value._unbonusedGems = value;
    return this;
  }
  deleteUnbonusedGems() {
    this._value._hasUnbonusedGems = false;
    this._value._unbonusedGems = null;
    return this;
  }
  setUsDollars(value) {
    this._value._hasUsDollars = true;
    this._value._usDollars = value;
    return this;
  }
  deleteUsDollars() {
    this._value._hasUsDollars = false;
    this._value._usDollars = null;
    return this;
  }
  setTabKey(value) {
    this._value._hasTabKey = true;
    this._value._tabKey = value;
    return this;
  }
  deleteTabKey() {
    this._value._hasTabKey = false;
    this._value._tabKey = null;
    return this;
  }
}
InAppPurchaseData_Product.Builder = InAppPurchaseData_Product_Builder;
class InAppPurchaseData_Product_WithParent {
  /**
   * @param {InAppPurchaseData_Product} value
   * @param {InAppPurchaseData_Product_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_Product.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasId() {
    if (this._cachedHasId === undefined) {
      if (this._value.hasId) {
        this._cachedHasId = true;
      } else {
        this._cachedHasId = this._parent ? this._parent.hasId : false;
      }
    }
    return this._cachedHasId;
  }
  get id() {
    if (this._cachedId === undefined) {
      if (this._value.hasId) {
        this._cachedId = this._value.id;
      } else {
        this._cachedId = this._parent ? this._parent.id : this._value.id;
      }
    }
    return this._cachedId;
  }
  get hasGems() {
    if (this._cachedHasGems === undefined) {
      if (this._value.hasGems) {
        this._cachedHasGems = true;
      } else {
        this._cachedHasGems = this._parent ? this._parent.hasGems : false;
      }
    }
    return this._cachedHasGems;
  }
  get gems() {
    if (this._cachedGems === undefined) {
      if (this._value.hasGems) {
        this._cachedGems = this._value.gems;
      } else {
        this._cachedGems = this._parent ? this._parent.gems : this._value.gems;
      }
    }
    return this._cachedGems;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  get hasUnbonusedGems() {
    if (this._cachedHasUnbonusedGems === undefined) {
      if (this._value.hasUnbonusedGems) {
        this._cachedHasUnbonusedGems = true;
      } else {
        this._cachedHasUnbonusedGems = this._parent ? this._parent.hasUnbonusedGems : false;
      }
    }
    return this._cachedHasUnbonusedGems;
  }
  get unbonusedGems() {
    if (this._cachedUnbonusedGems === undefined) {
      if (this._value.hasUnbonusedGems) {
        this._cachedUnbonusedGems = this._value.unbonusedGems;
      } else {
        this._cachedUnbonusedGems = this._parent ? this._parent.unbonusedGems : this._value.unbonusedGems;
      }
    }
    return this._cachedUnbonusedGems;
  }
  get hasUsDollars() {
    if (this._cachedHasUsDollars === undefined) {
      if (this._value.hasUsDollars) {
        this._cachedHasUsDollars = true;
      } else {
        this._cachedHasUsDollars = this._parent ? this._parent.hasUsDollars : false;
      }
    }
    return this._cachedHasUsDollars;
  }
  get usDollars() {
    if (this._cachedUsDollars === undefined) {
      if (this._value.hasUsDollars) {
        this._cachedUsDollars = this._value.usDollars;
      } else {
        this._cachedUsDollars = this._parent ? this._parent.usDollars : this._value.usDollars;
      }
    }
    return this._cachedUsDollars;
  }
  get hasTabKey() {
    if (this._cachedHasTabKey === undefined) {
      if (this._value.hasTabKey) {
        this._cachedHasTabKey = true;
      } else {
        this._cachedHasTabKey = this._parent ? this._parent.hasTabKey : false;
      }
    }
    return this._cachedHasTabKey;
  }
  get tabKey() {
    if (this._cachedTabKey === undefined) {
      if (this._value.hasTabKey) {
        this._cachedTabKey = this._value.tabKey;
      } else {
        this._cachedTabKey = this._parent ? this._parent.tabKey : this._value.tabKey;
      }
    }
    return this._cachedTabKey;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_Product_WithParent(current, parent);
    return result;
  }
}
InAppPurchaseData_Product_WithParent.default = new InAppPurchaseData_Product_WithParent(InAppPurchaseData_Product.default, null);
InAppPurchaseData_Product.WithParent = InAppPurchaseData_Product_WithParent;
class InAppPurchaseData_Product_Descriptor {
  get id() {
    if (!this._id) {
      this._id = {
        name: "id",
        Name: "Id",
        number: 1,
        protoType: 9,
        protoName: "id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._id;
  }
  get gems() {
    if (!this._gems) {
      this._gems = {
        name: "gems",
        Name: "Gems",
        number: 2,
        protoType: 5,
        protoName: "gems",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gems;
  }
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 3,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          valueDropdown: "InAppPurchaseIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get unbonusedGems() {
    if (!this._unbonusedGems) {
      this._unbonusedGems = {
        name: "unbonusedGems",
        Name: "UnbonusedGems",
        number: 4,
        protoType: 5,
        protoName: "unbonused_gems",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unbonusedGems;
  }
  get usDollars() {
    if (!this._usDollars) {
      this._usDollars = {
        name: "usDollars",
        Name: "UsDollars",
        number: 5,
        protoType: 1,
        protoName: "us_dollars",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usDollars;
  }
  get tabKey() {
    if (!this._tabKey) {
      this._tabKey = {
        name: "tabKey",
        Name: "TabKey",
        number: 21,
        protoType: 9,
        protoName: "tab_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabKey;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.id,
        this.gems,
        this.icon,
        this.unbonusedGems,
        this.usDollars,
        this.tabKey,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForId",
        Name: "DummyOneofForId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGems",
        Name: "DummyOneofForGems",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnbonusedGems",
        Name: "DummyOneofForUnbonusedGems",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUsDollars",
        Name: "DummyOneofForUsDollars",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTabKey",
        Name: "DummyOneofForTabKey",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_Product.descriptor = new InAppPurchaseData_Product_Descriptor();
class InAppPurchaseData_DealBundle {
  get descriptor() {
    return InAppPurchaseData_DealBundle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProductId = false;
    this._productId = null;
    this._hasPrice = false;
    this._price = null;
    this._hasLimit = false;
    this._limit = null;
    this._hasPurchaseTimes = false;
    this._purchaseTimes = null;
    this._items = [];
    this._hasFeaturePackTemplatePrefab = false;
    this._featurePackTemplatePrefab = null;
    this._postPurchaseTriggers = [];
    this._hasBundleDescription = false;
    this._bundleDescription = null;
    this._hasBackgroundAsset = false;
    this._backgroundAsset = null;
  }
  isEmpty() {
    if (this._hasProductId) return false;
    if (this._hasPrice) return false;
    if (this._hasLimit) return false;
    if (this._hasPurchaseTimes) return false;
    if (this._items.length > 0) return false;
    if (this._hasFeaturePackTemplatePrefab) return false;
    if (this._postPurchaseTriggers.length > 0) return false;
    if (this._hasBundleDescription) return false;
    if (this._hasBackgroundAsset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DealBundle) {
      return value;
    }
    return InAppPurchaseData_DealBundle.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DealBundle();
    if (json.productId != null) {
      result._hasProductId = true;
      result._productId = JsonToString.fromJson(json.productId);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.limit != null) {
      result._hasLimit = true;
      result._limit = JsonToInt32.fromJson(json.limit);
    }
    if (json.purchaseTimes != null) {
      result._hasPurchaseTimes = true;
      result._purchaseTimes = JsonToInt32.fromJson(json.purchaseTimes);
    }
    result._items = JsonToList(json.items, InAppPurchaseData_BundleItem);
    if (json.featurePackTemplatePrefab != null) {
      result._hasFeaturePackTemplatePrefab = true;
      result._featurePackTemplatePrefab = JsonToString.fromJson(json.featurePackTemplatePrefab);
    }
    result._postPurchaseTriggers = JsonToList(json.postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    if (json.bundleDescription != null) {
      result._hasBundleDescription = true;
      result._bundleDescription = JsonToString.fromJson(json.bundleDescription);
    }
    if (json.backgroundAsset != null) {
      result._hasBackgroundAsset = true;
      result._backgroundAsset = JsonToString.fromJson(json.backgroundAsset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProductId) {
      result.productId = JsonToString.toJson(this._productId);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasLimit) {
      result.limit = JsonToInt32.toJson(this._limit);
    }
    if (this._hasPurchaseTimes) {
      result.purchaseTimes = JsonToInt32.toJson(this._purchaseTimes);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InAppPurchaseData_BundleItem);
    }
    if (this._hasFeaturePackTemplatePrefab) {
      result.featurePackTemplatePrefab = JsonToString.toJson(this._featurePackTemplatePrefab);
    }
    if (this._postPurchaseTriggers.length > 0) {
      result.postPurchaseTriggers = ArrayToJson(this._postPurchaseTriggers, InAppPurchaseData_IapTrigger);
    }
    if (this._hasBundleDescription) {
      result.bundleDescription = JsonToString.toJson(this._bundleDescription);
    }
    if (this._hasBackgroundAsset) {
      result.backgroundAsset = JsonToString.toJson(this._backgroundAsset);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get productId() {
    return this._hasProductId ? this._productId : JsonToString.default;
  }
  get hasProductId() {
    return this._hasProductId;
  }
  setProductId(path, value) {
    return {type: 'SET', path: path.concat(['productId']), value};
  }
  deleteProductId(path) {
    return {type: 'DELETE', path: path.concat(['productId'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get limit() {
    return this._hasLimit ? this._limit : JsonToInt32.default;
  }
  get hasLimit() {
    return this._hasLimit;
  }
  setLimit(path, value) {
    return {type: 'SET', path: path.concat(['limit']), value};
  }
  deleteLimit(path) {
    return {type: 'DELETE', path: path.concat(['limit'])};
  }
  /**
   * @returns {number}
   */
  get purchaseTimes() {
    return this._hasPurchaseTimes ? this._purchaseTimes : JsonToInt32.default;
  }
  get hasPurchaseTimes() {
    return this._hasPurchaseTimes;
  }
  setPurchaseTimes(path, value) {
    return {type: 'SET', path: path.concat(['purchaseTimes']), value};
  }
  deletePurchaseTimes(path) {
    return {type: 'DELETE', path: path.concat(['purchaseTimes'])};
  }
  /**
   * @returns {InAppPurchaseData_BundleItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InAppPurchaseData_BundleItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {string}
   */
  get featurePackTemplatePrefab() {
    return this._hasFeaturePackTemplatePrefab ? this._featurePackTemplatePrefab : JsonToString.default;
  }
  get hasFeaturePackTemplatePrefab() {
    return this._hasFeaturePackTemplatePrefab;
  }
  setFeaturePackTemplatePrefab(path, value) {
    return {type: 'SET', path: path.concat(['featurePackTemplatePrefab']), value};
  }
  deleteFeaturePackTemplatePrefab(path) {
    return {type: 'DELETE', path: path.concat(['featurePackTemplatePrefab'])};
  }
  /**
   * @returns {InAppPurchaseData_IapTrigger[]}
   */
  get postPurchaseTriggers() {
    return this._postPurchaseTriggers;
  }
  addPostPurchaseTriggers(path, value) {
    return {type: 'ADD', path: path.concat(['postPurchaseTriggers']), value: value.toJson()};
  }
  setPostPurchaseTriggers(path, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers']), value: ArrayToJson(value, InAppPurchaseData_IapTrigger)};
  }
  setPostPurchaseTriggersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['postPurchaseTriggers', key]), value: value.toJson()};
  }
  deletePostPurchaseTriggers(path) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers'])};
  }
  deletePostPurchaseTriggersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['postPurchaseTriggers', key])};
  }
  /**
   * @returns {string}
   */
  get bundleDescription() {
    return this._hasBundleDescription ? this._bundleDescription : JsonToString.default;
  }
  get hasBundleDescription() {
    return this._hasBundleDescription;
  }
  setBundleDescription(path, value) {
    return {type: 'SET', path: path.concat(['bundleDescription']), value};
  }
  deleteBundleDescription(path) {
    return {type: 'DELETE', path: path.concat(['bundleDescription'])};
  }
  /**
   * @returns {string}
   */
  get backgroundAsset() {
    return this._hasBackgroundAsset ? this._backgroundAsset : JsonToString.default;
  }
  get hasBackgroundAsset() {
    return this._hasBackgroundAsset;
  }
  setBackgroundAsset(path, value) {
    return {type: 'SET', path: path.concat(['backgroundAsset']), value};
  }
  deleteBackgroundAsset(path) {
    return {type: 'DELETE', path: path.concat(['backgroundAsset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "productId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasProductId = true;
              copy._productId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProductId) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasProductId = false;
              copy._productId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "limit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasLimit = true;
              copy._limit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLimit) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasLimit = false;
              copy._limit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseTimes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasPurchaseTimes = true;
              copy._purchaseTimes = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseTimes) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasPurchaseTimes = false;
              copy._purchaseTimes = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InAppPurchaseData_BundleItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._items = copy._items.concat([InAppPurchaseData_BundleItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InAppPurchaseData_BundleItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealBundle(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "featurePackTemplatePrefab": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasFeaturePackTemplatePrefab = true;
              copy._featurePackTemplatePrefab = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeaturePackTemplatePrefab) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasFeaturePackTemplatePrefab = false;
              copy._featurePackTemplatePrefab = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "postPurchaseTriggers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._postPurchaseTriggers = [];        for (let i of value) {
                copy._postPurchaseTriggers.push(InAppPurchaseData_IapTrigger.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.concat([InAppPurchaseData_IapTrigger.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._postPurchaseTriggers.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._postPurchaseTriggers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
              copy._postPurchaseTriggers[path[1]] = InAppPurchaseData_IapTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice(0, path[1]).concat(copy._postPurchaseTriggers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._postPurchaseTriggers.length) {
            return this;
          }
          const oldValue = this._postPurchaseTriggers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealBundle(this);
          copy._postPurchaseTriggers = copy._postPurchaseTriggers.slice();
          copy._postPurchaseTriggers[key] = newValue;
          return copy;
        }
      }
      case "bundleDescription": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasBundleDescription = true;
              copy._bundleDescription = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBundleDescription) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasBundleDescription = false;
              copy._bundleDescription = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "backgroundAsset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasBackgroundAsset = true;
              copy._backgroundAsset = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBackgroundAsset) {
                return this;
              }
              const copy = new InAppPurchaseData_DealBundle(this);
              copy._hasBackgroundAsset = false;
              copy._backgroundAsset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DealBundle} other
   * @returns {InAppPurchaseData_DealBundle}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DealBundle(this);
    if (other._hasProductId) {
      copy._hasProductId = true;
      copy._productId = other._productId;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasLimit) {
      copy._hasLimit = true;
      copy._limit = other._limit;
    }
    if (other._hasPurchaseTimes) {
      copy._hasPurchaseTimes = true;
      copy._purchaseTimes = other._purchaseTimes;
    }
    copy._items = this._items.concat(other._items);
    if (other._hasFeaturePackTemplatePrefab) {
      copy._hasFeaturePackTemplatePrefab = true;
      copy._featurePackTemplatePrefab = other._featurePackTemplatePrefab;
    }
    copy._postPurchaseTriggers = this._postPurchaseTriggers.concat(other._postPurchaseTriggers);
    if (other._hasBundleDescription) {
      copy._hasBundleDescription = true;
      copy._bundleDescription = other._bundleDescription;
    }
    if (other._hasBackgroundAsset) {
      copy._hasBackgroundAsset = true;
      copy._backgroundAsset = other._backgroundAsset;
    }
    return copy;
  }
}
InAppPurchaseData_DealBundle.default = new InAppPurchaseData_DealBundle();
class InAppPurchaseData_DealBundle_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DealBundle(value);
  }
  build() {
    return new InAppPurchaseData_DealBundle(this._value);
  }
  setProductId(value) {
    this._value._hasProductId = true;
    this._value._productId = value;
    return this;
  }
  deleteProductId() {
    this._value._hasProductId = false;
    this._value._productId = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setLimit(value) {
    this._value._hasLimit = true;
    this._value._limit = value;
    return this;
  }
  deleteLimit() {
    this._value._hasLimit = false;
    this._value._limit = null;
    return this;
  }
  setPurchaseTimes(value) {
    this._value._hasPurchaseTimes = true;
    this._value._purchaseTimes = value;
    return this;
  }
  deletePurchaseTimes() {
    this._value._hasPurchaseTimes = false;
    this._value._purchaseTimes = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  setFeaturePackTemplatePrefab(value) {
    this._value._hasFeaturePackTemplatePrefab = true;
    this._value._featurePackTemplatePrefab = value;
    return this;
  }
  deleteFeaturePackTemplatePrefab() {
    this._value._hasFeaturePackTemplatePrefab = false;
    this._value._featurePackTemplatePrefab = null;
    return this;
  }
  addAllPostPurchaseTriggers(values) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat(values);
    return this;
  }
  addPostPurchaseTriggers(value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat([value]);
    return this;
  }
  setPostPurchaseTriggers(index, value) {
    this._value._postPurchaseTriggers = this._value._postPurchaseTriggers.concat();
    this._value._postPurchaseTriggers[index] = value;
    return this;
  }
  clearPostPurchaseTriggers() {
    this._value._postPurchaseTriggers = [];
    return this;
  }
  setBundleDescription(value) {
    this._value._hasBundleDescription = true;
    this._value._bundleDescription = value;
    return this;
  }
  deleteBundleDescription() {
    this._value._hasBundleDescription = false;
    this._value._bundleDescription = null;
    return this;
  }
  setBackgroundAsset(value) {
    this._value._hasBackgroundAsset = true;
    this._value._backgroundAsset = value;
    return this;
  }
  deleteBackgroundAsset() {
    this._value._hasBackgroundAsset = false;
    this._value._backgroundAsset = null;
    return this;
  }
}
InAppPurchaseData_DealBundle.Builder = InAppPurchaseData_DealBundle_Builder;
class InAppPurchaseData_DealBundle_WithParent {
  /**
   * @param {InAppPurchaseData_DealBundle} value
   * @param {InAppPurchaseData_DealBundle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DealBundle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProductId() {
    if (this._cachedHasProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedHasProductId = true;
      } else {
        this._cachedHasProductId = this._parent ? this._parent.hasProductId : false;
      }
    }
    return this._cachedHasProductId;
  }
  get productId() {
    if (this._cachedProductId === undefined) {
      if (this._value.hasProductId) {
        this._cachedProductId = this._value.productId;
      } else {
        this._cachedProductId = this._parent ? this._parent.productId : this._value.productId;
      }
    }
    return this._cachedProductId;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasLimit() {
    if (this._cachedHasLimit === undefined) {
      if (this._value.hasLimit) {
        this._cachedHasLimit = true;
      } else {
        this._cachedHasLimit = this._parent ? this._parent.hasLimit : false;
      }
    }
    return this._cachedHasLimit;
  }
  get limit() {
    if (this._cachedLimit === undefined) {
      if (this._value.hasLimit) {
        this._cachedLimit = this._value.limit;
      } else {
        this._cachedLimit = this._parent ? this._parent.limit : this._value.limit;
      }
    }
    return this._cachedLimit;
  }
  get hasPurchaseTimes() {
    if (this._cachedHasPurchaseTimes === undefined) {
      if (this._value.hasPurchaseTimes) {
        this._cachedHasPurchaseTimes = true;
      } else {
        this._cachedHasPurchaseTimes = this._parent ? this._parent.hasPurchaseTimes : false;
      }
    }
    return this._cachedHasPurchaseTimes;
  }
  get purchaseTimes() {
    if (this._cachedPurchaseTimes === undefined) {
      if (this._value.hasPurchaseTimes) {
        this._cachedPurchaseTimes = this._value.purchaseTimes;
      } else {
        this._cachedPurchaseTimes = this._parent ? this._parent.purchaseTimes : this._value.purchaseTimes;
      }
    }
    return this._cachedPurchaseTimes;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InAppPurchaseData_BundleItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get hasFeaturePackTemplatePrefab() {
    if (this._cachedHasFeaturePackTemplatePrefab === undefined) {
      if (this._value.hasFeaturePackTemplatePrefab) {
        this._cachedHasFeaturePackTemplatePrefab = true;
      } else {
        this._cachedHasFeaturePackTemplatePrefab = this._parent ? this._parent.hasFeaturePackTemplatePrefab : false;
      }
    }
    return this._cachedHasFeaturePackTemplatePrefab;
  }
  get featurePackTemplatePrefab() {
    if (this._cachedFeaturePackTemplatePrefab === undefined) {
      if (this._value.hasFeaturePackTemplatePrefab) {
        this._cachedFeaturePackTemplatePrefab = this._value.featurePackTemplatePrefab;
      } else {
        this._cachedFeaturePackTemplatePrefab = this._parent ? this._parent.featurePackTemplatePrefab : this._value.featurePackTemplatePrefab;
      }
    }
    return this._cachedFeaturePackTemplatePrefab;
  }
  get selfPostPurchaseTriggers() {
    if (!this._selfPostPurchaseTriggers) {
      this._selfPostPurchaseTriggers = [];
      for (let i of this._value.postPurchaseTriggers) {
        this._selfPostPurchaseTriggers.push(new InAppPurchaseData_IapTrigger.WithParent(i, null));
      }
    }
    return this._selfPostPurchaseTriggers;
  }
  get inherentPostPurchaseTriggers() {
    if (!this._inherentPostPurchaseTriggers) {
      this._inherentPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers : [];
    }
    return this._inherentPostPurchaseTriggers;
  }
  get postPurchaseTriggers() {
    if (!this._allPostPurchaseTriggers) {
      this._allPostPurchaseTriggers = this._parent ? this._parent.postPurchaseTriggers.concat(this.selfPostPurchaseTriggers) : this.selfPostPurchaseTriggers;
    }
    return this._allPostPurchaseTriggers;
  }
  get hasBundleDescription() {
    if (this._cachedHasBundleDescription === undefined) {
      if (this._value.hasBundleDescription) {
        this._cachedHasBundleDescription = true;
      } else {
        this._cachedHasBundleDescription = this._parent ? this._parent.hasBundleDescription : false;
      }
    }
    return this._cachedHasBundleDescription;
  }
  get bundleDescription() {
    if (this._cachedBundleDescription === undefined) {
      if (this._value.hasBundleDescription) {
        this._cachedBundleDescription = this._value.bundleDescription;
      } else {
        this._cachedBundleDescription = this._parent ? this._parent.bundleDescription : this._value.bundleDescription;
      }
    }
    return this._cachedBundleDescription;
  }
  get hasBackgroundAsset() {
    if (this._cachedHasBackgroundAsset === undefined) {
      if (this._value.hasBackgroundAsset) {
        this._cachedHasBackgroundAsset = true;
      } else {
        this._cachedHasBackgroundAsset = this._parent ? this._parent.hasBackgroundAsset : false;
      }
    }
    return this._cachedHasBackgroundAsset;
  }
  get backgroundAsset() {
    if (this._cachedBackgroundAsset === undefined) {
      if (this._value.hasBackgroundAsset) {
        this._cachedBackgroundAsset = this._value.backgroundAsset;
      } else {
        this._cachedBackgroundAsset = this._parent ? this._parent.backgroundAsset : this._value.backgroundAsset;
      }
    }
    return this._cachedBackgroundAsset;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DealBundle_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InAppPurchaseData_BundleItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfPostPurchaseTriggers) {
      if (this._value.postPurchaseTriggers === current.postPurchaseTriggers) {
        result._selfPostPurchaseTriggers = this._selfPostPurchaseTriggers;
      } else {
        result._selfPostPurchaseTriggers = [];
        for (let i = 0; i < current.postPurchaseTriggers.length; i++) {
          const oldValue = this._value.postPurchaseTriggers[i];
          if (oldValue) {
            const oldCache = this._selfPostPurchaseTriggers[i];
            if (oldValue === current.postPurchaseTriggers[i]) {
              result._selfPostPurchaseTriggers[i] = oldCache;
            } else {
              result._selfPostPurchaseTriggers[i] = oldCache.update(current.postPurchaseTriggers[i], null);
            }
          } else {
            result._selfPostPurchaseTriggers[i] = new InAppPurchaseData_IapTrigger.WithParent(current.postPurchaseTriggers[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_DealBundle_WithParent.default = new InAppPurchaseData_DealBundle_WithParent(InAppPurchaseData_DealBundle.default, null);
InAppPurchaseData_DealBundle.WithParent = InAppPurchaseData_DealBundle_WithParent;
class InAppPurchaseData_DealBundle_Descriptor {
  get productId() {
    if (!this._productId) {
      this._productId = {
        name: "productId",
        Name: "ProductId",
        number: 1,
        protoType: 9,
        protoName: "product_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._productId;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 2,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get limit() {
    if (!this._limit) {
      this._limit = {
        name: "limit",
        Name: "Limit",
        number: 3,
        protoType: 5,
        protoName: "limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._limit;
  }
  get purchaseTimes() {
    if (!this._purchaseTimes) {
      this._purchaseTimes = {
        name: "purchaseTimes",
        Name: "PurchaseTimes",
        number: 4,
        protoType: 5,
        protoName: "purchase_times",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseTimes;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 5,
        protoType: 11,
        protoName: "items",
        type: InAppPurchaseData_BundleItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get featurePackTemplatePrefab() {
    if (!this._featurePackTemplatePrefab) {
      this._featurePackTemplatePrefab = {
        name: "featurePackTemplatePrefab",
        Name: "FeaturePackTemplatePrefab",
        number: 6,
        protoType: 9,
        protoName: "feature_pack_template_prefab",
        type: JsonToString,
        options: {
          valueDropdown: "DealPageFeaturePackTemplatePrefab",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featurePackTemplatePrefab;
  }
  get postPurchaseTriggers() {
    if (!this._postPurchaseTriggers) {
      this._postPurchaseTriggers = {
        name: "postPurchaseTriggers",
        Name: "PostPurchaseTriggers",
        number: 7,
        protoType: 11,
        protoName: "post_purchase_triggers",
        type: InAppPurchaseData_IapTrigger,
        isRepeated: true,
        options: {
          comments: "Products that will be triggered after purchase",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postPurchaseTriggers;
  }
  get bundleDescription() {
    if (!this._bundleDescription) {
      this._bundleDescription = {
        name: "bundleDescription",
        Name: "BundleDescription",
        number: 8,
        protoType: 9,
        protoName: "bundle_description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleDescription;
  }
  get backgroundAsset() {
    if (!this._backgroundAsset) {
      this._backgroundAsset = {
        name: "backgroundAsset",
        Name: "BackgroundAsset",
        number: 9,
        protoType: 9,
        protoName: "background_asset",
        type: JsonToString,
        options: {
          valueDropdown: "DealPageBundleBackgroundAssets",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._backgroundAsset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.productId,
        this.price,
        this.limit,
        this.purchaseTimes,
        this.items,
        this.featurePackTemplatePrefab,
        this.postPurchaseTriggers,
        this.bundleDescription,
        this.backgroundAsset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProductId",
        Name: "DummyOneofForProductId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLimit",
        Name: "DummyOneofForLimit",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseTimes",
        Name: "DummyOneofForPurchaseTimes",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeaturePackTemplatePrefab",
        Name: "DummyOneofForFeaturePackTemplatePrefab",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBundleDescription",
        Name: "DummyOneofForBundleDescription",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBackgroundAsset",
        Name: "DummyOneofForBackgroundAsset",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DealBundle.descriptor = new InAppPurchaseData_DealBundle_Descriptor();
class InAppPurchaseData_DealGroup_LevelGroup {
  get descriptor() {
    return InAppPurchaseData_DealGroup_LevelGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevelMin = false;
    this._playerLevelMin = null;
    this._hasPlayerLevelMax = false;
    this._playerLevelMax = null;
    this._bundleGroups = [];
  }
  isEmpty() {
    if (this._hasPlayerLevelMin) return false;
    if (this._hasPlayerLevelMax) return false;
    if (this._bundleGroups.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DealGroup_LevelGroup) {
      return value;
    }
    return InAppPurchaseData_DealGroup_LevelGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DealGroup_LevelGroup();
    if (json.playerLevelMin != null) {
      result._hasPlayerLevelMin = true;
      result._playerLevelMin = JsonToInt32.fromJson(json.playerLevelMin);
    }
    if (json.playerLevelMax != null) {
      result._hasPlayerLevelMax = true;
      result._playerLevelMax = JsonToInt32.fromJson(json.playerLevelMax);
    }
    result._bundleGroups = JsonToList(json.bundleGroups, InAppPurchaseData_DealGroup_BundleGroup);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevelMin) {
      result.playerLevelMin = JsonToInt32.toJson(this._playerLevelMin);
    }
    if (this._hasPlayerLevelMax) {
      result.playerLevelMax = JsonToInt32.toJson(this._playerLevelMax);
    }
    if (this._bundleGroups.length > 0) {
      result.bundleGroups = ArrayToJson(this._bundleGroups, InAppPurchaseData_DealGroup_BundleGroup);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get playerLevelMin() {
    return this._hasPlayerLevelMin ? this._playerLevelMin : JsonToInt32.default;
  }
  get hasPlayerLevelMin() {
    return this._hasPlayerLevelMin;
  }
  setPlayerLevelMin(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelMin']), value};
  }
  deletePlayerLevelMin(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelMin'])};
  }
  /**
   * @returns {number}
   */
  get playerLevelMax() {
    return this._hasPlayerLevelMax ? this._playerLevelMax : JsonToInt32.default;
  }
  get hasPlayerLevelMax() {
    return this._hasPlayerLevelMax;
  }
  setPlayerLevelMax(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelMax']), value};
  }
  deletePlayerLevelMax(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelMax'])};
  }
  /**
   * @returns {InAppPurchaseData_DealGroup_BundleGroup[]}
   */
  get bundleGroups() {
    return this._bundleGroups;
  }
  addBundleGroups(path, value) {
    return {type: 'ADD', path: path.concat(['bundleGroups']), value: value.toJson()};
  }
  setBundleGroups(path, value) {
    return {type: 'SET', path: path.concat(['bundleGroups']), value: ArrayToJson(value, InAppPurchaseData_DealGroup_BundleGroup)};
  }
  setBundleGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleGroups', key]), value: value.toJson()};
  }
  deleteBundleGroups(path) {
    return {type: 'DELETE', path: path.concat(['bundleGroups'])};
  }
  deleteBundleGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleGroups', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevelMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._hasPlayerLevelMin = true;
              copy._playerLevelMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevelMin) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._hasPlayerLevelMin = false;
              copy._playerLevelMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._hasPlayerLevelMax = true;
              copy._playerLevelMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevelMax) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._hasPlayerLevelMax = false;
              copy._playerLevelMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bundleGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._bundleGroups = [];        for (let i of value) {
                copy._bundleGroups.push(InAppPurchaseData_DealGroup_BundleGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._bundleGroups = copy._bundleGroups.concat([InAppPurchaseData_DealGroup_BundleGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleGroups.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._bundleGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._bundleGroups = copy._bundleGroups.slice();
              copy._bundleGroups[path[1]] = InAppPurchaseData_DealGroup_BundleGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
              copy._bundleGroups = copy._bundleGroups.slice(0, path[1]).concat(copy._bundleGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleGroups.length) {
            return this;
          }
          const oldValue = this._bundleGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
          copy._bundleGroups = copy._bundleGroups.slice();
          copy._bundleGroups[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DealGroup_LevelGroup} other
   * @returns {InAppPurchaseData_DealGroup_LevelGroup}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DealGroup_LevelGroup(this);
    if (other._hasPlayerLevelMin) {
      copy._hasPlayerLevelMin = true;
      copy._playerLevelMin = other._playerLevelMin;
    }
    if (other._hasPlayerLevelMax) {
      copy._hasPlayerLevelMax = true;
      copy._playerLevelMax = other._playerLevelMax;
    }
    copy._bundleGroups = this._bundleGroups.concat(other._bundleGroups);
    return copy;
  }
}
InAppPurchaseData_DealGroup_LevelGroup.default = new InAppPurchaseData_DealGroup_LevelGroup();
class InAppPurchaseData_DealGroup_LevelGroup_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DealGroup_LevelGroup(value);
  }
  build() {
    return new InAppPurchaseData_DealGroup_LevelGroup(this._value);
  }
  setPlayerLevelMin(value) {
    this._value._hasPlayerLevelMin = true;
    this._value._playerLevelMin = value;
    return this;
  }
  deletePlayerLevelMin() {
    this._value._hasPlayerLevelMin = false;
    this._value._playerLevelMin = null;
    return this;
  }
  setPlayerLevelMax(value) {
    this._value._hasPlayerLevelMax = true;
    this._value._playerLevelMax = value;
    return this;
  }
  deletePlayerLevelMax() {
    this._value._hasPlayerLevelMax = false;
    this._value._playerLevelMax = null;
    return this;
  }
  addAllBundleGroups(values) {
    this._value._bundleGroups = this._value._bundleGroups.concat(values);
    return this;
  }
  addBundleGroups(value) {
    this._value._bundleGroups = this._value._bundleGroups.concat([value]);
    return this;
  }
  setBundleGroups(index, value) {
    this._value._bundleGroups = this._value._bundleGroups.concat();
    this._value._bundleGroups[index] = value;
    return this;
  }
  clearBundleGroups() {
    this._value._bundleGroups = [];
    return this;
  }
}
InAppPurchaseData_DealGroup_LevelGroup.Builder = InAppPurchaseData_DealGroup_LevelGroup_Builder;
class InAppPurchaseData_DealGroup_LevelGroup_WithParent {
  /**
   * @param {InAppPurchaseData_DealGroup_LevelGroup} value
   * @param {InAppPurchaseData_DealGroup_LevelGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DealGroup_LevelGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevelMin() {
    if (this._cachedHasPlayerLevelMin === undefined) {
      if (this._value.hasPlayerLevelMin) {
        this._cachedHasPlayerLevelMin = true;
      } else {
        this._cachedHasPlayerLevelMin = this._parent ? this._parent.hasPlayerLevelMin : false;
      }
    }
    return this._cachedHasPlayerLevelMin;
  }
  get playerLevelMin() {
    if (this._cachedPlayerLevelMin === undefined) {
      if (this._value.hasPlayerLevelMin) {
        this._cachedPlayerLevelMin = this._value.playerLevelMin;
      } else {
        this._cachedPlayerLevelMin = this._parent ? this._parent.playerLevelMin : this._value.playerLevelMin;
      }
    }
    return this._cachedPlayerLevelMin;
  }
  get hasPlayerLevelMax() {
    if (this._cachedHasPlayerLevelMax === undefined) {
      if (this._value.hasPlayerLevelMax) {
        this._cachedHasPlayerLevelMax = true;
      } else {
        this._cachedHasPlayerLevelMax = this._parent ? this._parent.hasPlayerLevelMax : false;
      }
    }
    return this._cachedHasPlayerLevelMax;
  }
  get playerLevelMax() {
    if (this._cachedPlayerLevelMax === undefined) {
      if (this._value.hasPlayerLevelMax) {
        this._cachedPlayerLevelMax = this._value.playerLevelMax;
      } else {
        this._cachedPlayerLevelMax = this._parent ? this._parent.playerLevelMax : this._value.playerLevelMax;
      }
    }
    return this._cachedPlayerLevelMax;
  }
  get selfBundleGroups() {
    if (!this._selfBundleGroups) {
      this._selfBundleGroups = [];
      for (let i of this._value.bundleGroups) {
        this._selfBundleGroups.push(new InAppPurchaseData_DealGroup_BundleGroup.WithParent(i, null));
      }
    }
    return this._selfBundleGroups;
  }
  get inherentBundleGroups() {
    if (!this._inherentBundleGroups) {
      this._inherentBundleGroups = this._parent ? this._parent.bundleGroups : [];
    }
    return this._inherentBundleGroups;
  }
  get bundleGroups() {
    if (!this._allBundleGroups) {
      this._allBundleGroups = this._parent ? this._parent.bundleGroups.concat(this.selfBundleGroups) : this.selfBundleGroups;
    }
    return this._allBundleGroups;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DealGroup_LevelGroup_WithParent(current, parent);
    if (this._selfBundleGroups) {
      if (this._value.bundleGroups === current.bundleGroups) {
        result._selfBundleGroups = this._selfBundleGroups;
      } else {
        result._selfBundleGroups = [];
        for (let i = 0; i < current.bundleGroups.length; i++) {
          const oldValue = this._value.bundleGroups[i];
          if (oldValue) {
            const oldCache = this._selfBundleGroups[i];
            if (oldValue === current.bundleGroups[i]) {
              result._selfBundleGroups[i] = oldCache;
            } else {
              result._selfBundleGroups[i] = oldCache.update(current.bundleGroups[i], null);
            }
          } else {
            result._selfBundleGroups[i] = new InAppPurchaseData_DealGroup_BundleGroup.WithParent(current.bundleGroups[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_DealGroup_LevelGroup_WithParent.default = new InAppPurchaseData_DealGroup_LevelGroup_WithParent(InAppPurchaseData_DealGroup_LevelGroup.default, null);
InAppPurchaseData_DealGroup_LevelGroup.WithParent = InAppPurchaseData_DealGroup_LevelGroup_WithParent;
class InAppPurchaseData_DealGroup_LevelGroup_Descriptor {
  get playerLevelMin() {
    if (!this._playerLevelMin) {
      this._playerLevelMin = {
        name: "playerLevelMin",
        Name: "PlayerLevelMin",
        number: 1,
        protoType: 5,
        protoName: "player_level_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelMin;
  }
  get playerLevelMax() {
    if (!this._playerLevelMax) {
      this._playerLevelMax = {
        name: "playerLevelMax",
        Name: "PlayerLevelMax",
        number: 2,
        protoType: 5,
        protoName: "player_level_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelMax;
  }
  get bundleGroups() {
    if (!this._bundleGroups) {
      this._bundleGroups = {
        name: "bundleGroups",
        Name: "BundleGroups",
        number: 3,
        protoType: 11,
        protoName: "bundle_groups",
        type: InAppPurchaseData_DealGroup_BundleGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleGroups;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevelMin,
        this.playerLevelMax,
        this.bundleGroups,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevelMin",
        Name: "DummyOneofForPlayerLevelMin",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerLevelMax",
        Name: "DummyOneofForPlayerLevelMax",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DealGroup_LevelGroup.descriptor = new InAppPurchaseData_DealGroup_LevelGroup_Descriptor();
class InAppPurchaseData_DealGroup_OneTimeGroup {
  get descriptor() {
    return InAppPurchaseData_DealGroup_OneTimeGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._bundleIds = [];
    this._hasDurationTimeSeconds = false;
    this._durationTimeSeconds = null;
  }
  isEmpty() {
    if (this._bundleIds.length > 0) return false;
    if (this._hasDurationTimeSeconds) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DealGroup_OneTimeGroup) {
      return value;
    }
    return InAppPurchaseData_DealGroup_OneTimeGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DealGroup_OneTimeGroup();
    result._bundleIds = JsonToList(json.bundleIds, JsonToString);
    if (json.durationTimeSeconds != null) {
      result._hasDurationTimeSeconds = true;
      result._durationTimeSeconds = JsonToInt32.fromJson(json.durationTimeSeconds);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._bundleIds.length > 0) {
      result.bundleIds = ArrayToJson(this._bundleIds, JsonToString);
    }
    if (this._hasDurationTimeSeconds) {
      result.durationTimeSeconds = JsonToInt32.toJson(this._durationTimeSeconds);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get bundleIds() {
    return this._bundleIds;
  }
  addBundleIds(path, value) {
    return {type: 'ADD', path: path.concat(['bundleIds']), value};
  }
  setBundleIds(path, value) {
    return {type: 'SET', path: path.concat(['bundleIds']), value: ArrayToJson(value, JsonToString)};
  }
  setBundleIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleIds', key]), value};
  }
  deleteBundleIds(path) {
    return {type: 'DELETE', path: path.concat(['bundleIds'])};
  }
  deleteBundleIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleIds', key])};
  }
  /**
   * @returns {number}
   */
  get durationTimeSeconds() {
    return this._hasDurationTimeSeconds ? this._durationTimeSeconds : JsonToInt32.default;
  }
  get hasDurationTimeSeconds() {
    return this._hasDurationTimeSeconds;
  }
  setDurationTimeSeconds(path, value) {
    return {type: 'SET', path: path.concat(['durationTimeSeconds']), value};
  }
  deleteDurationTimeSeconds(path) {
    return {type: 'DELETE', path: path.concat(['durationTimeSeconds'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "bundleIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._bundleIds = [];        for (let i of value) {
                copy._bundleIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._bundleIds = copy._bundleIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleIds.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._bundleIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._bundleIds = copy._bundleIds.slice();
              copy._bundleIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._bundleIds = copy._bundleIds.slice(0, path[1]).concat(copy._bundleIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          const oldValue = this._bundleIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
          copy._bundleIds = copy._bundleIds.slice();
          copy._bundleIds[key] = newValue;
          return copy;
        }
      }
      case "durationTimeSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._hasDurationTimeSeconds = true;
              copy._durationTimeSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDurationTimeSeconds) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
              copy._hasDurationTimeSeconds = false;
              copy._durationTimeSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DealGroup_OneTimeGroup} other
   * @returns {InAppPurchaseData_DealGroup_OneTimeGroup}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DealGroup_OneTimeGroup(this);
    copy._bundleIds = this._bundleIds.concat(other._bundleIds);
    if (other._hasDurationTimeSeconds) {
      copy._hasDurationTimeSeconds = true;
      copy._durationTimeSeconds = other._durationTimeSeconds;
    }
    return copy;
  }
}
InAppPurchaseData_DealGroup_OneTimeGroup.default = new InAppPurchaseData_DealGroup_OneTimeGroup();
class InAppPurchaseData_DealGroup_OneTimeGroup_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DealGroup_OneTimeGroup(value);
  }
  build() {
    return new InAppPurchaseData_DealGroup_OneTimeGroup(this._value);
  }
  addAllBundleIds(values) {
    this._value._bundleIds = this._value._bundleIds.concat(values);
    return this;
  }
  addBundleIds(value) {
    this._value._bundleIds = this._value._bundleIds.concat([value]);
    return this;
  }
  setBundleIds(index, value) {
    this._value._bundleIds = this._value._bundleIds.concat();
    this._value._bundleIds[index] = value;
    return this;
  }
  clearBundleIds() {
    this._value._bundleIds = [];
    return this;
  }
  setDurationTimeSeconds(value) {
    this._value._hasDurationTimeSeconds = true;
    this._value._durationTimeSeconds = value;
    return this;
  }
  deleteDurationTimeSeconds() {
    this._value._hasDurationTimeSeconds = false;
    this._value._durationTimeSeconds = null;
    return this;
  }
}
InAppPurchaseData_DealGroup_OneTimeGroup.Builder = InAppPurchaseData_DealGroup_OneTimeGroup_Builder;
class InAppPurchaseData_DealGroup_OneTimeGroup_WithParent {
  /**
   * @param {InAppPurchaseData_DealGroup_OneTimeGroup} value
   * @param {InAppPurchaseData_DealGroup_OneTimeGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DealGroup_OneTimeGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfBundleIds() {
    return this._value.bundleIds;
  }
  get inherentBundleIds() {
    if (!this._inherentBundleIds) {
      this._inherentBundleIds = this._parent ? this._parent.bundleIds : [];
    }
    return this._inherentBundleIds;
  }
  get bundleIds() {
    if (!this._allBundleIds) {
      this._allBundleIds = this._parent ? this._parent.bundleIds.concat(this.selfBundleIds) : this.selfBundleIds;
    }
    return this._allBundleIds;
  }
  get hasDurationTimeSeconds() {
    if (this._cachedHasDurationTimeSeconds === undefined) {
      if (this._value.hasDurationTimeSeconds) {
        this._cachedHasDurationTimeSeconds = true;
      } else {
        this._cachedHasDurationTimeSeconds = this._parent ? this._parent.hasDurationTimeSeconds : false;
      }
    }
    return this._cachedHasDurationTimeSeconds;
  }
  get durationTimeSeconds() {
    if (this._cachedDurationTimeSeconds === undefined) {
      if (this._value.hasDurationTimeSeconds) {
        this._cachedDurationTimeSeconds = this._value.durationTimeSeconds;
      } else {
        this._cachedDurationTimeSeconds = this._parent ? this._parent.durationTimeSeconds : this._value.durationTimeSeconds;
      }
    }
    return this._cachedDurationTimeSeconds;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DealGroup_OneTimeGroup_WithParent(current, parent);
    return result;
  }
}
InAppPurchaseData_DealGroup_OneTimeGroup_WithParent.default = new InAppPurchaseData_DealGroup_OneTimeGroup_WithParent(InAppPurchaseData_DealGroup_OneTimeGroup.default, null);
InAppPurchaseData_DealGroup_OneTimeGroup.WithParent = InAppPurchaseData_DealGroup_OneTimeGroup_WithParent;
class InAppPurchaseData_DealGroup_OneTimeGroup_Descriptor {
  get bundleIds() {
    if (!this._bundleIds) {
      this._bundleIds = {
        name: "bundleIds",
        Name: "BundleIds",
        number: 1,
        protoType: 9,
        protoName: "bundle_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "DealBundleIds",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleIds;
  }
  get durationTimeSeconds() {
    if (!this._durationTimeSeconds) {
      this._durationTimeSeconds = {
        name: "durationTimeSeconds",
        Name: "DurationTimeSeconds",
        number: 2,
        protoType: 5,
        protoName: "duration_time_seconds",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._durationTimeSeconds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.bundleIds,
        this.durationTimeSeconds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDurationTimeSeconds",
        Name: "DummyOneofForDurationTimeSeconds",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DealGroup_OneTimeGroup.descriptor = new InAppPurchaseData_DealGroup_OneTimeGroup_Descriptor();
class InAppPurchaseData_DealGroup_BundleGroup {
  get descriptor() {
    return InAppPurchaseData_DealGroup_BundleGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._bundleIds = [];
    this._hasStartTime = false;
    this._startTime = null;
    this._hasEndTime = false;
    this._endTime = null;
  }
  isEmpty() {
    if (this._bundleIds.length > 0) return false;
    if (this._hasStartTime) return false;
    if (this._hasEndTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DealGroup_BundleGroup) {
      return value;
    }
    return InAppPurchaseData_DealGroup_BundleGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DealGroup_BundleGroup();
    result._bundleIds = JsonToList(json.bundleIds, JsonToString);
    if (json.startTime != null) {
      result._hasStartTime = true;
      result._startTime = JsonToInt32.fromJson(json.startTime);
    }
    if (json.endTime != null) {
      result._hasEndTime = true;
      result._endTime = JsonToInt32.fromJson(json.endTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._bundleIds.length > 0) {
      result.bundleIds = ArrayToJson(this._bundleIds, JsonToString);
    }
    if (this._hasStartTime) {
      result.startTime = JsonToInt32.toJson(this._startTime);
    }
    if (this._hasEndTime) {
      result.endTime = JsonToInt32.toJson(this._endTime);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get bundleIds() {
    return this._bundleIds;
  }
  addBundleIds(path, value) {
    return {type: 'ADD', path: path.concat(['bundleIds']), value};
  }
  setBundleIds(path, value) {
    return {type: 'SET', path: path.concat(['bundleIds']), value: ArrayToJson(value, JsonToString)};
  }
  setBundleIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleIds', key]), value};
  }
  deleteBundleIds(path) {
    return {type: 'DELETE', path: path.concat(['bundleIds'])};
  }
  deleteBundleIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleIds', key])};
  }
  /**
   * @returns {number}
   */
  get startTime() {
    return this._hasStartTime ? this._startTime : JsonToInt32.default;
  }
  get hasStartTime() {
    return this._hasStartTime;
  }
  setStartTime(path, value) {
    return {type: 'SET', path: path.concat(['startTime']), value};
  }
  deleteStartTime(path) {
    return {type: 'DELETE', path: path.concat(['startTime'])};
  }
  /**
   * @returns {number}
   */
  get endTime() {
    return this._hasEndTime ? this._endTime : JsonToInt32.default;
  }
  get hasEndTime() {
    return this._hasEndTime;
  }
  setEndTime(path, value) {
    return {type: 'SET', path: path.concat(['endTime']), value};
  }
  deleteEndTime(path) {
    return {type: 'DELETE', path: path.concat(['endTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "bundleIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._bundleIds = [];        for (let i of value) {
                copy._bundleIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._bundleIds = copy._bundleIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleIds.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._bundleIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._bundleIds = copy._bundleIds.slice();
              copy._bundleIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._bundleIds = copy._bundleIds.slice(0, path[1]).concat(copy._bundleIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          const oldValue = this._bundleIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
          copy._bundleIds = copy._bundleIds.slice();
          copy._bundleIds[key] = newValue;
          return copy;
        }
      }
      case "startTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._hasStartTime = true;
              copy._startTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartTime) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._hasStartTime = false;
              copy._startTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "endTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._hasEndTime = true;
              copy._endTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEndTime) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
              copy._hasEndTime = false;
              copy._endTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DealGroup_BundleGroup} other
   * @returns {InAppPurchaseData_DealGroup_BundleGroup}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DealGroup_BundleGroup(this);
    copy._bundleIds = this._bundleIds.concat(other._bundleIds);
    if (other._hasStartTime) {
      copy._hasStartTime = true;
      copy._startTime = other._startTime;
    }
    if (other._hasEndTime) {
      copy._hasEndTime = true;
      copy._endTime = other._endTime;
    }
    return copy;
  }
}
InAppPurchaseData_DealGroup_BundleGroup.default = new InAppPurchaseData_DealGroup_BundleGroup();
class InAppPurchaseData_DealGroup_BundleGroup_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DealGroup_BundleGroup(value);
  }
  build() {
    return new InAppPurchaseData_DealGroup_BundleGroup(this._value);
  }
  addAllBundleIds(values) {
    this._value._bundleIds = this._value._bundleIds.concat(values);
    return this;
  }
  addBundleIds(value) {
    this._value._bundleIds = this._value._bundleIds.concat([value]);
    return this;
  }
  setBundleIds(index, value) {
    this._value._bundleIds = this._value._bundleIds.concat();
    this._value._bundleIds[index] = value;
    return this;
  }
  clearBundleIds() {
    this._value._bundleIds = [];
    return this;
  }
  setStartTime(value) {
    this._value._hasStartTime = true;
    this._value._startTime = value;
    return this;
  }
  deleteStartTime() {
    this._value._hasStartTime = false;
    this._value._startTime = null;
    return this;
  }
  setEndTime(value) {
    this._value._hasEndTime = true;
    this._value._endTime = value;
    return this;
  }
  deleteEndTime() {
    this._value._hasEndTime = false;
    this._value._endTime = null;
    return this;
  }
}
InAppPurchaseData_DealGroup_BundleGroup.Builder = InAppPurchaseData_DealGroup_BundleGroup_Builder;
class InAppPurchaseData_DealGroup_BundleGroup_WithParent {
  /**
   * @param {InAppPurchaseData_DealGroup_BundleGroup} value
   * @param {InAppPurchaseData_DealGroup_BundleGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DealGroup_BundleGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfBundleIds() {
    return this._value.bundleIds;
  }
  get inherentBundleIds() {
    if (!this._inherentBundleIds) {
      this._inherentBundleIds = this._parent ? this._parent.bundleIds : [];
    }
    return this._inherentBundleIds;
  }
  get bundleIds() {
    if (!this._allBundleIds) {
      this._allBundleIds = this._parent ? this._parent.bundleIds.concat(this.selfBundleIds) : this.selfBundleIds;
    }
    return this._allBundleIds;
  }
  get hasStartTime() {
    if (this._cachedHasStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedHasStartTime = true;
      } else {
        this._cachedHasStartTime = this._parent ? this._parent.hasStartTime : false;
      }
    }
    return this._cachedHasStartTime;
  }
  get startTime() {
    if (this._cachedStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedStartTime = this._value.startTime;
      } else {
        this._cachedStartTime = this._parent ? this._parent.startTime : this._value.startTime;
      }
    }
    return this._cachedStartTime;
  }
  get hasEndTime() {
    if (this._cachedHasEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedHasEndTime = true;
      } else {
        this._cachedHasEndTime = this._parent ? this._parent.hasEndTime : false;
      }
    }
    return this._cachedHasEndTime;
  }
  get endTime() {
    if (this._cachedEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedEndTime = this._value.endTime;
      } else {
        this._cachedEndTime = this._parent ? this._parent.endTime : this._value.endTime;
      }
    }
    return this._cachedEndTime;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DealGroup_BundleGroup_WithParent(current, parent);
    return result;
  }
}
InAppPurchaseData_DealGroup_BundleGroup_WithParent.default = new InAppPurchaseData_DealGroup_BundleGroup_WithParent(InAppPurchaseData_DealGroup_BundleGroup.default, null);
InAppPurchaseData_DealGroup_BundleGroup.WithParent = InAppPurchaseData_DealGroup_BundleGroup_WithParent;
class InAppPurchaseData_DealGroup_BundleGroup_Descriptor {
  get bundleIds() {
    if (!this._bundleIds) {
      this._bundleIds = {
        name: "bundleIds",
        Name: "BundleIds",
        number: 1,
        protoType: 9,
        protoName: "bundle_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "DealBundleIds",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleIds;
  }
  get startTime() {
    if (!this._startTime) {
      this._startTime = {
        name: "startTime",
        Name: "StartTime",
        number: 2,
        protoType: 5,
        protoName: "start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startTime;
  }
  get endTime() {
    if (!this._endTime) {
      this._endTime = {
        name: "endTime",
        Name: "EndTime",
        number: 3,
        protoType: 5,
        protoName: "end_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._endTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.bundleIds,
        this.startTime,
        this.endTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStartTime",
        Name: "DummyOneofForStartTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEndTime",
        Name: "DummyOneofForEndTime",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DealGroup_BundleGroup.descriptor = new InAppPurchaseData_DealGroup_BundleGroup_Descriptor();
class InAppPurchaseData_DealGroup_CalendarGroup {
  get descriptor() {
    return InAppPurchaseData_DealGroup_CalendarGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._levelGroups = [];
  }
  isEmpty() {
    if (this._levelGroups.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DealGroup_CalendarGroup) {
      return value;
    }
    return InAppPurchaseData_DealGroup_CalendarGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DealGroup_CalendarGroup();
    result._levelGroups = JsonToList(json.levelGroups, InAppPurchaseData_DealGroup_LevelGroup);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._levelGroups.length > 0) {
      result.levelGroups = ArrayToJson(this._levelGroups, InAppPurchaseData_DealGroup_LevelGroup);
    }
    return result;
  }
  /**
   * @returns {InAppPurchaseData_DealGroup_LevelGroup[]}
   */
  get levelGroups() {
    return this._levelGroups;
  }
  addLevelGroups(path, value) {
    return {type: 'ADD', path: path.concat(['levelGroups']), value: value.toJson()};
  }
  setLevelGroups(path, value) {
    return {type: 'SET', path: path.concat(['levelGroups']), value: ArrayToJson(value, InAppPurchaseData_DealGroup_LevelGroup)};
  }
  setLevelGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levelGroups', key]), value: value.toJson()};
  }
  deleteLevelGroups(path) {
    return {type: 'DELETE', path: path.concat(['levelGroups'])};
  }
  deleteLevelGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levelGroups', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levelGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
              copy._levelGroups = [];        for (let i of value) {
                copy._levelGroups.push(InAppPurchaseData_DealGroup_LevelGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
              copy._levelGroups = copy._levelGroups.concat([InAppPurchaseData_DealGroup_LevelGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levelGroups.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
              copy._levelGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levelGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
              copy._levelGroups = copy._levelGroups.slice();
              copy._levelGroups[path[1]] = InAppPurchaseData_DealGroup_LevelGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
              copy._levelGroups = copy._levelGroups.slice(0, path[1]).concat(copy._levelGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levelGroups.length) {
            return this;
          }
          const oldValue = this._levelGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
          copy._levelGroups = copy._levelGroups.slice();
          copy._levelGroups[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DealGroup_CalendarGroup} other
   * @returns {InAppPurchaseData_DealGroup_CalendarGroup}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DealGroup_CalendarGroup(this);
    copy._levelGroups = this._levelGroups.concat(other._levelGroups);
    return copy;
  }
}
InAppPurchaseData_DealGroup_CalendarGroup.default = new InAppPurchaseData_DealGroup_CalendarGroup();
class InAppPurchaseData_DealGroup_CalendarGroup_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DealGroup_CalendarGroup(value);
  }
  build() {
    return new InAppPurchaseData_DealGroup_CalendarGroup(this._value);
  }
  addAllLevelGroups(values) {
    this._value._levelGroups = this._value._levelGroups.concat(values);
    return this;
  }
  addLevelGroups(value) {
    this._value._levelGroups = this._value._levelGroups.concat([value]);
    return this;
  }
  setLevelGroups(index, value) {
    this._value._levelGroups = this._value._levelGroups.concat();
    this._value._levelGroups[index] = value;
    return this;
  }
  clearLevelGroups() {
    this._value._levelGroups = [];
    return this;
  }
}
InAppPurchaseData_DealGroup_CalendarGroup.Builder = InAppPurchaseData_DealGroup_CalendarGroup_Builder;
class InAppPurchaseData_DealGroup_CalendarGroup_WithParent {
  /**
   * @param {InAppPurchaseData_DealGroup_CalendarGroup} value
   * @param {InAppPurchaseData_DealGroup_CalendarGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DealGroup_CalendarGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLevelGroups() {
    if (!this._selfLevelGroups) {
      this._selfLevelGroups = [];
      for (let i of this._value.levelGroups) {
        this._selfLevelGroups.push(new InAppPurchaseData_DealGroup_LevelGroup.WithParent(i, null));
      }
    }
    return this._selfLevelGroups;
  }
  get inherentLevelGroups() {
    if (!this._inherentLevelGroups) {
      this._inherentLevelGroups = this._parent ? this._parent.levelGroups : [];
    }
    return this._inherentLevelGroups;
  }
  get levelGroups() {
    if (!this._allLevelGroups) {
      this._allLevelGroups = this._parent ? this._parent.levelGroups.concat(this.selfLevelGroups) : this.selfLevelGroups;
    }
    return this._allLevelGroups;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DealGroup_CalendarGroup_WithParent(current, parent);
    if (this._selfLevelGroups) {
      if (this._value.levelGroups === current.levelGroups) {
        result._selfLevelGroups = this._selfLevelGroups;
      } else {
        result._selfLevelGroups = [];
        for (let i = 0; i < current.levelGroups.length; i++) {
          const oldValue = this._value.levelGroups[i];
          if (oldValue) {
            const oldCache = this._selfLevelGroups[i];
            if (oldValue === current.levelGroups[i]) {
              result._selfLevelGroups[i] = oldCache;
            } else {
              result._selfLevelGroups[i] = oldCache.update(current.levelGroups[i], null);
            }
          } else {
            result._selfLevelGroups[i] = new InAppPurchaseData_DealGroup_LevelGroup.WithParent(current.levelGroups[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_DealGroup_CalendarGroup_WithParent.default = new InAppPurchaseData_DealGroup_CalendarGroup_WithParent(InAppPurchaseData_DealGroup_CalendarGroup.default, null);
InAppPurchaseData_DealGroup_CalendarGroup.WithParent = InAppPurchaseData_DealGroup_CalendarGroup_WithParent;
class InAppPurchaseData_DealGroup_CalendarGroup_Descriptor {
  get levelGroups() {
    if (!this._levelGroups) {
      this._levelGroups = {
        name: "levelGroups",
        Name: "LevelGroups",
        number: 1,
        protoType: 11,
        protoName: "level_groups",
        type: InAppPurchaseData_DealGroup_LevelGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelGroups;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levelGroups,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DealGroup_CalendarGroup.descriptor = new InAppPurchaseData_DealGroup_CalendarGroup_Descriptor();
class InAppPurchaseData_DealGroup {
  get descriptor() {
    return InAppPurchaseData_DealGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGroupId = false;
    this._groupId = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasRefreshTimeSeconds = false;
    this._refreshTimeSeconds = null;
    this._bundles = [];
    this._groupTypeCase = 0;
    this._groupTypeValue = null;
  }
  isEmpty() {
    if (this._hasGroupId) return false;
    if (this._hasDisplayName) return false;
    if (this._hasRefreshTimeSeconds) return false;
    if (this._bundles.length > 0) return false;
    if (this._groupTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_DealGroup) {
      return value;
    }
    return InAppPurchaseData_DealGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_DealGroup();
    if (json.groupId != null) {
      result._hasGroupId = true;
      result._groupId = JsonToString.fromJson(json.groupId);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.refreshTimeSeconds != null) {
      result._hasRefreshTimeSeconds = true;
      result._refreshTimeSeconds = JsonToInt32.fromJson(json.refreshTimeSeconds);
    }
    result._bundles = JsonToList(json.bundles, InAppPurchaseData_DealBundle);
    if (json.calendarGroup != null) {
      result._groupTypeCase = 7;
      result._groupTypeValue = InAppPurchaseData_DealGroup_CalendarGroup.fromJson(json.calendarGroup);
    }
    if (json.onetimeGroup != null) {
      result._groupTypeCase = 8;
      result._groupTypeValue = InAppPurchaseData_DealGroup_OneTimeGroup.fromJson(json.onetimeGroup);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGroupId) {
      result.groupId = JsonToString.toJson(this._groupId);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasRefreshTimeSeconds) {
      result.refreshTimeSeconds = JsonToInt32.toJson(this._refreshTimeSeconds);
    }
    if (this._bundles.length > 0) {
      result.bundles = ArrayToJson(this._bundles, InAppPurchaseData_DealBundle);
    }
    switch (this._groupTypeCase) {
      case 7:
        result.calendarGroup = InAppPurchaseData_DealGroup_CalendarGroup.toJson(this._groupTypeValue);
        break;
      case 8:
        result.onetimeGroup = InAppPurchaseData_DealGroup_OneTimeGroup.toJson(this._groupTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get groupId() {
    return this._hasGroupId ? this._groupId : JsonToString.default;
  }
  get hasGroupId() {
    return this._hasGroupId;
  }
  setGroupId(path, value) {
    return {type: 'SET', path: path.concat(['groupId']), value};
  }
  deleteGroupId(path) {
    return {type: 'DELETE', path: path.concat(['groupId'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get refreshTimeSeconds() {
    return this._hasRefreshTimeSeconds ? this._refreshTimeSeconds : JsonToInt32.default;
  }
  get hasRefreshTimeSeconds() {
    return this._hasRefreshTimeSeconds;
  }
  setRefreshTimeSeconds(path, value) {
    return {type: 'SET', path: path.concat(['refreshTimeSeconds']), value};
  }
  deleteRefreshTimeSeconds(path) {
    return {type: 'DELETE', path: path.concat(['refreshTimeSeconds'])};
  }
  /**
   * @returns {InAppPurchaseData_DealBundle[]}
   */
  get bundles() {
    return this._bundles;
  }
  addBundles(path, value) {
    return {type: 'ADD', path: path.concat(['bundles']), value: value.toJson()};
  }
  setBundles(path, value) {
    return {type: 'SET', path: path.concat(['bundles']), value: ArrayToJson(value, InAppPurchaseData_DealBundle)};
  }
  setBundlesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundles', key]), value: value.toJson()};
  }
  deleteBundles(path) {
    return {type: 'DELETE', path: path.concat(['bundles'])};
  }
  deleteBundlesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundles', key])};
  }
  get groupTypeCase() {
    return this._groupTypeCase;
  }
  deleteGroupType(path) {
    switch (this._groupTypeCase) {
      default:
      case 7: {
        return {type: 'DELETE', path: path.concat(['calendarGroup'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['onetimeGroup'])};
      }
    }
  }
  /**
   * @returns {InAppPurchaseData_DealGroup_CalendarGroup}
   */
  get calendarGroup() {
    return this._groupTypeCase === 7 ? this._groupTypeValue : InAppPurchaseData_DealGroup_CalendarGroup.default;
  }
  setCalendarGroup(path, value) {
    return {type: 'SET', path: path.concat(['calendarGroup']), value: value.toJson()};
  }
  deleteCalendarGroup(path) {
    return {type: 'DELETE', path: path.concat(['calendarGroup'])};
  }
  /**
   * @returns {InAppPurchaseData_DealGroup_OneTimeGroup}
   */
  get onetimeGroup() {
    return this._groupTypeCase === 8 ? this._groupTypeValue : InAppPurchaseData_DealGroup_OneTimeGroup.default;
  }
  setOnetimeGroup(path, value) {
    return {type: 'SET', path: path.concat(['onetimeGroup']), value: value.toJson()};
  }
  deleteOnetimeGroup(path) {
    return {type: 'DELETE', path: path.concat(['onetimeGroup'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "groupId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._hasGroupId = true;
              copy._groupId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupId) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._hasGroupId = false;
              copy._groupId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refreshTimeSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._hasRefreshTimeSeconds = true;
              copy._refreshTimeSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshTimeSeconds) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._hasRefreshTimeSeconds = false;
              copy._refreshTimeSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bundles": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._bundles = [];        for (let i of value) {
                copy._bundles.push(InAppPurchaseData_DealBundle.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._bundles = copy._bundles.concat([InAppPurchaseData_DealBundle.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundles.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._bundles = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundles.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._bundles = copy._bundles.slice();
              copy._bundles[path[1]] = InAppPurchaseData_DealBundle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._bundles = copy._bundles.slice(0, path[1]).concat(copy._bundles.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundles.length) {
            return this;
          }
          const oldValue = this._bundles[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup(this);
          copy._bundles = copy._bundles.slice();
          copy._bundles[key] = newValue;
          return copy;
        }
      }
      case "calendarGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._groupTypeCase = 7;
              copy._groupTypeValue = InAppPurchaseData_DealGroup_CalendarGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._groupTypeCase !== 7) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._groupTypeCase = 0;
              copy._groupTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._groupTypeCase !== 7) {
            const copy = new InAppPurchaseData_DealGroup(this);
            copy._groupTypeCase = 7;
            copy._groupTypeValue = InAppPurchaseData_DealGroup_CalendarGroup.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.calendarGroup.apply(type, path.slice(1), value);
          if (newValue === this.calendarGroup) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup(this);
          copy._groupTypeCase = 7;
          copy._groupTypeValue = newValue;
          return copy;
        }
      }
      case "onetimeGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._groupTypeCase = 8;
              copy._groupTypeValue = InAppPurchaseData_DealGroup_OneTimeGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._groupTypeCase !== 8) {
                return this;
              }
              const copy = new InAppPurchaseData_DealGroup(this);
              copy._groupTypeCase = 0;
              copy._groupTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._groupTypeCase !== 8) {
            const copy = new InAppPurchaseData_DealGroup(this);
            copy._groupTypeCase = 8;
            copy._groupTypeValue = InAppPurchaseData_DealGroup_OneTimeGroup.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.onetimeGroup.apply(type, path.slice(1), value);
          if (newValue === this.onetimeGroup) {
            return this;
          }
          const copy = new InAppPurchaseData_DealGroup(this);
          copy._groupTypeCase = 8;
          copy._groupTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_DealGroup} other
   * @returns {InAppPurchaseData_DealGroup}
   */
  merge(other) {
    const copy = new InAppPurchaseData_DealGroup(this);
    if (other._hasGroupId) {
      copy._hasGroupId = true;
      copy._groupId = other._groupId;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasRefreshTimeSeconds) {
      copy._hasRefreshTimeSeconds = true;
      copy._refreshTimeSeconds = other._refreshTimeSeconds;
    }
    copy._bundles = this._bundles.concat(other._bundles);
    if (other._groupTypeCase === 7) {
      if (this._groupTypeCase === 7) {
        copy._groupTypeValue = copy._groupTypeValue.merge(other._groupTypeValue);
      } else {
        copy._groupTypeValue = other._groupTypeValue;
      }
      copy._groupTypeCase = 7;
    }
    if (other._groupTypeCase === 7) {
      if (this._groupTypeCase === 7) {
        copy._groupTypeValue = copy._groupTypeValue.merge(other._groupTypeValue);
      } else {
        copy._groupTypeValue = other._groupTypeValue;
      }
      copy._groupTypeCase = 7;
    }
    return copy;
  }
}
InAppPurchaseData_DealGroup.default = new InAppPurchaseData_DealGroup();
InAppPurchaseData_DealGroup.LevelGroup = InAppPurchaseData_DealGroup_LevelGroup;
InAppPurchaseData_DealGroup.OneTimeGroup = InAppPurchaseData_DealGroup_OneTimeGroup;
InAppPurchaseData_DealGroup.BundleGroup = InAppPurchaseData_DealGroup_BundleGroup;
InAppPurchaseData_DealGroup.CalendarGroup = InAppPurchaseData_DealGroup_CalendarGroup;
class InAppPurchaseData_DealGroup_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_DealGroup(value);
  }
  build() {
    return new InAppPurchaseData_DealGroup(this._value);
  }
  setGroupId(value) {
    this._value._hasGroupId = true;
    this._value._groupId = value;
    return this;
  }
  deleteGroupId() {
    this._value._hasGroupId = false;
    this._value._groupId = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setRefreshTimeSeconds(value) {
    this._value._hasRefreshTimeSeconds = true;
    this._value._refreshTimeSeconds = value;
    return this;
  }
  deleteRefreshTimeSeconds() {
    this._value._hasRefreshTimeSeconds = false;
    this._value._refreshTimeSeconds = null;
    return this;
  }
  addAllBundles(values) {
    this._value._bundles = this._value._bundles.concat(values);
    return this;
  }
  addBundles(value) {
    this._value._bundles = this._value._bundles.concat([value]);
    return this;
  }
  setBundles(index, value) {
    this._value._bundles = this._value._bundles.concat();
    this._value._bundles[index] = value;
    return this;
  }
  clearBundles() {
    this._value._bundles = [];
    return this;
  }
  cleargroupType() {
    this._value._groupTypeCase = 0;
    this._value._groupTypeValue = null;
    return this;
  }
  setCalendarGroup(value) {
    this._value._groupTypeCase = 7;
    this._value._groupTypeValue = value;
    return this;
  }
  setOnetimeGroup(value) {
    this._value._groupTypeCase = 8;
    this._value._groupTypeValue = value;
    return this;
  }
}
InAppPurchaseData_DealGroup.Builder = InAppPurchaseData_DealGroup_Builder;
class InAppPurchaseData_DealGroup_WithParent {
  /**
   * @param {InAppPurchaseData_DealGroup} value
   * @param {InAppPurchaseData_DealGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_DealGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGroupId() {
    if (this._cachedHasGroupId === undefined) {
      if (this._value.hasGroupId) {
        this._cachedHasGroupId = true;
      } else {
        this._cachedHasGroupId = this._parent ? this._parent.hasGroupId : false;
      }
    }
    return this._cachedHasGroupId;
  }
  get groupId() {
    if (this._cachedGroupId === undefined) {
      if (this._value.hasGroupId) {
        this._cachedGroupId = this._value.groupId;
      } else {
        this._cachedGroupId = this._parent ? this._parent.groupId : this._value.groupId;
      }
    }
    return this._cachedGroupId;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasRefreshTimeSeconds() {
    if (this._cachedHasRefreshTimeSeconds === undefined) {
      if (this._value.hasRefreshTimeSeconds) {
        this._cachedHasRefreshTimeSeconds = true;
      } else {
        this._cachedHasRefreshTimeSeconds = this._parent ? this._parent.hasRefreshTimeSeconds : false;
      }
    }
    return this._cachedHasRefreshTimeSeconds;
  }
  get refreshTimeSeconds() {
    if (this._cachedRefreshTimeSeconds === undefined) {
      if (this._value.hasRefreshTimeSeconds) {
        this._cachedRefreshTimeSeconds = this._value.refreshTimeSeconds;
      } else {
        this._cachedRefreshTimeSeconds = this._parent ? this._parent.refreshTimeSeconds : this._value.refreshTimeSeconds;
      }
    }
    return this._cachedRefreshTimeSeconds;
  }
  get selfBundles() {
    if (!this._selfBundles) {
      this._selfBundles = [];
      for (let i of this._value.bundles) {
        this._selfBundles.push(new InAppPurchaseData_DealBundle.WithParent(i, null));
      }
    }
    return this._selfBundles;
  }
  get inherentBundles() {
    if (!this._inherentBundles) {
      this._inherentBundles = this._parent ? this._parent.bundles : [];
    }
    return this._inherentBundles;
  }
  get bundles() {
    if (!this._allBundles) {
      this._allBundles = this._parent ? this._parent.bundles.concat(this.selfBundles) : this.selfBundles;
    }
    return this._allBundles;
  }
  get groupTypeCase() {
    if (this._cachedgroupTypeCase === undefined) {
      if (this._value._groupTypeCase === 0) {
        this._cachedgroupTypeCase = this._parent ? this._parent.groupTypeCase : 0;
      } else {
        this._cachedgroupTypeCase = this._value._groupTypeCase;
      }
    }
    return this._cachedgroupTypeCase;
  }
  get calendarGroup() {
    if (!this._cachedCalendarGroup) {
      if (this._value._groupTypeCase === 0) {
        this._cachedCalendarGroup = this._parent ? new InAppPurchaseData_DealGroup_CalendarGroup.WithParent(InAppPurchaseData_DealGroup_CalendarGroup.default, this._parent.calendarGroup) : this._value.calendarGroup;
      } else if (this._value._groupTypeCase === 7) {
        this._cachedCalendarGroup = new InAppPurchaseData_DealGroup_CalendarGroup.WithParent(this._value.calendarGroup, this._parent && this._parent.groupTypeCase === 7 ? this._parent.calendarGroup : null);
      } else {
        this._cachedCalendarGroup = InAppPurchaseData_DealGroup_CalendarGroup.WithParent.default;
      }
    }
    return this._cachedCalendarGroup;
  }
  get onetimeGroup() {
    if (!this._cachedOnetimeGroup) {
      if (this._value._groupTypeCase === 0) {
        this._cachedOnetimeGroup = this._parent ? new InAppPurchaseData_DealGroup_OneTimeGroup.WithParent(InAppPurchaseData_DealGroup_OneTimeGroup.default, this._parent.onetimeGroup) : this._value.onetimeGroup;
      } else if (this._value._groupTypeCase === 8) {
        this._cachedOnetimeGroup = new InAppPurchaseData_DealGroup_OneTimeGroup.WithParent(this._value.onetimeGroup, this._parent && this._parent.groupTypeCase === 8 ? this._parent.onetimeGroup : null);
      } else {
        this._cachedOnetimeGroup = InAppPurchaseData_DealGroup_OneTimeGroup.WithParent.default;
      }
    }
    return this._cachedOnetimeGroup;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_DealGroup_WithParent(current, parent);
    if (this._selfBundles) {
      if (this._value.bundles === current.bundles) {
        result._selfBundles = this._selfBundles;
      } else {
        result._selfBundles = [];
        for (let i = 0; i < current.bundles.length; i++) {
          const oldValue = this._value.bundles[i];
          if (oldValue) {
            const oldCache = this._selfBundles[i];
            if (oldValue === current.bundles[i]) {
              result._selfBundles[i] = oldCache;
            } else {
              result._selfBundles[i] = oldCache.update(current.bundles[i], null);
            }
          } else {
            result._selfBundles[i] = new InAppPurchaseData_DealBundle.WithParent(current.bundles[i], null);
          }
        }
      }
    }
    if (this._cachedCalendarGroup && this._value._groupTypeCase === 7 && current._groupTypeCase === 7) {
      if (this._value.calendarGroup === current.calendarGroup && this._parent === parent) {
        result._cachedCalendarGroup = this._cachedCalendarGroup;
      } else {
        result._cachedCalendarGroup = this._cachedCalendarGroup.update(current.calendarGroup, parent && parent.groupTypeCase === 7 ? parent.calendarGroup : null);
      }
    }
    if (this._cachedOnetimeGroup && this._value._groupTypeCase === 8 && current._groupTypeCase === 8) {
      if (this._value.onetimeGroup === current.onetimeGroup && this._parent === parent) {
        result._cachedOnetimeGroup = this._cachedOnetimeGroup;
      } else {
        result._cachedOnetimeGroup = this._cachedOnetimeGroup.update(current.onetimeGroup, parent && parent.groupTypeCase === 8 ? parent.onetimeGroup : null);
      }
    }
    return result;
  }
}
InAppPurchaseData_DealGroup_WithParent.default = new InAppPurchaseData_DealGroup_WithParent(InAppPurchaseData_DealGroup.default, null);
InAppPurchaseData_DealGroup.WithParent = InAppPurchaseData_DealGroup_WithParent;
class InAppPurchaseData_DealGroup_Descriptor {
  get groupId() {
    if (!this._groupId) {
      this._groupId = {
        name: "groupId",
        Name: "GroupId",
        number: 1,
        protoType: 9,
        protoName: "group_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupId;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get refreshTimeSeconds() {
    if (!this._refreshTimeSeconds) {
      this._refreshTimeSeconds = {
        name: "refreshTimeSeconds",
        Name: "RefreshTimeSeconds",
        number: 3,
        protoType: 5,
        protoName: "refresh_time_seconds",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshTimeSeconds;
  }
  get bundles() {
    if (!this._bundles) {
      this._bundles = {
        name: "bundles",
        Name: "Bundles",
        number: 4,
        protoType: 11,
        protoName: "bundles",
        type: InAppPurchaseData_DealBundle,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundles;
  }
  get calendarGroup() {
    if (!this._calendarGroup) {
      this._calendarGroup = {
        name: "calendarGroup",
        Name: "CalendarGroup",
        number: 7,
        protoType: 11,
        protoName: "calendar_group",
        oneofIndex: 3,
        type: InAppPurchaseData_DealGroup_CalendarGroup,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._calendarGroup;
  }
  get onetimeGroup() {
    if (!this._onetimeGroup) {
      this._onetimeGroup = {
        name: "onetimeGroup",
        Name: "OnetimeGroup",
        number: 8,
        protoType: 11,
        protoName: "onetime_group",
        oneofIndex: 3,
        type: InAppPurchaseData_DealGroup_OneTimeGroup,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._onetimeGroup;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.groupId,
        this.displayName,
        this.refreshTimeSeconds,
        this.bundles,
        this.calendarGroup,
        this.onetimeGroup,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGroupId",
        Name: "DummyOneofForGroupId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshTimeSeconds",
        Name: "DummyOneofForRefreshTimeSeconds",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "groupType",
        Name: "GroupType",
        fields: [
          this.fields[4],
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_DealGroup.descriptor = new InAppPurchaseData_DealGroup_Descriptor();
class InAppPurchaseData_SaleBundleDefinition {
  get descriptor() {
    return InAppPurchaseData_SaleBundleDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._saleBundles = [];
    this._hasUnlockProgress = false;
    this._unlockProgress = null;
  }
  isEmpty() {
    if (this._saleBundles.length > 0) return false;
    if (this._hasUnlockProgress) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData_SaleBundleDefinition) {
      return value;
    }
    return InAppPurchaseData_SaleBundleDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData_SaleBundleDefinition();
    result._saleBundles = JsonToList(json.saleBundles, InAppPurchaseData_SaleBundle);
    if (json.unlockProgress != null) {
      result._hasUnlockProgress = true;
      result._unlockProgress = JsonToInt32.fromJson(json.unlockProgress);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._saleBundles.length > 0) {
      result.saleBundles = ArrayToJson(this._saleBundles, InAppPurchaseData_SaleBundle);
    }
    if (this._hasUnlockProgress) {
      result.unlockProgress = JsonToInt32.toJson(this._unlockProgress);
    }
    return result;
  }
  /**
   * @returns {InAppPurchaseData_SaleBundle[]}
   */
  get saleBundles() {
    return this._saleBundles;
  }
  addSaleBundles(path, value) {
    return {type: 'ADD', path: path.concat(['saleBundles']), value: value.toJson()};
  }
  setSaleBundles(path, value) {
    return {type: 'SET', path: path.concat(['saleBundles']), value: ArrayToJson(value, InAppPurchaseData_SaleBundle)};
  }
  setSaleBundlesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['saleBundles', key]), value: value.toJson()};
  }
  deleteSaleBundles(path) {
    return {type: 'DELETE', path: path.concat(['saleBundles'])};
  }
  deleteSaleBundlesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['saleBundles', key])};
  }
  /**
   * @returns {number}
   */
  get unlockProgress() {
    return this._hasUnlockProgress ? this._unlockProgress : JsonToInt32.default;
  }
  get hasUnlockProgress() {
    return this._hasUnlockProgress;
  }
  setUnlockProgress(path, value) {
    return {type: 'SET', path: path.concat(['unlockProgress']), value};
  }
  deleteUnlockProgress(path) {
    return {type: 'DELETE', path: path.concat(['unlockProgress'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "saleBundles": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._saleBundles = [];        for (let i of value) {
                copy._saleBundles.push(InAppPurchaseData_SaleBundle.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._saleBundles = copy._saleBundles.concat([InAppPurchaseData_SaleBundle.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._saleBundles.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._saleBundles = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._saleBundles.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._saleBundles = copy._saleBundles.slice();
              copy._saleBundles[path[1]] = InAppPurchaseData_SaleBundle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._saleBundles = copy._saleBundles.slice(0, path[1]).concat(copy._saleBundles.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._saleBundles.length) {
            return this;
          }
          const oldValue = this._saleBundles[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData_SaleBundleDefinition(this);
          copy._saleBundles = copy._saleBundles.slice();
          copy._saleBundles[key] = newValue;
          return copy;
        }
      }
      case "unlockProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._hasUnlockProgress = true;
              copy._unlockProgress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnlockProgress) {
                return this;
              }
              const copy = new InAppPurchaseData_SaleBundleDefinition(this);
              copy._hasUnlockProgress = false;
              copy._unlockProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData_SaleBundleDefinition} other
   * @returns {InAppPurchaseData_SaleBundleDefinition}
   */
  merge(other) {
    const copy = new InAppPurchaseData_SaleBundleDefinition(this);
    copy._saleBundles = this._saleBundles.concat(other._saleBundles);
    if (other._hasUnlockProgress) {
      copy._hasUnlockProgress = true;
      copy._unlockProgress = other._unlockProgress;
    }
    return copy;
  }
}
InAppPurchaseData_SaleBundleDefinition.default = new InAppPurchaseData_SaleBundleDefinition();
class InAppPurchaseData_SaleBundleDefinition_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData_SaleBundleDefinition(value);
  }
  build() {
    return new InAppPurchaseData_SaleBundleDefinition(this._value);
  }
  addAllSaleBundles(values) {
    this._value._saleBundles = this._value._saleBundles.concat(values);
    return this;
  }
  addSaleBundles(value) {
    this._value._saleBundles = this._value._saleBundles.concat([value]);
    return this;
  }
  setSaleBundles(index, value) {
    this._value._saleBundles = this._value._saleBundles.concat();
    this._value._saleBundles[index] = value;
    return this;
  }
  clearSaleBundles() {
    this._value._saleBundles = [];
    return this;
  }
  setUnlockProgress(value) {
    this._value._hasUnlockProgress = true;
    this._value._unlockProgress = value;
    return this;
  }
  deleteUnlockProgress() {
    this._value._hasUnlockProgress = false;
    this._value._unlockProgress = null;
    return this;
  }
}
InAppPurchaseData_SaleBundleDefinition.Builder = InAppPurchaseData_SaleBundleDefinition_Builder;
class InAppPurchaseData_SaleBundleDefinition_WithParent {
  /**
   * @param {InAppPurchaseData_SaleBundleDefinition} value
   * @param {InAppPurchaseData_SaleBundleDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData_SaleBundleDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSaleBundles() {
    if (!this._selfSaleBundles) {
      this._selfSaleBundles = [];
      for (let i of this._value.saleBundles) {
        this._selfSaleBundles.push(new InAppPurchaseData_SaleBundle.WithParent(i, null));
      }
    }
    return this._selfSaleBundles;
  }
  get inherentSaleBundles() {
    if (!this._inherentSaleBundles) {
      this._inherentSaleBundles = this._parent ? this._parent.saleBundles : [];
    }
    return this._inherentSaleBundles;
  }
  get saleBundles() {
    if (!this._allSaleBundles) {
      this._allSaleBundles = this._parent ? this._parent.saleBundles.concat(this.selfSaleBundles) : this.selfSaleBundles;
    }
    return this._allSaleBundles;
  }
  get hasUnlockProgress() {
    if (this._cachedHasUnlockProgress === undefined) {
      if (this._value.hasUnlockProgress) {
        this._cachedHasUnlockProgress = true;
      } else {
        this._cachedHasUnlockProgress = this._parent ? this._parent.hasUnlockProgress : false;
      }
    }
    return this._cachedHasUnlockProgress;
  }
  get unlockProgress() {
    if (this._cachedUnlockProgress === undefined) {
      if (this._value.hasUnlockProgress) {
        this._cachedUnlockProgress = this._value.unlockProgress;
      } else {
        this._cachedUnlockProgress = this._parent ? this._parent.unlockProgress : this._value.unlockProgress;
      }
    }
    return this._cachedUnlockProgress;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_SaleBundleDefinition_WithParent(current, parent);
    if (this._selfSaleBundles) {
      if (this._value.saleBundles === current.saleBundles) {
        result._selfSaleBundles = this._selfSaleBundles;
      } else {
        result._selfSaleBundles = [];
        for (let i = 0; i < current.saleBundles.length; i++) {
          const oldValue = this._value.saleBundles[i];
          if (oldValue) {
            const oldCache = this._selfSaleBundles[i];
            if (oldValue === current.saleBundles[i]) {
              result._selfSaleBundles[i] = oldCache;
            } else {
              result._selfSaleBundles[i] = oldCache.update(current.saleBundles[i], null);
            }
          } else {
            result._selfSaleBundles[i] = new InAppPurchaseData_SaleBundle.WithParent(current.saleBundles[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_SaleBundleDefinition_WithParent.default = new InAppPurchaseData_SaleBundleDefinition_WithParent(InAppPurchaseData_SaleBundleDefinition.default, null);
InAppPurchaseData_SaleBundleDefinition.WithParent = InAppPurchaseData_SaleBundleDefinition_WithParent;
class InAppPurchaseData_SaleBundleDefinition_Descriptor {
  get saleBundles() {
    if (!this._saleBundles) {
      this._saleBundles = {
        name: "saleBundles",
        Name: "SaleBundles",
        number: 1,
        protoType: 11,
        protoName: "sale_bundles",
        type: InAppPurchaseData_SaleBundle,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._saleBundles;
  }
  get unlockProgress() {
    if (!this._unlockProgress) {
      this._unlockProgress = {
        name: "unlockProgress",
        Name: "UnlockProgress",
        number: 2,
        protoType: 5,
        protoName: "unlock_progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockProgress;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.saleBundles,
        this.unlockProgress,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnlockProgress",
        Name: "DummyOneofForUnlockProgress",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData_SaleBundleDefinition.descriptor = new InAppPurchaseData_SaleBundleDefinition_Descriptor();
export class InAppPurchaseData {
  get descriptor() {
    return InAppPurchaseData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._products = [];
    this._limitedBundles = [];
    this._subscriptions = [];
    this._tabs = [];
    this._tabPriority = [];
    this._bundleDefinitions = [];
    this._dealGroups = [];
    this._hasSaleDefinition = false;
    this._saleDefinition = null;
    this._campaignSaleBundles = [];
    this._dailyTrialBundles = [];
  }
  isEmpty() {
    if (this._products.length > 0) return false;
    if (this._limitedBundles.length > 0) return false;
    if (this._subscriptions.length > 0) return false;
    if (this._tabs.length > 0) return false;
    if (this._tabPriority.length > 0) return false;
    if (this._bundleDefinitions.length > 0) return false;
    if (this._dealGroups.length > 0) return false;
    if (this._hasSaleDefinition && !this._saleDefinition.isEmpty()) return false;
    if (this._campaignSaleBundles.length > 0) return false;
    if (this._dailyTrialBundles.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InAppPurchaseData) {
      return value;
    }
    return InAppPurchaseData.fromJson(value);
  }
  static fromJson(json) {
    const result = new InAppPurchaseData();
    result._products = JsonToList(json.products, InAppPurchaseData_Product);
    result._limitedBundles = JsonToList(json.limitedBundles, InAppPurchaseData_LimitedBundles);
    result._subscriptions = JsonToList(json.subscriptions, InAppPurchaseData_Subscription);
    result._tabs = JsonToList(json.tabs, InAppPurchaseData_Tab);
    result._tabPriority = JsonToList(json.tabPriority, JsonToString);
    result._bundleDefinitions = JsonToList(json.bundleDefinitions, InAppPurchaseData_DealBundle);
    result._dealGroups = JsonToList(json.dealGroups, InAppPurchaseData_DealGroup);
    if (json.saleDefinition != null) {
      result._hasSaleDefinition = true;
      result._saleDefinition = InAppPurchaseData_SaleBundleDefinition.fromJson(json.saleDefinition);
    }
    result._campaignSaleBundles = JsonToList(json.campaignSaleBundles, InAppPurchaseData_CampaignSaleBundle);
    result._dailyTrialBundles = JsonToList(json.dailyTrialBundles, InAppPurchaseData_DailyTrialBundle);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._products.length > 0) {
      result.products = ArrayToJson(this._products, InAppPurchaseData_Product);
    }
    if (this._limitedBundles.length > 0) {
      result.limitedBundles = ArrayToJson(this._limitedBundles, InAppPurchaseData_LimitedBundles);
    }
    if (this._subscriptions.length > 0) {
      result.subscriptions = ArrayToJson(this._subscriptions, InAppPurchaseData_Subscription);
    }
    if (this._tabs.length > 0) {
      result.tabs = ArrayToJson(this._tabs, InAppPurchaseData_Tab);
    }
    if (this._tabPriority.length > 0) {
      result.tabPriority = ArrayToJson(this._tabPriority, JsonToString);
    }
    if (this._bundleDefinitions.length > 0) {
      result.bundleDefinitions = ArrayToJson(this._bundleDefinitions, InAppPurchaseData_DealBundle);
    }
    if (this._dealGroups.length > 0) {
      result.dealGroups = ArrayToJson(this._dealGroups, InAppPurchaseData_DealGroup);
    }
    if (this._hasSaleDefinition && !this._saleDefinition.isEmpty()) {
      result.saleDefinition = InAppPurchaseData_SaleBundleDefinition.toJson(this._saleDefinition);
    }
    if (this._campaignSaleBundles.length > 0) {
      result.campaignSaleBundles = ArrayToJson(this._campaignSaleBundles, InAppPurchaseData_CampaignSaleBundle);
    }
    if (this._dailyTrialBundles.length > 0) {
      result.dailyTrialBundles = ArrayToJson(this._dailyTrialBundles, InAppPurchaseData_DailyTrialBundle);
    }
    return result;
  }
  /**
   * @returns {InAppPurchaseData_Product[]}
   */
  get products() {
    return this._products;
  }
  addProducts(path, value) {
    return {type: 'ADD', path: path.concat(['products']), value: value.toJson()};
  }
  setProducts(path, value) {
    return {type: 'SET', path: path.concat(['products']), value: ArrayToJson(value, InAppPurchaseData_Product)};
  }
  setProductsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['products', key]), value: value.toJson()};
  }
  deleteProducts(path) {
    return {type: 'DELETE', path: path.concat(['products'])};
  }
  deleteProductsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['products', key])};
  }
  /**
   * @returns {InAppPurchaseData_LimitedBundles[]}
   */
  get limitedBundles() {
    return this._limitedBundles;
  }
  addLimitedBundles(path, value) {
    return {type: 'ADD', path: path.concat(['limitedBundles']), value: value.toJson()};
  }
  setLimitedBundles(path, value) {
    return {type: 'SET', path: path.concat(['limitedBundles']), value: ArrayToJson(value, InAppPurchaseData_LimitedBundles)};
  }
  setLimitedBundlesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['limitedBundles', key]), value: value.toJson()};
  }
  deleteLimitedBundles(path) {
    return {type: 'DELETE', path: path.concat(['limitedBundles'])};
  }
  deleteLimitedBundlesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['limitedBundles', key])};
  }
  /**
   * @returns {InAppPurchaseData_Subscription[]}
   */
  get subscriptions() {
    return this._subscriptions;
  }
  addSubscriptions(path, value) {
    return {type: 'ADD', path: path.concat(['subscriptions']), value: value.toJson()};
  }
  setSubscriptions(path, value) {
    return {type: 'SET', path: path.concat(['subscriptions']), value: ArrayToJson(value, InAppPurchaseData_Subscription)};
  }
  setSubscriptionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['subscriptions', key]), value: value.toJson()};
  }
  deleteSubscriptions(path) {
    return {type: 'DELETE', path: path.concat(['subscriptions'])};
  }
  deleteSubscriptionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['subscriptions', key])};
  }
  /**
   * @returns {InAppPurchaseData_Tab[]}
   */
  get tabs() {
    return this._tabs;
  }
  addTabs(path, value) {
    return {type: 'ADD', path: path.concat(['tabs']), value: value.toJson()};
  }
  setTabs(path, value) {
    return {type: 'SET', path: path.concat(['tabs']), value: ArrayToJson(value, InAppPurchaseData_Tab)};
  }
  setTabsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tabs', key]), value: value.toJson()};
  }
  deleteTabs(path) {
    return {type: 'DELETE', path: path.concat(['tabs'])};
  }
  deleteTabsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tabs', key])};
  }
  /**
   * @returns {string[]}
   */
  get tabPriority() {
    return this._tabPriority;
  }
  addTabPriority(path, value) {
    return {type: 'ADD', path: path.concat(['tabPriority']), value};
  }
  setTabPriority(path, value) {
    return {type: 'SET', path: path.concat(['tabPriority']), value: ArrayToJson(value, JsonToString)};
  }
  setTabPriorityByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tabPriority', key]), value};
  }
  deleteTabPriority(path) {
    return {type: 'DELETE', path: path.concat(['tabPriority'])};
  }
  deleteTabPriorityByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tabPriority', key])};
  }
  /**
   * @returns {InAppPurchaseData_DealBundle[]}
   */
  get bundleDefinitions() {
    return this._bundleDefinitions;
  }
  addBundleDefinitions(path, value) {
    return {type: 'ADD', path: path.concat(['bundleDefinitions']), value: value.toJson()};
  }
  setBundleDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['bundleDefinitions']), value: ArrayToJson(value, InAppPurchaseData_DealBundle)};
  }
  setBundleDefinitionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleDefinitions', key]), value: value.toJson()};
  }
  deleteBundleDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['bundleDefinitions'])};
  }
  deleteBundleDefinitionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleDefinitions', key])};
  }
  /**
   * @returns {InAppPurchaseData_DealGroup[]}
   */
  get dealGroups() {
    return this._dealGroups;
  }
  addDealGroups(path, value) {
    return {type: 'ADD', path: path.concat(['dealGroups']), value: value.toJson()};
  }
  setDealGroups(path, value) {
    return {type: 'SET', path: path.concat(['dealGroups']), value: ArrayToJson(value, InAppPurchaseData_DealGroup)};
  }
  setDealGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dealGroups', key]), value: value.toJson()};
  }
  deleteDealGroups(path) {
    return {type: 'DELETE', path: path.concat(['dealGroups'])};
  }
  deleteDealGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dealGroups', key])};
  }
  /**
   * @returns {InAppPurchaseData_SaleBundleDefinition}
   */
  get saleDefinition() {
    return this._hasSaleDefinition ? this._saleDefinition : InAppPurchaseData_SaleBundleDefinition.default;
  }
  get hasSaleDefinition() {
    return this._hasSaleDefinition;
  }
  setSaleDefinition(path, value) {
    return {type: 'SET', path: path.concat(['saleDefinition']), value: value.toJson()};
  }
  deleteSaleDefinition(path) {
    return {type: 'DELETE', path: path.concat(['saleDefinition'])};
  }
  /**
   * @returns {InAppPurchaseData_CampaignSaleBundle[]}
   */
  get campaignSaleBundles() {
    return this._campaignSaleBundles;
  }
  addCampaignSaleBundles(path, value) {
    return {type: 'ADD', path: path.concat(['campaignSaleBundles']), value: value.toJson()};
  }
  setCampaignSaleBundles(path, value) {
    return {type: 'SET', path: path.concat(['campaignSaleBundles']), value: ArrayToJson(value, InAppPurchaseData_CampaignSaleBundle)};
  }
  setCampaignSaleBundlesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['campaignSaleBundles', key]), value: value.toJson()};
  }
  deleteCampaignSaleBundles(path) {
    return {type: 'DELETE', path: path.concat(['campaignSaleBundles'])};
  }
  deleteCampaignSaleBundlesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['campaignSaleBundles', key])};
  }
  /**
   * @returns {InAppPurchaseData_DailyTrialBundle[]}
   */
  get dailyTrialBundles() {
    return this._dailyTrialBundles;
  }
  addDailyTrialBundles(path, value) {
    return {type: 'ADD', path: path.concat(['dailyTrialBundles']), value: value.toJson()};
  }
  setDailyTrialBundles(path, value) {
    return {type: 'SET', path: path.concat(['dailyTrialBundles']), value: ArrayToJson(value, InAppPurchaseData_DailyTrialBundle)};
  }
  setDailyTrialBundlesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dailyTrialBundles', key]), value: value.toJson()};
  }
  deleteDailyTrialBundles(path) {
    return {type: 'DELETE', path: path.concat(['dailyTrialBundles'])};
  }
  deleteDailyTrialBundlesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dailyTrialBundles', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "products": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._products = [];        for (let i of value) {
                copy._products.push(InAppPurchaseData_Product.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._products = copy._products.concat([InAppPurchaseData_Product.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._products.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._products = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._products.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._products = copy._products.slice();
              copy._products[path[1]] = InAppPurchaseData_Product.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._products = copy._products.slice(0, path[1]).concat(copy._products.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._products.length) {
            return this;
          }
          const oldValue = this._products[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._products = copy._products.slice();
          copy._products[key] = newValue;
          return copy;
        }
      }
      case "limitedBundles": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._limitedBundles = [];        for (let i of value) {
                copy._limitedBundles.push(InAppPurchaseData_LimitedBundles.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._limitedBundles = copy._limitedBundles.concat([InAppPurchaseData_LimitedBundles.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._limitedBundles.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._limitedBundles = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._limitedBundles.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._limitedBundles = copy._limitedBundles.slice();
              copy._limitedBundles[path[1]] = InAppPurchaseData_LimitedBundles.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._limitedBundles = copy._limitedBundles.slice(0, path[1]).concat(copy._limitedBundles.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._limitedBundles.length) {
            return this;
          }
          const oldValue = this._limitedBundles[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._limitedBundles = copy._limitedBundles.slice();
          copy._limitedBundles[key] = newValue;
          return copy;
        }
      }
      case "subscriptions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._subscriptions = [];        for (let i of value) {
                copy._subscriptions.push(InAppPurchaseData_Subscription.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._subscriptions = copy._subscriptions.concat([InAppPurchaseData_Subscription.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._subscriptions.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._subscriptions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._subscriptions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._subscriptions = copy._subscriptions.slice();
              copy._subscriptions[path[1]] = InAppPurchaseData_Subscription.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._subscriptions = copy._subscriptions.slice(0, path[1]).concat(copy._subscriptions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._subscriptions.length) {
            return this;
          }
          const oldValue = this._subscriptions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._subscriptions = copy._subscriptions.slice();
          copy._subscriptions[key] = newValue;
          return copy;
        }
      }
      case "tabs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._tabs = [];        for (let i of value) {
                copy._tabs.push(InAppPurchaseData_Tab.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._tabs = copy._tabs.concat([InAppPurchaseData_Tab.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tabs.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._tabs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tabs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._tabs = copy._tabs.slice();
              copy._tabs[path[1]] = InAppPurchaseData_Tab.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._tabs = copy._tabs.slice(0, path[1]).concat(copy._tabs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tabs.length) {
            return this;
          }
          const oldValue = this._tabs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._tabs = copy._tabs.slice();
          copy._tabs[key] = newValue;
          return copy;
        }
      }
      case "tabPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._tabPriority = [];        for (let i of value) {
                copy._tabPriority.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._tabPriority = copy._tabPriority.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tabPriority.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._tabPriority = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tabPriority.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._tabPriority = copy._tabPriority.slice();
              copy._tabPriority[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._tabPriority = copy._tabPriority.slice(0, path[1]).concat(copy._tabPriority.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tabPriority.length) {
            return this;
          }
          const oldValue = this._tabPriority[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._tabPriority = copy._tabPriority.slice();
          copy._tabPriority[key] = newValue;
          return copy;
        }
      }
      case "bundleDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._bundleDefinitions = [];        for (let i of value) {
                copy._bundleDefinitions.push(InAppPurchaseData_DealBundle.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._bundleDefinitions = copy._bundleDefinitions.concat([InAppPurchaseData_DealBundle.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleDefinitions.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._bundleDefinitions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleDefinitions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._bundleDefinitions = copy._bundleDefinitions.slice();
              copy._bundleDefinitions[path[1]] = InAppPurchaseData_DealBundle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._bundleDefinitions = copy._bundleDefinitions.slice(0, path[1]).concat(copy._bundleDefinitions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleDefinitions.length) {
            return this;
          }
          const oldValue = this._bundleDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._bundleDefinitions = copy._bundleDefinitions.slice();
          copy._bundleDefinitions[key] = newValue;
          return copy;
        }
      }
      case "dealGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._dealGroups = [];        for (let i of value) {
                copy._dealGroups.push(InAppPurchaseData_DealGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._dealGroups = copy._dealGroups.concat([InAppPurchaseData_DealGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dealGroups.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._dealGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dealGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._dealGroups = copy._dealGroups.slice();
              copy._dealGroups[path[1]] = InAppPurchaseData_DealGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._dealGroups = copy._dealGroups.slice(0, path[1]).concat(copy._dealGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dealGroups.length) {
            return this;
          }
          const oldValue = this._dealGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._dealGroups = copy._dealGroups.slice();
          copy._dealGroups[key] = newValue;
          return copy;
        }
      }
      case "saleDefinition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._hasSaleDefinition = true;
              copy._saleDefinition = InAppPurchaseData_SaleBundleDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSaleDefinition) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._hasSaleDefinition = false;
              copy._saleDefinition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSaleDefinition) {
            const copy = new InAppPurchaseData(this);
            copy._hasSaleDefinition = true;
            copy._saleDefinition = InAppPurchaseData_SaleBundleDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._saleDefinition.apply(type, path.slice(1), value);
          if (newValue === this._saleDefinition) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._saleDefinition = copy._saleDefinition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "campaignSaleBundles": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._campaignSaleBundles = [];        for (let i of value) {
                copy._campaignSaleBundles.push(InAppPurchaseData_CampaignSaleBundle.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._campaignSaleBundles = copy._campaignSaleBundles.concat([InAppPurchaseData_CampaignSaleBundle.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._campaignSaleBundles.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._campaignSaleBundles = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._campaignSaleBundles.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._campaignSaleBundles = copy._campaignSaleBundles.slice();
              copy._campaignSaleBundles[path[1]] = InAppPurchaseData_CampaignSaleBundle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._campaignSaleBundles = copy._campaignSaleBundles.slice(0, path[1]).concat(copy._campaignSaleBundles.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._campaignSaleBundles.length) {
            return this;
          }
          const oldValue = this._campaignSaleBundles[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._campaignSaleBundles = copy._campaignSaleBundles.slice();
          copy._campaignSaleBundles[key] = newValue;
          return copy;
        }
      }
      case "dailyTrialBundles": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._dailyTrialBundles = [];        for (let i of value) {
                copy._dailyTrialBundles.push(InAppPurchaseData_DailyTrialBundle.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InAppPurchaseData(this);
              copy._dailyTrialBundles = copy._dailyTrialBundles.concat([InAppPurchaseData_DailyTrialBundle.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dailyTrialBundles.length === 0) {
                return this;
              }
              const copy = new InAppPurchaseData(this);
              copy._dailyTrialBundles = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dailyTrialBundles.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InAppPurchaseData(this);
              copy._dailyTrialBundles = copy._dailyTrialBundles.slice();
              copy._dailyTrialBundles[path[1]] = InAppPurchaseData_DailyTrialBundle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InAppPurchaseData(this);
              copy._dailyTrialBundles = copy._dailyTrialBundles.slice(0, path[1]).concat(copy._dailyTrialBundles.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dailyTrialBundles.length) {
            return this;
          }
          const oldValue = this._dailyTrialBundles[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InAppPurchaseData(this);
          copy._dailyTrialBundles = copy._dailyTrialBundles.slice();
          copy._dailyTrialBundles[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InAppPurchaseData} other
   * @returns {InAppPurchaseData}
   */
  merge(other) {
    const copy = new InAppPurchaseData(this);
    copy._products = this._products.concat(other._products);
    copy._limitedBundles = this._limitedBundles.concat(other._limitedBundles);
    copy._subscriptions = this._subscriptions.concat(other._subscriptions);
    copy._tabs = this._tabs.concat(other._tabs);
    copy._tabPriority = this._tabPriority.concat(other._tabPriority);
    copy._bundleDefinitions = this._bundleDefinitions.concat(other._bundleDefinitions);
    copy._dealGroups = this._dealGroups.concat(other._dealGroups);
    if (other._hasSaleDefinition) {
      if (copy._hasSaleDefinition) {
        copy._saleDefinition = copy.saleDefinition.merge(other.saleDefinition);
      } else {
        copy._saleDefinition = other._saleDefinition;
      }
      copy._hasSaleDefinition = true;
    }
    copy._campaignSaleBundles = this._campaignSaleBundles.concat(other._campaignSaleBundles);
    copy._dailyTrialBundles = this._dailyTrialBundles.concat(other._dailyTrialBundles);
    return copy;
  }
}
InAppPurchaseData.default = new InAppPurchaseData();
InAppPurchaseData.Filter = InAppPurchaseData_Filter;
InAppPurchaseData.IapTrigger = InAppPurchaseData_IapTrigger;
InAppPurchaseData.Tab = InAppPurchaseData_Tab;
InAppPurchaseData.Subscription = InAppPurchaseData_Subscription;
InAppPurchaseData.BundleItem = InAppPurchaseData_BundleItem;
InAppPurchaseData.LimitedBundles = InAppPurchaseData_LimitedBundles;
InAppPurchaseData.SaleBundle = InAppPurchaseData_SaleBundle;
InAppPurchaseData.DailyTrialBundle = InAppPurchaseData_DailyTrialBundle;
InAppPurchaseData.CampaignSaleBundle = InAppPurchaseData_CampaignSaleBundle;
InAppPurchaseData.Product = InAppPurchaseData_Product;
InAppPurchaseData.DealBundle = InAppPurchaseData_DealBundle;
InAppPurchaseData.DealGroup = InAppPurchaseData_DealGroup;
InAppPurchaseData.SaleBundleDefinition = InAppPurchaseData_SaleBundleDefinition;
class InAppPurchaseData_Builder {
  constructor(value) {
    this._value = new InAppPurchaseData(value);
  }
  build() {
    return new InAppPurchaseData(this._value);
  }
  addAllProducts(values) {
    this._value._products = this._value._products.concat(values);
    return this;
  }
  addProducts(value) {
    this._value._products = this._value._products.concat([value]);
    return this;
  }
  setProducts(index, value) {
    this._value._products = this._value._products.concat();
    this._value._products[index] = value;
    return this;
  }
  clearProducts() {
    this._value._products = [];
    return this;
  }
  addAllLimitedBundles(values) {
    this._value._limitedBundles = this._value._limitedBundles.concat(values);
    return this;
  }
  addLimitedBundles(value) {
    this._value._limitedBundles = this._value._limitedBundles.concat([value]);
    return this;
  }
  setLimitedBundles(index, value) {
    this._value._limitedBundles = this._value._limitedBundles.concat();
    this._value._limitedBundles[index] = value;
    return this;
  }
  clearLimitedBundles() {
    this._value._limitedBundles = [];
    return this;
  }
  addAllSubscriptions(values) {
    this._value._subscriptions = this._value._subscriptions.concat(values);
    return this;
  }
  addSubscriptions(value) {
    this._value._subscriptions = this._value._subscriptions.concat([value]);
    return this;
  }
  setSubscriptions(index, value) {
    this._value._subscriptions = this._value._subscriptions.concat();
    this._value._subscriptions[index] = value;
    return this;
  }
  clearSubscriptions() {
    this._value._subscriptions = [];
    return this;
  }
  addAllTabs(values) {
    this._value._tabs = this._value._tabs.concat(values);
    return this;
  }
  addTabs(value) {
    this._value._tabs = this._value._tabs.concat([value]);
    return this;
  }
  setTabs(index, value) {
    this._value._tabs = this._value._tabs.concat();
    this._value._tabs[index] = value;
    return this;
  }
  clearTabs() {
    this._value._tabs = [];
    return this;
  }
  addAllTabPriority(values) {
    this._value._tabPriority = this._value._tabPriority.concat(values);
    return this;
  }
  addTabPriority(value) {
    this._value._tabPriority = this._value._tabPriority.concat([value]);
    return this;
  }
  setTabPriority(index, value) {
    this._value._tabPriority = this._value._tabPriority.concat();
    this._value._tabPriority[index] = value;
    return this;
  }
  clearTabPriority() {
    this._value._tabPriority = [];
    return this;
  }
  addAllBundleDefinitions(values) {
    this._value._bundleDefinitions = this._value._bundleDefinitions.concat(values);
    return this;
  }
  addBundleDefinitions(value) {
    this._value._bundleDefinitions = this._value._bundleDefinitions.concat([value]);
    return this;
  }
  setBundleDefinitions(index, value) {
    this._value._bundleDefinitions = this._value._bundleDefinitions.concat();
    this._value._bundleDefinitions[index] = value;
    return this;
  }
  clearBundleDefinitions() {
    this._value._bundleDefinitions = [];
    return this;
  }
  addAllDealGroups(values) {
    this._value._dealGroups = this._value._dealGroups.concat(values);
    return this;
  }
  addDealGroups(value) {
    this._value._dealGroups = this._value._dealGroups.concat([value]);
    return this;
  }
  setDealGroups(index, value) {
    this._value._dealGroups = this._value._dealGroups.concat();
    this._value._dealGroups[index] = value;
    return this;
  }
  clearDealGroups() {
    this._value._dealGroups = [];
    return this;
  }
  setSaleDefinition(value) {
    this._value._hasSaleDefinition = true;
    this._value._saleDefinition = value;
    return this;
  }
  deleteSaleDefinition() {
    this._value._hasSaleDefinition = false;
    this._value._saleDefinition = null;
    return this;
  }
  addAllCampaignSaleBundles(values) {
    this._value._campaignSaleBundles = this._value._campaignSaleBundles.concat(values);
    return this;
  }
  addCampaignSaleBundles(value) {
    this._value._campaignSaleBundles = this._value._campaignSaleBundles.concat([value]);
    return this;
  }
  setCampaignSaleBundles(index, value) {
    this._value._campaignSaleBundles = this._value._campaignSaleBundles.concat();
    this._value._campaignSaleBundles[index] = value;
    return this;
  }
  clearCampaignSaleBundles() {
    this._value._campaignSaleBundles = [];
    return this;
  }
  addAllDailyTrialBundles(values) {
    this._value._dailyTrialBundles = this._value._dailyTrialBundles.concat(values);
    return this;
  }
  addDailyTrialBundles(value) {
    this._value._dailyTrialBundles = this._value._dailyTrialBundles.concat([value]);
    return this;
  }
  setDailyTrialBundles(index, value) {
    this._value._dailyTrialBundles = this._value._dailyTrialBundles.concat();
    this._value._dailyTrialBundles[index] = value;
    return this;
  }
  clearDailyTrialBundles() {
    this._value._dailyTrialBundles = [];
    return this;
  }
}
InAppPurchaseData.Builder = InAppPurchaseData_Builder;
class InAppPurchaseData_WithParent {
  /**
   * @param {InAppPurchaseData} value
   * @param {InAppPurchaseData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InAppPurchaseData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfProducts() {
    if (!this._selfProducts) {
      this._selfProducts = [];
      for (let i of this._value.products) {
        this._selfProducts.push(new InAppPurchaseData_Product.WithParent(i, null));
      }
    }
    return this._selfProducts;
  }
  get inherentProducts() {
    if (!this._inherentProducts) {
      this._inherentProducts = this._parent ? this._parent.products : [];
    }
    return this._inherentProducts;
  }
  get products() {
    if (!this._allProducts) {
      this._allProducts = this._parent ? this._parent.products.concat(this.selfProducts) : this.selfProducts;
    }
    return this._allProducts;
  }
  get selfLimitedBundles() {
    if (!this._selfLimitedBundles) {
      this._selfLimitedBundles = [];
      for (let i of this._value.limitedBundles) {
        this._selfLimitedBundles.push(new InAppPurchaseData_LimitedBundles.WithParent(i, null));
      }
    }
    return this._selfLimitedBundles;
  }
  get inherentLimitedBundles() {
    if (!this._inherentLimitedBundles) {
      this._inherentLimitedBundles = this._parent ? this._parent.limitedBundles : [];
    }
    return this._inherentLimitedBundles;
  }
  get limitedBundles() {
    if (!this._allLimitedBundles) {
      this._allLimitedBundles = this._parent ? this._parent.limitedBundles.concat(this.selfLimitedBundles) : this.selfLimitedBundles;
    }
    return this._allLimitedBundles;
  }
  get selfSubscriptions() {
    if (!this._selfSubscriptions) {
      this._selfSubscriptions = [];
      for (let i of this._value.subscriptions) {
        this._selfSubscriptions.push(new InAppPurchaseData_Subscription.WithParent(i, null));
      }
    }
    return this._selfSubscriptions;
  }
  get inherentSubscriptions() {
    if (!this._inherentSubscriptions) {
      this._inherentSubscriptions = this._parent ? this._parent.subscriptions : [];
    }
    return this._inherentSubscriptions;
  }
  get subscriptions() {
    if (!this._allSubscriptions) {
      this._allSubscriptions = this._parent ? this._parent.subscriptions.concat(this.selfSubscriptions) : this.selfSubscriptions;
    }
    return this._allSubscriptions;
  }
  get selfTabs() {
    if (!this._selfTabs) {
      this._selfTabs = [];
      for (let i of this._value.tabs) {
        this._selfTabs.push(new InAppPurchaseData_Tab.WithParent(i, null));
      }
    }
    return this._selfTabs;
  }
  get inherentTabs() {
    if (!this._inherentTabs) {
      this._inherentTabs = this._parent ? this._parent.tabs : [];
    }
    return this._inherentTabs;
  }
  get tabs() {
    if (!this._allTabs) {
      this._allTabs = this._parent ? this._parent.tabs.concat(this.selfTabs) : this.selfTabs;
    }
    return this._allTabs;
  }
  get selfTabPriority() {
    return this._value.tabPriority;
  }
  get inherentTabPriority() {
    if (!this._inherentTabPriority) {
      this._inherentTabPriority = this._parent ? this._parent.tabPriority : [];
    }
    return this._inherentTabPriority;
  }
  get tabPriority() {
    if (!this._allTabPriority) {
      this._allTabPriority = this._parent ? this._parent.tabPriority.concat(this.selfTabPriority) : this.selfTabPriority;
    }
    return this._allTabPriority;
  }
  get selfBundleDefinitions() {
    if (!this._selfBundleDefinitions) {
      this._selfBundleDefinitions = [];
      for (let i of this._value.bundleDefinitions) {
        this._selfBundleDefinitions.push(new InAppPurchaseData_DealBundle.WithParent(i, null));
      }
    }
    return this._selfBundleDefinitions;
  }
  get inherentBundleDefinitions() {
    if (!this._inherentBundleDefinitions) {
      this._inherentBundleDefinitions = this._parent ? this._parent.bundleDefinitions : [];
    }
    return this._inherentBundleDefinitions;
  }
  get bundleDefinitions() {
    if (!this._allBundleDefinitions) {
      this._allBundleDefinitions = this._parent ? this._parent.bundleDefinitions.concat(this.selfBundleDefinitions) : this.selfBundleDefinitions;
    }
    return this._allBundleDefinitions;
  }
  get selfDealGroups() {
    if (!this._selfDealGroups) {
      this._selfDealGroups = [];
      for (let i of this._value.dealGroups) {
        this._selfDealGroups.push(new InAppPurchaseData_DealGroup.WithParent(i, null));
      }
    }
    return this._selfDealGroups;
  }
  get inherentDealGroups() {
    if (!this._inherentDealGroups) {
      this._inherentDealGroups = this._parent ? this._parent.dealGroups : [];
    }
    return this._inherentDealGroups;
  }
  get dealGroups() {
    if (!this._allDealGroups) {
      this._allDealGroups = this._parent ? this._parent.dealGroups.concat(this.selfDealGroups) : this.selfDealGroups;
    }
    return this._allDealGroups;
  }
  get hasSaleDefinition() {
    if (this._cachedHasSaleDefinition === undefined) {
      if (this._value.hasSaleDefinition) {
        this._cachedHasSaleDefinition = true;
      } else {
        this._cachedHasSaleDefinition = this._parent ? this._parent.hasSaleDefinition : false;
      }
    }
    return this._cachedHasSaleDefinition;
  }
  get saleDefinition() {
    if (!this._cachedSaleDefinition) {
      if (this._value.hasSaleDefinition) {
        this._cachedSaleDefinition = new InAppPurchaseData_SaleBundleDefinition.WithParent(this._value.saleDefinition, this._parent && this._parent.hasSaleDefinition ? this._parent.saleDefinition : null);
      } else {
        this._cachedSaleDefinition = this._parent ? new InAppPurchaseData_SaleBundleDefinition.WithParent(InAppPurchaseData_SaleBundleDefinition.default, this._parent.saleDefinition) : InAppPurchaseData_SaleBundleDefinition.WithParent.default;
      }
    }
    return this._cachedSaleDefinition;
  }
  get selfCampaignSaleBundles() {
    if (!this._selfCampaignSaleBundles) {
      this._selfCampaignSaleBundles = [];
      for (let i of this._value.campaignSaleBundles) {
        this._selfCampaignSaleBundles.push(new InAppPurchaseData_CampaignSaleBundle.WithParent(i, null));
      }
    }
    return this._selfCampaignSaleBundles;
  }
  get inherentCampaignSaleBundles() {
    if (!this._inherentCampaignSaleBundles) {
      this._inherentCampaignSaleBundles = this._parent ? this._parent.campaignSaleBundles : [];
    }
    return this._inherentCampaignSaleBundles;
  }
  get campaignSaleBundles() {
    if (!this._allCampaignSaleBundles) {
      this._allCampaignSaleBundles = this._parent ? this._parent.campaignSaleBundles.concat(this.selfCampaignSaleBundles) : this.selfCampaignSaleBundles;
    }
    return this._allCampaignSaleBundles;
  }
  get selfDailyTrialBundles() {
    if (!this._selfDailyTrialBundles) {
      this._selfDailyTrialBundles = [];
      for (let i of this._value.dailyTrialBundles) {
        this._selfDailyTrialBundles.push(new InAppPurchaseData_DailyTrialBundle.WithParent(i, null));
      }
    }
    return this._selfDailyTrialBundles;
  }
  get inherentDailyTrialBundles() {
    if (!this._inherentDailyTrialBundles) {
      this._inherentDailyTrialBundles = this._parent ? this._parent.dailyTrialBundles : [];
    }
    return this._inherentDailyTrialBundles;
  }
  get dailyTrialBundles() {
    if (!this._allDailyTrialBundles) {
      this._allDailyTrialBundles = this._parent ? this._parent.dailyTrialBundles.concat(this.selfDailyTrialBundles) : this.selfDailyTrialBundles;
    }
    return this._allDailyTrialBundles;
  }
  update(current, parent) {
    const result = new InAppPurchaseData_WithParent(current, parent);
    if (this._selfProducts) {
      if (this._value.products === current.products) {
        result._selfProducts = this._selfProducts;
      } else {
        result._selfProducts = [];
        for (let i = 0; i < current.products.length; i++) {
          const oldValue = this._value.products[i];
          if (oldValue) {
            const oldCache = this._selfProducts[i];
            if (oldValue === current.products[i]) {
              result._selfProducts[i] = oldCache;
            } else {
              result._selfProducts[i] = oldCache.update(current.products[i], null);
            }
          } else {
            result._selfProducts[i] = new InAppPurchaseData_Product.WithParent(current.products[i], null);
          }
        }
      }
    }
    if (this._selfLimitedBundles) {
      if (this._value.limitedBundles === current.limitedBundles) {
        result._selfLimitedBundles = this._selfLimitedBundles;
      } else {
        result._selfLimitedBundles = [];
        for (let i = 0; i < current.limitedBundles.length; i++) {
          const oldValue = this._value.limitedBundles[i];
          if (oldValue) {
            const oldCache = this._selfLimitedBundles[i];
            if (oldValue === current.limitedBundles[i]) {
              result._selfLimitedBundles[i] = oldCache;
            } else {
              result._selfLimitedBundles[i] = oldCache.update(current.limitedBundles[i], null);
            }
          } else {
            result._selfLimitedBundles[i] = new InAppPurchaseData_LimitedBundles.WithParent(current.limitedBundles[i], null);
          }
        }
      }
    }
    if (this._selfSubscriptions) {
      if (this._value.subscriptions === current.subscriptions) {
        result._selfSubscriptions = this._selfSubscriptions;
      } else {
        result._selfSubscriptions = [];
        for (let i = 0; i < current.subscriptions.length; i++) {
          const oldValue = this._value.subscriptions[i];
          if (oldValue) {
            const oldCache = this._selfSubscriptions[i];
            if (oldValue === current.subscriptions[i]) {
              result._selfSubscriptions[i] = oldCache;
            } else {
              result._selfSubscriptions[i] = oldCache.update(current.subscriptions[i], null);
            }
          } else {
            result._selfSubscriptions[i] = new InAppPurchaseData_Subscription.WithParent(current.subscriptions[i], null);
          }
        }
      }
    }
    if (this._selfTabs) {
      if (this._value.tabs === current.tabs) {
        result._selfTabs = this._selfTabs;
      } else {
        result._selfTabs = [];
        for (let i = 0; i < current.tabs.length; i++) {
          const oldValue = this._value.tabs[i];
          if (oldValue) {
            const oldCache = this._selfTabs[i];
            if (oldValue === current.tabs[i]) {
              result._selfTabs[i] = oldCache;
            } else {
              result._selfTabs[i] = oldCache.update(current.tabs[i], null);
            }
          } else {
            result._selfTabs[i] = new InAppPurchaseData_Tab.WithParent(current.tabs[i], null);
          }
        }
      }
    }
    if (this._selfBundleDefinitions) {
      if (this._value.bundleDefinitions === current.bundleDefinitions) {
        result._selfBundleDefinitions = this._selfBundleDefinitions;
      } else {
        result._selfBundleDefinitions = [];
        for (let i = 0; i < current.bundleDefinitions.length; i++) {
          const oldValue = this._value.bundleDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfBundleDefinitions[i];
            if (oldValue === current.bundleDefinitions[i]) {
              result._selfBundleDefinitions[i] = oldCache;
            } else {
              result._selfBundleDefinitions[i] = oldCache.update(current.bundleDefinitions[i], null);
            }
          } else {
            result._selfBundleDefinitions[i] = new InAppPurchaseData_DealBundle.WithParent(current.bundleDefinitions[i], null);
          }
        }
      }
    }
    if (this._selfDealGroups) {
      if (this._value.dealGroups === current.dealGroups) {
        result._selfDealGroups = this._selfDealGroups;
      } else {
        result._selfDealGroups = [];
        for (let i = 0; i < current.dealGroups.length; i++) {
          const oldValue = this._value.dealGroups[i];
          if (oldValue) {
            const oldCache = this._selfDealGroups[i];
            if (oldValue === current.dealGroups[i]) {
              result._selfDealGroups[i] = oldCache;
            } else {
              result._selfDealGroups[i] = oldCache.update(current.dealGroups[i], null);
            }
          } else {
            result._selfDealGroups[i] = new InAppPurchaseData_DealGroup.WithParent(current.dealGroups[i], null);
          }
        }
      }
    }
    if (this._cachedSaleDefinition && this._value.hasSaleDefinition && current.hasSaleDefinition) {
      if (this._value.saleDefinition === current.saleDefinition && this._parent === parent) {
        result._cachedSaleDefinition = this._cachedSaleDefinition;
      } else {
        result._cachedSaleDefinition = this._cachedSaleDefinition.update(current.saleDefinition, parent && parent.hasSaleDefinition ? parent.saleDefinition : null);
      }
    }
    if (this._selfCampaignSaleBundles) {
      if (this._value.campaignSaleBundles === current.campaignSaleBundles) {
        result._selfCampaignSaleBundles = this._selfCampaignSaleBundles;
      } else {
        result._selfCampaignSaleBundles = [];
        for (let i = 0; i < current.campaignSaleBundles.length; i++) {
          const oldValue = this._value.campaignSaleBundles[i];
          if (oldValue) {
            const oldCache = this._selfCampaignSaleBundles[i];
            if (oldValue === current.campaignSaleBundles[i]) {
              result._selfCampaignSaleBundles[i] = oldCache;
            } else {
              result._selfCampaignSaleBundles[i] = oldCache.update(current.campaignSaleBundles[i], null);
            }
          } else {
            result._selfCampaignSaleBundles[i] = new InAppPurchaseData_CampaignSaleBundle.WithParent(current.campaignSaleBundles[i], null);
          }
        }
      }
    }
    if (this._selfDailyTrialBundles) {
      if (this._value.dailyTrialBundles === current.dailyTrialBundles) {
        result._selfDailyTrialBundles = this._selfDailyTrialBundles;
      } else {
        result._selfDailyTrialBundles = [];
        for (let i = 0; i < current.dailyTrialBundles.length; i++) {
          const oldValue = this._value.dailyTrialBundles[i];
          if (oldValue) {
            const oldCache = this._selfDailyTrialBundles[i];
            if (oldValue === current.dailyTrialBundles[i]) {
              result._selfDailyTrialBundles[i] = oldCache;
            } else {
              result._selfDailyTrialBundles[i] = oldCache.update(current.dailyTrialBundles[i], null);
            }
          } else {
            result._selfDailyTrialBundles[i] = new InAppPurchaseData_DailyTrialBundle.WithParent(current.dailyTrialBundles[i], null);
          }
        }
      }
    }
    return result;
  }
}
InAppPurchaseData_WithParent.default = new InAppPurchaseData_WithParent(InAppPurchaseData.default, null);
InAppPurchaseData.WithParent = InAppPurchaseData_WithParent;
class InAppPurchaseData_Descriptor {
  get products() {
    if (!this._products) {
      this._products = {
        name: "products",
        Name: "Products",
        number: 1,
        protoType: 11,
        protoName: "products",
        type: InAppPurchaseData_Product,
        isRepeated: true,
        options: {
          comments: "The store that sells gem specifically",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._products;
  }
  get limitedBundles() {
    if (!this._limitedBundles) {
      this._limitedBundles = {
        name: "limitedBundles",
        Name: "LimitedBundles",
        number: 2,
        protoType: 11,
        protoName: "limited_bundles",
        type: InAppPurchaseData_LimitedBundles,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._limitedBundles;
  }
  get subscriptions() {
    if (!this._subscriptions) {
      this._subscriptions = {
        name: "subscriptions",
        Name: "Subscriptions",
        number: 3,
        protoType: 11,
        protoName: "subscriptions",
        type: InAppPurchaseData_Subscription,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subscriptions;
  }
  get tabs() {
    if (!this._tabs) {
      this._tabs = {
        name: "tabs",
        Name: "Tabs",
        number: 4,
        protoType: 11,
        protoName: "tabs",
        type: InAppPurchaseData_Tab,
        isRepeated: true,
        options: {
          comments: "Tabs used to hold items/bundles",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabs;
  }
  get tabPriority() {
    if (!this._tabPriority) {
      this._tabPriority = {
        name: "tabPriority",
        Name: "TabPriority",
        number: 5,
        protoType: 9,
        protoName: "tab_priority",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "array of tab keys, determines which tab to open when open shop",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabPriority;
  }
  get bundleDefinitions() {
    if (!this._bundleDefinitions) {
      this._bundleDefinitions = {
        name: "bundleDefinitions",
        Name: "BundleDefinitions",
        number: 7,
        protoType: 11,
        protoName: "bundle_definitions",
        type: InAppPurchaseData_DealBundle,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleDefinitions;
  }
  get dealGroups() {
    if (!this._dealGroups) {
      this._dealGroups = {
        name: "dealGroups",
        Name: "DealGroups",
        number: 6,
        protoType: 11,
        protoName: "deal_groups",
        type: InAppPurchaseData_DealGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dealGroups;
  }
  get saleDefinition() {
    if (!this._saleDefinition) {
      this._saleDefinition = {
        name: "saleDefinition",
        Name: "SaleDefinition",
        number: 8,
        protoType: 11,
        protoName: "sale_definition",
        type: InAppPurchaseData_SaleBundleDefinition,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._saleDefinition;
  }
  get campaignSaleBundles() {
    if (!this._campaignSaleBundles) {
      this._campaignSaleBundles = {
        name: "campaignSaleBundles",
        Name: "CampaignSaleBundles",
        number: 9,
        protoType: 11,
        protoName: "campaign_sale_bundles",
        type: InAppPurchaseData_CampaignSaleBundle,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignSaleBundles;
  }
  get dailyTrialBundles() {
    if (!this._dailyTrialBundles) {
      this._dailyTrialBundles = {
        name: "dailyTrialBundles",
        Name: "DailyTrialBundles",
        number: 10,
        protoType: 11,
        protoName: "daily_trial_bundles",
        type: InAppPurchaseData_DailyTrialBundle,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyTrialBundles;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.products,
        this.limitedBundles,
        this.subscriptions,
        this.tabs,
        this.tabPriority,
        this.bundleDefinitions,
        this.dealGroups,
        this.saleDefinition,
        this.campaignSaleBundles,
        this.dailyTrialBundles,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSaleDefinition",
        Name: "DummyOneofForSaleDefinition",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
InAppPurchaseData.descriptor = new InAppPurchaseData_Descriptor();
